/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type AggregatorCompany = Company & {
  /** Ссылка на отчет с транзакциями */
  accountantDashboardReportUrl: Scalars['String'];
  /** Дополнительная информация */
  additional: CompanyAdditional;
  /** Пользователь API */
  apiUser?: Maybe<ApiUser>;
  /** Пользователи API */
  apiUsers: ApiUsersQuery;
  /** B2B */
  b2b: Scalars['Boolean'];
  /** Бренд */
  brand?: Maybe<Scalars['String']>;
  /** Контакт бухгалтера */
  buh: CompanyContact;
  /** Автомобиль */
  car?: Maybe<Car>;
  /** Бизнес-карты */
  cards?: Maybe<Cards>;
  cars: Cars;
  /** Тип компании */
  companyType?: Maybe<Scalars['String']>;
  /** Контактное лицо */
  contact?: Maybe<Scalars['String']>;
  /** Контракт */
  contract?: Maybe<Contract>;
  /** Контракты компании */
  contracts: Array<Contract>;
  /** Отделы/подотделы */
  departments: Array<Department>;
  /** Контактное лицо */
  director?: Maybe<Scalars['String']>;
  /** Ссылка на отчет с транзакциями */
  downloadStatementsReceiptsReport: Scalars['String'];
  /** Водитель */
  driver?: Maybe<Driver>;
  /** Водители */
  drivers: Drivers;
  /** Контактный Email */
  email?: Maybe<Scalars['String']>;
  getBalanceReportLink?: Maybe<Scalars['String']>;
  getCompanyStationsByConstraints: Stations;
  getConstraintsByAZS: ConstraintsAzsItems;
  getConstraintsByContracts: ConstraintsContracts;
  getStationsByCompany: Stations;
  id: Scalars['ID'];
  /** ИНН */
  inn?: Maybe<Scalars['String']>;
  integrationsReportLink?: Maybe<Scalars['String']>;
  /** КПП */
  kpp?: Maybe<Scalars['String']>;
  /** Лимиты */
  limits: Limits;
  /** Логи */
  logs: Logs;
  /** Режим отображения */
  mode: OrganizationMode;
  monthlyReportLink: Scalars['String'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Отправленные сообщения */
  notifications: Notifications;
  /** Официальный адрес */
  officialAddress?: Maybe<Scalars['String']>;
  /** ОГРН (ОГРНИП) */
  ogrn?: Maybe<Scalars['String']>;
  /** Детали заказа компании */
  orderDetails: Array<OrderDetail>;
  /** Заказ */
  orderNew?: Maybe<Order>;
  /** Заказы */
  ordersNew: Orders;
  ordersNewReportLink?: Maybe<Scalars['String']>;
  ordersReportLink?: Maybe<Scalars['String']>;
  /** Группы/подгруппы */
  partner?: Maybe<Partner>;
  /** Группы/подгруппы */
  partners: Array<Partner>;
  /** Платежи компании */
  payments: Payments;
  /** Контактный телефон */
  phone?: Maybe<Scalars['String']>;
  /** Почтовый адрес */
  postAddress?: Maybe<Scalars['String']>;
  profitabilityReportUrl: Scalars['String'];
  /** Дата регистрации */
  registered: Scalars['DateTime'];
  /** Отчет по балансу */
  report: Array<ReportItem>;
  /** Тип отчетов */
  reportType: ReportType;
  /** Отчеты по балансу */
  reports: Array<ReportGroup>;
  /** Роль авторизованного пользователя */
  role: Scalars['String'];
  /** Взаиморасчёт */
  settlement: Array<SettlementItem>;
  /** Ссылка на скачивание взаиморасчёта с компанией по контракту */
  settlementLink: Scalars['String'];
  /** Взаиморасчёты */
  settlements: Array<SettlementsItem>;
  /** Ссылка на скачивание взаиморасчётов */
  settlementsLink: Scalars['String'];
  /** Режим отображения (простой/полный) */
  simple: Scalars['Boolean'];
  /** Источник */
  source?: Maybe<Scalars['String']>;
  /** Статистика компании агрегатора */
  stat: CompanyStat;
  /** Поиск контрактов по реквизитам плательщика */
  statementReceiptContracts: Array<StatementReceiptContract>;
  /** Шаблоны платёжных поручений */
  statementsPatterns: Array<StatementPattern>;
  /** Выписки по счёту */
  statementsReceipts: StatementsReceipts;
  /** АЗС компании */
  station?: Maybe<Station>;
  /** Станции АЗС */
  stations: Stations;
  /** Логи состояний */
  stationsStateLogsGroups?: Maybe<StationsStateLogsGroups>;
  /** Статус */
  status: CompanyStatus;
  /** Свод по видам топлива */
  summaryByFuelType: Array<SummaryByFuelTypeItem>;
  /** Ссылка на скачивание свода по видам топлива */
  summaryByFuelTypeLink: Scalars['String'];
  /** Контакт технического отдела */
  tech: CompanyContact;
  /** Шаблоны сообщений */
  templates: NotificationTemplates;
  /** Ссылка на отчет с транзакциями */
  terBankReportUrl: Scalars['String'];
  /** Тип доступа */
  type: Scalars['String'];
  /** Обновлённые станции */
  updatedStations?: Maybe<UpdatedStations>;
  /** Пользователь */
  user?: Maybe<User>;
  /** Права доступа текущего пользователя */
  userAccess?: Maybe<Array<CompanyUserAccess>>;
  /** Пользователи */
  users: UsersQuery;
  /** Признак верификации компании */
  verified: Scalars['Boolean'];
  /** Путевой лист */
  waybill: Waybill;
  /** Путевые листы */
  waybills: Waybills;
};


export type AggregatorCompanyAccountantDashboardReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanyApiUserArgs = {
  phone: Scalars['String'];
};


export type AggregatorCompanyApiUsersArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type AggregatorCompanyCarArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyCarsArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type AggregatorCompanyContractsArgs = {
  contractsSubtype?: InputMaybe<Array<ContractSubtype>>;
  contractsType?: InputMaybe<ContractType>;
};


export type AggregatorCompanyDriverArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type AggregatorCompanyDriversArgs = {
  page?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: RecordState;
  status?: InputMaybe<DriverStatus>;
};


export type AggregatorCompanyGetBalanceReportLinkArgs = {
  month: Scalars['String'];
};


export type AggregatorCompanyGetCompanyStationsByConstraintsArgs = {
  filter: QueryParams;
};


export type AggregatorCompanyGetConstraintsByAzsArgs = {
  filter: QueryParams;
};


export type AggregatorCompanyGetConstraintsByContractsArgs = {
  filter: ConstraintsContractsQueryParams;
};


export type AggregatorCompanyGetStationsByCompanyArgs = {
  filter?: InputMaybe<QueryParams>;
};


export type AggregatorCompanyLimitsArgs = {
  filter: LimitsQueryParams;
};


export type AggregatorCompanyLogsArgs = {
  filter: LogsQueryParams;
};


export type AggregatorCompanyMonthlyReportLinkArgs = {
  month: Scalars['String'];
};


export type AggregatorCompanyNotificationsArgs = {
  filter: NotificationsQueryParams;
};


export type AggregatorCompanyOrderDetailsArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyOrderNewArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyOrdersNewArgs = {
  filter: OrdersQueryParams;
};


export type AggregatorCompanyOrdersNewReportLinkArgs = {
  filter: OrdersQueryParams;
  format?: ReportFormat;
};


export type AggregatorCompanyOrdersReportLinkArgs = {
  format?: ReportFormat;
  from: Scalars['DateTime'];
  stationId?: InputMaybe<Scalars['ID']>;
  status?: ReportStatusFilter;
  to: Scalars['DateTime'];
};


export type AggregatorCompanyPartnersArgs = {
  state?: RecordState;
};


export type AggregatorCompanyProfitabilityReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanyReportArgs = {
  month: Scalars['ID'];
};


export type AggregatorCompanySettlementArgs = {
  contractId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanySettlementLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanySettlementsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanySettlementsLinkArgs = {
  companyType?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  reportType: SettlementsReportType;
  to: Scalars['String'];
};


export type AggregatorCompanyStatementReceiptContractsArgs = {
  statementReceiptId: Scalars['ID'];
};


export type AggregatorCompanyStatementsReceiptsArgs = {
  filter: StatementsReceiptsQueryParams;
};


export type AggregatorCompanyStationArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyStationsArgs = {
  contractsType?: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  page?: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Array<StationState>>;
  status?: InputMaybe<StationStatus>;
};


export type AggregatorCompanyStationsStateLogsGroupsArgs = {
  filter: QueryParams;
};


export type AggregatorCompanySummaryByFuelTypeArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanySummaryByFuelTypeLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanyTemplatesArgs = {
  filter: NotificationsTemplatesQueryParams;
};


export type AggregatorCompanyTerBankReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanyUpdatedStationsArgs = {
  filter: QueryParams;
};


export type AggregatorCompanyUserArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyUsersArgs = {
  filter?: UsersQueryParams;
  query?: InputMaybe<Scalars['String']>;
};


export type AggregatorCompanyWaybillArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyWaybillsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
};

/** API пользователь приложения */
export type ApiUser = User & {
  /** Записи водителя текущего пользователя */
  drivers: Array<Driver>;
  /** Email пользователя */
  email?: Maybe<Scalars['String']>;
  /** Признак наличия SberId */
  hasSberLoyalty?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  /** Дата последней активности пользователя */
  lastActivity?: Maybe<Scalars['DateTime']>;
  phone?: Maybe<Scalars['String']>;
  /** Дата регистрации пользователя */
  registered?: Maybe<Scalars['DateTime']>;
  /** Баланс СберСпасибо */
  sberLoyaltyBalance?: Maybe<Scalars['Float']>;
  /** Дата регистрации в СберId */
  sberLoyaltyRegistrationDate?: Maybe<Scalars['DateTime']>;
  /** Информация о приложении пользователя (json) */
  version?: Maybe<AppVersion>;
};

/** Выборка заказов */
export type ApiUsersQuery = {
  /** Количество пользователей */
  count: Scalars['Int'];
  /** Список пользователей */
  items: Array<User>;
};

/** Пользователь приложения */
export type AppUser = User & {
  id?: Maybe<Scalars['ID']>;
  phone?: Maybe<Scalars['String']>;
};

/** Информация о приложении пользователя */
export type AppVersion = {
  /** Тип приложения */
  appType?: Maybe<Scalars['String']>;
  /** Версия приложения */
  appVersion?: Maybe<Scalars['String']>;
  /** Данные об ОС */
  os?: Maybe<Scalars['String']>;
  /** Версия ОС */
  osVersion?: Maybe<Scalars['String']>;
};

export type AzsCompany = Company & {
  /** Ссылка на отчет с транзакциями */
  accountantDashboardReportUrl: Scalars['String'];
  /** Дополнительная информация */
  additional: CompanyAdditional;
  /** Пользователь API */
  apiUser?: Maybe<ApiUser>;
  /** Пользователи API */
  apiUsers: ApiUsersQuery;
  /** B2B */
  b2b: Scalars['Boolean'];
  /** Бренд */
  brand?: Maybe<Scalars['String']>;
  /** Контакт бухгалтера */
  buh: CompanyContact;
  /** Автомобиль */
  car?: Maybe<Car>;
  /** Бизнес-карты */
  cards?: Maybe<Cards>;
  cars: Cars;
  /** Тип компании */
  companyType?: Maybe<Scalars['String']>;
  /** Контактное лицо */
  contact?: Maybe<Scalars['String']>;
  /** Контракт */
  contract?: Maybe<Contract>;
  /** Контракты компании */
  contracts: Array<Contract>;
  /** Отделы/подотделы */
  departments: Array<Department>;
  /** Контактное лицо */
  director?: Maybe<Scalars['String']>;
  /** Ссылка на отчет с транзакциями */
  downloadStatementsReceiptsReport: Scalars['String'];
  /** Водитель */
  driver?: Maybe<Driver>;
  /** Водители */
  drivers: Drivers;
  /** Контактный Email */
  email?: Maybe<Scalars['String']>;
  getBalanceReportLink?: Maybe<Scalars['String']>;
  getCompanyStationsByConstraints: Stations;
  getConstraintsByAZS: ConstraintsAzsItems;
  getConstraintsByContracts: ConstraintsContracts;
  getStationsByCompany: Stations;
  id: Scalars['ID'];
  /** ИНН */
  inn?: Maybe<Scalars['String']>;
  integrationsReportLink?: Maybe<Scalars['String']>;
  /** КПП */
  kpp?: Maybe<Scalars['String']>;
  /** Лимиты */
  limits: Limits;
  /** Логи */
  logs: Logs;
  /** Режим отображения */
  mode: OrganizationMode;
  monthlyReportLink: Scalars['String'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Отправленные сообщения */
  notifications: Notifications;
  /** Официальный адрес */
  officialAddress?: Maybe<Scalars['String']>;
  /** Список оффлайн сетей АЗС организации */
  offlinePartners?: Maybe<Array<PartnerOffline>>;
  /** ОГРН (ОГРНИП) */
  ogrn?: Maybe<Scalars['String']>;
  /** Детали заказа компании */
  orderDetails: Array<OrderDetail>;
  /** Заказ */
  orderNew?: Maybe<Order>;
  /** Заказы */
  ordersNew: Orders;
  ordersNewReportLink?: Maybe<Scalars['String']>;
  ordersReportLink?: Maybe<Scalars['String']>;
  /** Группы/подгруппы */
  partner?: Maybe<Partner>;
  /** Группы/подгруппы */
  partners: Array<Partner>;
  /** Платежи компании */
  payments: Payments;
  /** Контактный телефон */
  phone?: Maybe<Scalars['String']>;
  /** Почтовый адрес */
  postAddress?: Maybe<Scalars['String']>;
  /** Продуктовый каталог партнера */
  productCatalog?: Maybe<Array<PartnerProductGroup>>;
  profitabilityReportUrl: Scalars['String'];
  /** Дата регистрации */
  registered: Scalars['DateTime'];
  /** Отчет по балансу */
  report: Array<ReportItem>;
  /** Тип отчетов */
  reportType: ReportType;
  /** Отчеты по балансу */
  reports: Array<ReportGroup>;
  /** Роль авторизованного пользователя */
  role: Scalars['String'];
  /** Настройки партнера */
  settings?: Maybe<PartnerSettings>;
  /** Взаиморасчёт */
  settlement: Array<SettlementItem>;
  /** Ссылка на скачивание взаиморасчёта с компанией по контракту */
  settlementLink: Scalars['String'];
  /** Взаиморасчёты */
  settlements: Array<SettlementsItem>;
  /** Ссылка на скачивание взаиморасчётов */
  settlementsLink: Scalars['String'];
  /** Режим отображения (простой/полный) */
  simple: Scalars['Boolean'];
  /** Источник */
  source?: Maybe<Scalars['String']>;
  /** Статистика АЗС */
  stat: AzsStat;
  /** Поиск контрактов по реквизитам плательщика */
  statementReceiptContracts: Array<StatementReceiptContract>;
  /** Шаблоны платёжных поручений */
  statementsPatterns: Array<StatementPattern>;
  /** Выписки по счёту */
  statementsReceipts: StatementsReceipts;
  /** АЗС компании */
  station?: Maybe<Station>;
  /** АСУ АЗС */
  stationPartner?: Maybe<StationPartner>;
  /** Топливо АЗС */
  stationPartnerFuels?: Maybe<Array<StationPartnerFuel>>;
  /** Станции АЗС */
  stations: Stations;
  /** Логи состояний */
  stationsStateLogsGroups?: Maybe<StationsStateLogsGroups>;
  /** Статистика по статусам АЗС */
  stationsStatuses: Array<StationsStatus>;
  /** Статус */
  status: CompanyStatus;
  /** Свод по видам топлива */
  summaryByFuelType: Array<SummaryByFuelTypeItem>;
  /** Ссылка на скачивание свода по видам топлива */
  summaryByFuelTypeLink: Scalars['String'];
  /** Контакт технического отдела */
  tech: CompanyContact;
  /** Шаблоны сообщений */
  templates: NotificationTemplates;
  /** Ссылка на отчет с транзакциями */
  terBankReportUrl: Scalars['String'];
  /** Тип доступа */
  type: Scalars['String'];
  /** Обновлённые станции */
  updatedStations?: Maybe<UpdatedStations>;
  /** Пользователь */
  user?: Maybe<User>;
  /** Права доступа текущего пользователя */
  userAccess?: Maybe<Array<CompanyUserAccess>>;
  /** Пользователи */
  users: UsersQuery;
  /** Признак верификации компании */
  verified: Scalars['Boolean'];
  /** Путевой лист */
  waybill: Waybill;
  /** Путевые листы */
  waybills: Waybills;
};


export type AzsCompanyAccountantDashboardReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanyApiUserArgs = {
  phone: Scalars['String'];
};


export type AzsCompanyApiUsersArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type AzsCompanyCarArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyCarsArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type AzsCompanyContractsArgs = {
  contractsSubtype?: InputMaybe<Array<ContractSubtype>>;
  contractsType?: InputMaybe<ContractType>;
};


export type AzsCompanyDriverArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type AzsCompanyDriversArgs = {
  page?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: RecordState;
  status?: InputMaybe<DriverStatus>;
};


export type AzsCompanyGetBalanceReportLinkArgs = {
  month: Scalars['String'];
};


export type AzsCompanyGetCompanyStationsByConstraintsArgs = {
  filter: QueryParams;
};


export type AzsCompanyGetConstraintsByAzsArgs = {
  filter: QueryParams;
};


export type AzsCompanyGetConstraintsByContractsArgs = {
  filter: ConstraintsContractsQueryParams;
};


export type AzsCompanyGetStationsByCompanyArgs = {
  filter?: InputMaybe<QueryParams>;
};


export type AzsCompanyLimitsArgs = {
  filter: LimitsQueryParams;
};


export type AzsCompanyLogsArgs = {
  filter: LogsQueryParams;
};


export type AzsCompanyMonthlyReportLinkArgs = {
  month: Scalars['String'];
};


export type AzsCompanyNotificationsArgs = {
  filter: NotificationsQueryParams;
};


export type AzsCompanyOrderDetailsArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyOrderNewArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyOrdersNewArgs = {
  filter: OrdersQueryParams;
};


export type AzsCompanyOrdersNewReportLinkArgs = {
  filter: OrdersQueryParams;
  format?: ReportFormat;
};


export type AzsCompanyOrdersReportLinkArgs = {
  format?: ReportFormat;
  from: Scalars['DateTime'];
  stationId?: InputMaybe<Scalars['ID']>;
  status?: ReportStatusFilter;
  to: Scalars['DateTime'];
};


export type AzsCompanyPartnersArgs = {
  state?: RecordState;
};


export type AzsCompanyProductCatalogArgs = {
  partnerId: Scalars['ID'];
};


export type AzsCompanyProfitabilityReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanyReportArgs = {
  month: Scalars['ID'];
};


export type AzsCompanySettingsArgs = {
  partnerId: Scalars['ID'];
};


export type AzsCompanySettlementArgs = {
  contractId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanySettlementLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanySettlementsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanySettlementsLinkArgs = {
  companyType?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  reportType: SettlementsReportType;
  to: Scalars['String'];
};


export type AzsCompanyStatementReceiptContractsArgs = {
  statementReceiptId: Scalars['ID'];
};


export type AzsCompanyStatementsReceiptsArgs = {
  filter: StatementsReceiptsQueryParams;
};


export type AzsCompanyStationArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyStationsArgs = {
  contractsType?: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  page?: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Array<StationState>>;
  status?: InputMaybe<StationStatus>;
};


export type AzsCompanyStationsStateLogsGroupsArgs = {
  filter: QueryParams;
};


export type AzsCompanySummaryByFuelTypeArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanySummaryByFuelTypeLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanyTemplatesArgs = {
  filter: NotificationsTemplatesQueryParams;
};


export type AzsCompanyTerBankReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanyUpdatedStationsArgs = {
  filter: QueryParams;
};


export type AzsCompanyUserArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyUsersArgs = {
  filter?: UsersQueryParams;
  query?: InputMaybe<Scalars['String']>;
};


export type AzsCompanyWaybillArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyWaybillsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
};

/** Статистика по АЗС */
export type AzsStat = {
  active: Scalars['Int'];
  all: Scalars['Int'];
  online: Scalars['Int'];
};

/** История изменения баланса водителя */
export type BalanceHistory = {
  count: Scalars['Int'];
  items: Array<BalanceHistoryEntry>;
};

/** Запись из истории изменения баланса водителя */
export type BalanceHistoryEntry = {
  date: Scalars['DateTime'];
  total: Scalars['Float'];
};

/** Информация для массового обновления информации на АЗС */
export type BulkEditStationsData = {
  /** Вкл/выкл станцию */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Цвет АЗС */
  color?: InputMaybe<Scalars['String']>;
  /** Режим пистолета */
  mode?: InputMaybe<StationMode>;
  /** Информация об АЗС */
  promo?: InputMaybe<Scalars['String']>;
};

/** Кабинет пользователя */
export type Cabinet = {
  /** Список компаний пользователя */
  companies: Array<Company>;
  /** Компания по идентификатору */
  company?: Maybe<Company>;
  email?: Maybe<Scalars['String']>;
  findCompanies: Companies;
  /** Признак активности привязки СберБизнесId */
  isSberBusinessIdLinked?: Maybe<Scalars['Boolean']>;
  me?: Maybe<LkUser>;
  phone?: Maybe<Scalars['String']>;
  serverAsu: Array<Scalars['String']>;
  stationGroups: Array<StationsGroup>;
  stationsGroup?: Maybe<StationsGroup>;
  stationsGroups: StationsGroups;
};


/** Кабинет пользователя */
export type CabinetCompanyArgs = {
  cardOwnerId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
};


/** Кабинет пользователя */
export type CabinetFindCompaniesArgs = {
  filter?: InputMaybe<CompaniesFilterParams>;
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};


/** Кабинет пользователя */
export type CabinetStationGroupsArgs = {
  companyId: Scalars['ID'];
};


/** Кабинет пользователя */
export type CabinetStationsGroupArgs = {
  id: Scalars['ID'];
};


/** Кабинет пользователя */
export type CabinetStationsGroupsArgs = {
  filter: StationsGroupQueryParams;
};

export type Car = {
  description?: Maybe<Scalars['String']>;
  /** Водители автомобиля */
  drivers: Array<Driver>;
  /** Признак наличия транзакций у автомобиля */
  hasTransactions: Scalars['Boolean'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  /** Водители автомобиля */
  partnerDrivers: Array<CarPartnerDriver>;
  /** Отделы (подразделения) */
  partners: Array<Partner>;
  region: Scalars['String'];
  sts?: Maybe<Scalars['String']>;
};

/** Данные для добавления автомобиля */
export type CarData = {
  /** Описание */
  description?: InputMaybe<Scalars['String']>;
  /** Имя */
  name?: InputMaybe<Scalars['String']>;
  /** Номер автомобиля */
  number: Scalars['String'];
  /** Регион автомобиля */
  region: Scalars['Int'];
  state?: RecordState;
  /** sts (на будущее) */
  sts?: InputMaybe<Scalars['Int']>;
};

/** Информация о водителях в отделе автомобиля */
export type CarPartnerDriver = {
  /** ФИО водителя автомобиля */
  driverId?: Maybe<Scalars['String']>;
  /** ФИО водителя автомобиля */
  driverName?: Maybe<Scalars['String']>;
  /** ID родительского отдела */
  parentPartnerId?: Maybe<Scalars['String']>;
  /** Название родительского отдела */
  parentPartnerName?: Maybe<Scalars['String']>;
  /** ID отдела */
  partnerId: Scalars['String'];
  /** Название отдела */
  partnerName: Scalars['String'];
};

/** Данные для редактирования автомобиля */
export type CarSaveData = {
  /** Описание */
  description?: InputMaybe<Scalars['String']>;
  /** Имя */
  name?: InputMaybe<Scalars['String']>;
  /** Номер автомобиля */
  number?: InputMaybe<Scalars['String']>;
  /** Водители */
  partnerDriverId?: InputMaybe<Array<Scalars['String']>>;
  /** Отделы (подразделения) */
  partnerId?: InputMaybe<Array<Scalars['String']>>;
  /** Регион автомобиля */
  region?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<RecordState>;
  /** sts (на будущее) */
  sts?: InputMaybe<Scalars['Int']>;
};

/** Бизнес-карта */
export type Card = {
  /** Баланс */
  balance: Array<CardBalance>;
  /** Пользовательское название карты */
  label: Scalars['String'];
  /** Лимиты */
  limits: Array<CardTemplate>;
  /** Лимиты */
  limitsShort: Scalars['String'];
  /** Последние 4 цифры карты */
  number: Scalars['String'];
  /** Тип карты (visa/master/mir) */
  psp: Scalars['Float'];
  /** Признак активности карты (вкл/выкл) */
  status: Scalars['Boolean'];
  /** ID карты */
  token: Scalars['String'];
};

/** Шаблон ограничений бизнес-карты */
export type CardBalance = {
  groupCafe: CardBalanceRestrictions;
  groupGoods: CardBalanceRestrictions;
  groupPetroleum: CardBalanceRestrictions;
  groupServices: CardBalanceRestrictions;
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Единичное ограничение бизнес-карты */
export type CardBalanceRestriction = {
  allowed: Scalars['Boolean'];
  balanceQuantity?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  period?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
  usedQuantity: Scalars['Float'];
};

/** Лимиты бизнес-карты */
export type CardBalanceRestrictions = {
  balanceQuantity: Scalars['Float'];
  groupRestriction: CardTemplateGroupRestrictions;
  restrictions: Array<CardBalanceRestriction>;
  usedQuantity: Scalars['Float'];
};

/** Виды топлива бизнес-карт */
export type CardFuel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Данные лимитов ограничений бизнес-карты */
export type CardLimitsData = {
  groupCafe: CardTemplateRestrictionsData;
  groupGoods: CardTemplateRestrictionsData;
  groupPetroleum: CardTemplateRestrictionsData;
  groupServices: CardTemplateRestrictionsData;
  id: Scalars['String'];
  name: Scalars['String'];
  nets: Array<Scalars['String']>;
  regions: Array<Scalars['String']>;
};

/** Сети АЗС бизнес-карт */
export type CardNet = {
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Информация о владельце карты */
export type CardOwner = Order & {
  /** Компания-покупатель */
  corp?: Maybe<OrderCorp>;
  /** Дата начала заказа */
  date: Scalars['DateTime'];
  /** Дата завершения заказа */
  finished?: Maybe<Scalars['DateTime']>;
  hasOfflineOrder?: Maybe<Scalars['Boolean']>;
  hasOnlineOrder?: Maybe<Scalars['Boolean']>;
  /** Уникальный идентификатор заказа */
  id: Scalars['ID'];
  /** IP-адрес покупателя */
  ip?: Maybe<Scalars['String']>;
  /** Полное название организации владельца карты */
  name?: Maybe<Scalars['String']>;
  /** Информация о платеже */
  payment?: Maybe<OrderPayment>;
  /** Признак наличия SberId */
  sberId?: Maybe<Scalars['Boolean']>;
  /** Информация по СберСпасибо (если имеется) */
  sberSpasiboDetails?: Maybe<OrderItemSberSpasiboDetails>;
  /** Краткое название организации владельца карты */
  shortName?: Maybe<Scalars['String']>;
  /** АЗС */
  station?: Maybe<Station>;
  /** Статус заказа */
  status: Scalars['String'];
  /** Текстовая информация о статусе заказа */
  statusMessage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  /** Пользователь приложения */
  user?: Maybe<AppUser>;
};

/** Регионы бизнес-карт */
export type CardRegion = {
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Шаблон ограничений бизнес-карты */
export type CardTemplate = {
  groupCafe: CardTemplateRestrictions;
  groupGoods: CardTemplateRestrictions;
  groupPetroleum: CardTemplateRestrictions;
  groupServices: CardTemplateRestrictions;
  id: Scalars['String'];
  name: Scalars['String'];
  nets: Array<Scalars['String']>;
  regions: Array<Scalars['String']>;
};

/** Данные нового шаблона ограничений бизнес-карты */
export type CardTemplateData = {
  groupCafe: CardTemplateRestrictionsData;
  groupGoods: CardTemplateRestrictionsData;
  groupPetroleum: CardTemplateRestrictionsData;
  groupServices: CardTemplateRestrictionsData;
  name: Scalars['String'];
  nets: Array<Scalars['String']>;
  regions: Array<Scalars['String']>;
};

/** Групповое ограничение бизнес-карты */
export type CardTemplateGroupRestrictions = {
  allowed: Scalars['Boolean'];
  period?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
};

/** Групповое ограничение бизнес-карты */
export type CardTemplateGroupRestrictionsData = {
  allowed: Scalars['Boolean'];
  period?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
};

/** Единичное ограничение бизнес-карты */
export type CardTemplateRestriction = {
  allowed: Scalars['Boolean'];
  name: Scalars['String'];
  period?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
};

/** Единичное ограничение бизнес-карты */
export type CardTemplateRestrictionData = {
  allowed: Scalars['Boolean'];
  name: Scalars['String'];
  period?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
};

/** Ограничения бизнес-карты */
export type CardTemplateRestrictions = {
  groupRestriction: CardTemplateGroupRestrictions;
  restrictions: Array<CardTemplateRestriction>;
};

/** Ограничения бизнес-карты */
export type CardTemplateRestrictionsData = {
  groupRestriction: CardTemplateGroupRestrictionsData;
  restrictions: Array<CardTemplateRestrictionData>;
};

/** Бизнес-карты */
export type Cards = {
  /** Бизнес-карта */
  card: Card;
  /** Бизнес-карты */
  cards: Array<Card>;
  /** Виды топлива */
  fuels: Array<CardFuel>;
  /** Сети АЗС */
  nets: Array<CardNet>;
  /** Регионы */
  regions: Array<CardRegion>;
  /** Шаблон лимитов бизнес-карты */
  template: CardTemplate;
  /** Шаблоны лимитов бизнес-карт */
  templates: Array<CardTemplate>;
};


/** Бизнес-карты */
export type CardsCardArgs = {
  token: Scalars['String'];
};


/** Бизнес-карты */
export type CardsTemplateArgs = {
  id: Scalars['ID'];
};

/** Информация об автомобилях транспортной компании */
export type Cars = {
  /** Количество автомобилей */
  count: Scalars['Int'];
  /** Признак, что у компании есть ли хотя бы один автомобиль */
  hasAny: Scalars['Boolean'];
  /** Список автомобилей */
  items: Array<Car>;
};


/** Информация об автомобилях транспортной компании */
export type CarsCountArgs = {
  state?: RecordState;
};


/** Информация об автомобилях транспортной компании */
export type CarsHasAnyArgs = {
  state?: RecordState;
};


/** Информация об автомобилях транспортной компании */
export type CarsItemsArgs = {
  state?: RecordState;
};

/** Результат проверки платежей */
export type CheckPaymentsResult = {
  /** Зачислено */
  amount: Scalars['Int'];
  /** Количество успешных платежей */
  completed: Scalars['Int'];
};

/** Информация о цвете */
export type Color = {
  /** HEX цвета */
  color?: Maybe<Scalars['String']>;
  /** ID цвета */
  id: Scalars['ID'];
  /** Название цвета */
  name?: Maybe<Scalars['String']>;
  /** Символ цвета */
  symbol?: Maybe<Scalars['String']>;
};

/** Список компаний */
export type Companies = {
  count: Scalars['Int'];
  items: Array<Company>;
  stat: Array<CompaniesStat>;
};

export type CompaniesFilterParams = {
  contractsType?: ContractType;
  paymentType?: InputMaybe<ContractPaymentType>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CompanyStatus>;
  type?: InputMaybe<CompaniesTypeFilter>;
};

export type CompaniesStat = {
  count: Scalars['Int'];
  status: CompanyStatus;
};

export enum CompaniesTypeFilter {
  Aggregator = 'aggregator',
  Azs = 'azs',
  Corp = 'corp',
  Taxi = 'taxi',
  Tk = 'tk'
}

/** Компания */
export type Company = {
  /** Ссылка на отчет с транзакциями */
  accountantDashboardReportUrl: Scalars['String'];
  /** Дополнительная информация */
  additional: CompanyAdditional;
  /** Пользователь API */
  apiUser?: Maybe<ApiUser>;
  /** Пользователи API */
  apiUsers: ApiUsersQuery;
  /** B2B */
  b2b: Scalars['Boolean'];
  /** Бренд */
  brand?: Maybe<Scalars['String']>;
  /** Контакт бухгалтера */
  buh: CompanyContact;
  /** Автомобиль */
  car?: Maybe<Car>;
  /** Бизнес-карты */
  cards?: Maybe<Cards>;
  cars: Cars;
  /** Тип компании */
  companyType?: Maybe<Scalars['String']>;
  /** Контактное лицо */
  contact?: Maybe<Scalars['String']>;
  /** Контракт */
  contract?: Maybe<Contract>;
  /** Контракты компании */
  contracts: Array<Contract>;
  /** Отделы/подотделы */
  departments: Array<Department>;
  /** Контактное лицо */
  director?: Maybe<Scalars['String']>;
  /** Ссылка на отчет с транзакциями */
  downloadStatementsReceiptsReport: Scalars['String'];
  /** Водитель */
  driver?: Maybe<Driver>;
  /** Водители */
  drivers: Drivers;
  /** Контактный Email */
  email?: Maybe<Scalars['String']>;
  getBalanceReportLink?: Maybe<Scalars['String']>;
  getCompanyStationsByConstraints: Stations;
  getConstraintsByAZS: ConstraintsAzsItems;
  getConstraintsByContracts: ConstraintsContracts;
  getStationsByCompany: Stations;
  id: Scalars['ID'];
  /** ИНН */
  inn?: Maybe<Scalars['String']>;
  integrationsReportLink?: Maybe<Scalars['String']>;
  /** КПП */
  kpp?: Maybe<Scalars['String']>;
  /** Лимиты */
  limits: Limits;
  /** Логи */
  logs: Logs;
  /** Режим отображения */
  mode: OrganizationMode;
  monthlyReportLink: Scalars['String'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Отправленные сообщения */
  notifications: Notifications;
  /** Официальный адрес */
  officialAddress?: Maybe<Scalars['String']>;
  /** ОГРН (ОГРНИП) */
  ogrn?: Maybe<Scalars['String']>;
  /** Детали заказа компании */
  orderDetails: Array<OrderDetail>;
  /** Заказ */
  orderNew?: Maybe<Order>;
  /** Заказы */
  ordersNew: Orders;
  ordersNewReportLink?: Maybe<Scalars['String']>;
  ordersReportLink?: Maybe<Scalars['String']>;
  /** Группы/подгруппы */
  partner?: Maybe<Partner>;
  /** Группы/подгруппы */
  partners: Array<Partner>;
  /** Платежи компании */
  payments: Payments;
  /** Контактный телефон */
  phone?: Maybe<Scalars['String']>;
  /** Почтовый адрес */
  postAddress?: Maybe<Scalars['String']>;
  profitabilityReportUrl: Scalars['String'];
  /** Дата регистрации */
  registered: Scalars['DateTime'];
  /** Отчет по балансу */
  report: Array<ReportItem>;
  /** Тип отчетов */
  reportType: ReportType;
  /** Отчеты по балансу */
  reports: Array<ReportGroup>;
  /** Роль авторизованного пользователя */
  role: Scalars['String'];
  /** Взаиморасчёт */
  settlement: Array<SettlementItem>;
  /** Ссылка на скачивание взаиморасчёта с компанией по контракту */
  settlementLink: Scalars['String'];
  /** Взаиморасчёты */
  settlements: Array<SettlementsItem>;
  /** Ссылка на скачивание взаиморасчётов */
  settlementsLink: Scalars['String'];
  /** Режим отображения (простой/полный) */
  simple: Scalars['Boolean'];
  /** Источник */
  source?: Maybe<Scalars['String']>;
  /** Поиск контрактов по реквизитам плательщика */
  statementReceiptContracts: Array<StatementReceiptContract>;
  /** Шаблоны платёжных поручений */
  statementsPatterns: Array<StatementPattern>;
  /** Выписки по счёту */
  statementsReceipts: StatementsReceipts;
  /** АЗС компании */
  station?: Maybe<Station>;
  /** Станции АЗС */
  stations: Stations;
  /** Логи состояний */
  stationsStateLogsGroups?: Maybe<StationsStateLogsGroups>;
  /** Статус */
  status: CompanyStatus;
  /** Свод по видам топлива */
  summaryByFuelType: Array<SummaryByFuelTypeItem>;
  /** Ссылка на скачивание свода по видам топлива */
  summaryByFuelTypeLink: Scalars['String'];
  /** Контакт технического отдела */
  tech: CompanyContact;
  /** Шаблоны сообщений */
  templates: NotificationTemplates;
  /** Ссылка на отчет с транзакциями */
  terBankReportUrl: Scalars['String'];
  /** Тип доступа */
  type: Scalars['String'];
  /** Обновлённые станции */
  updatedStations?: Maybe<UpdatedStations>;
  /** Пользователь */
  user?: Maybe<User>;
  /** Права доступа текущего пользователя */
  userAccess?: Maybe<Array<CompanyUserAccess>>;
  /** Пользователи */
  users: UsersQuery;
  /** Признак верификации компании */
  verified: Scalars['Boolean'];
  /** Путевой лист */
  waybill: Waybill;
  /** Путевые листы */
  waybills: Waybills;
};


/** Компания */
export type CompanyAccountantDashboardReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** Компания */
export type CompanyApiUserArgs = {
  phone: Scalars['String'];
};


/** Компания */
export type CompanyApiUsersArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


/** Компания */
export type CompanyCarArgs = {
  id: Scalars['ID'];
};


/** Компания */
export type CompanyCarsArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


/** Компания */
export type CompanyContractsArgs = {
  contractsSubtype?: InputMaybe<Array<ContractSubtype>>;
  contractsType?: InputMaybe<ContractType>;
};


/** Компания */
export type CompanyDriverArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


/** Компания */
export type CompanyDriversArgs = {
  page?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: RecordState;
  status?: InputMaybe<DriverStatus>;
};


/** Компания */
export type CompanyGetBalanceReportLinkArgs = {
  month: Scalars['String'];
};


/** Компания */
export type CompanyGetCompanyStationsByConstraintsArgs = {
  filter: QueryParams;
};


/** Компания */
export type CompanyGetConstraintsByAzsArgs = {
  filter: QueryParams;
};


/** Компания */
export type CompanyGetConstraintsByContractsArgs = {
  filter: ConstraintsContractsQueryParams;
};


/** Компания */
export type CompanyGetStationsByCompanyArgs = {
  filter?: InputMaybe<QueryParams>;
};


/** Компания */
export type CompanyLimitsArgs = {
  filter: LimitsQueryParams;
};


/** Компания */
export type CompanyLogsArgs = {
  filter: LogsQueryParams;
};


/** Компания */
export type CompanyMonthlyReportLinkArgs = {
  month: Scalars['String'];
};


/** Компания */
export type CompanyNotificationsArgs = {
  filter: NotificationsQueryParams;
};


/** Компания */
export type CompanyOrderDetailsArgs = {
  id: Scalars['ID'];
};


/** Компания */
export type CompanyOrderNewArgs = {
  id: Scalars['ID'];
};


/** Компания */
export type CompanyOrdersNewArgs = {
  filter: OrdersQueryParams;
};


/** Компания */
export type CompanyOrdersNewReportLinkArgs = {
  filter: OrdersQueryParams;
  format?: ReportFormat;
};


/** Компания */
export type CompanyOrdersReportLinkArgs = {
  format?: ReportFormat;
  from: Scalars['DateTime'];
  stationId?: InputMaybe<Scalars['ID']>;
  status?: ReportStatusFilter;
  to: Scalars['DateTime'];
};


/** Компания */
export type CompanyPartnersArgs = {
  state?: RecordState;
};


/** Компания */
export type CompanyProfitabilityReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** Компания */
export type CompanyReportArgs = {
  month: Scalars['ID'];
};


/** Компания */
export type CompanySettlementArgs = {
  contractId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
};


/** Компания */
export type CompanySettlementLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** Компания */
export type CompanySettlementsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** Компания */
export type CompanySettlementsLinkArgs = {
  companyType?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  reportType: SettlementsReportType;
  to: Scalars['String'];
};


/** Компания */
export type CompanyStatementReceiptContractsArgs = {
  statementReceiptId: Scalars['ID'];
};


/** Компания */
export type CompanyStatementsReceiptsArgs = {
  filter: StatementsReceiptsQueryParams;
};


/** Компания */
export type CompanyStationArgs = {
  id: Scalars['ID'];
};


/** Компания */
export type CompanyStationsArgs = {
  contractsType?: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  page?: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Array<StationState>>;
  status?: InputMaybe<StationStatus>;
};


/** Компания */
export type CompanyStationsStateLogsGroupsArgs = {
  filter: QueryParams;
};


/** Компания */
export type CompanySummaryByFuelTypeArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** Компания */
export type CompanySummaryByFuelTypeLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** Компания */
export type CompanyTemplatesArgs = {
  filter: NotificationsTemplatesQueryParams;
};


/** Компания */
export type CompanyTerBankReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** Компания */
export type CompanyUpdatedStationsArgs = {
  filter: QueryParams;
};


/** Компания */
export type CompanyUserArgs = {
  id: Scalars['ID'];
};


/** Компания */
export type CompanyUsersArgs = {
  filter?: UsersQueryParams;
  query?: InputMaybe<Scalars['String']>;
};


/** Компания */
export type CompanyWaybillArgs = {
  id: Scalars['ID'];
};


/** Компания */
export type CompanyWaybillsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
};

/** Дополнительная информация */
export type CompanyAdditional = {
  /** Комментарий */
  commentary?: Maybe<Scalars['String']>;
};

export type CompanyAdditionalData = {
  commentary?: InputMaybe<Scalars['String']>;
};

/** Контакт */
export type CompanyContact = {
  /** Email */
  email?: Maybe<Scalars['String']>;
  /** Имя */
  name?: Maybe<Scalars['String']>;
  /** Телефон */
  phone?: Maybe<Scalars['String']>;
};

/** Контактное лицо */
export type CompanyContactData = {
  /** Email */
  email?: InputMaybe<Scalars['String']>;
  /** Имя */
  name?: InputMaybe<Scalars['String']>;
  /** Телефон */
  phone?: InputMaybe<Scalars['String']>;
};

export type CompanyData = {
  /** Дополнительная информация */
  additional?: InputMaybe<CompanyAdditionalData>;
  /** Бренд */
  brand?: InputMaybe<Scalars['String']>;
  /** Контакт бухгалтера */
  buh?: InputMaybe<CompanyContactData>;
  /** Тип компании */
  companyType?: InputMaybe<Scalars['String']>;
  /** Контактное лицо */
  contact?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<ContractData>;
  /** Контактное лицо */
  director?: InputMaybe<Scalars['String']>;
  /** Контакнтный Email */
  email?: InputMaybe<Scalars['String']>;
  /** ИНН */
  inn?: InputMaybe<Scalars['String']>;
  /** КПП */
  kpp?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  officialAddress?: InputMaybe<Scalars['String']>;
  /** ОГРН (ОГРНИП) */
  ogrn?: InputMaybe<Scalars['String']>;
  /** Контактный телефон */
  phone?: InputMaybe<Scalars['String']>;
  /** Почтовый адрес */
  postAddress?: InputMaybe<Scalars['String']>;
  /** Каталог товаров офлайн компании */
  productCatalog?: InputMaybe<Array<PartnerProductGroupData>>;
  /** Тип отчетов */
  reportType?: InputMaybe<ReportType>;
  /** Настройки офлайн компании */
  settings?: InputMaybe<PartnerSettingsData>;
  /** Источник */
  source?: InputMaybe<Scalars['String']>;
  /** Данные об партнёре (только для АЗС) */
  stationPartner?: InputMaybe<StationPartnerData>;
  /** Данные о топливе (только для АЗС) */
  stationPartnerFuels?: InputMaybe<Array<StationPartnerFuelData>>;
  /** Статус */
  status?: InputMaybe<CompanyStatus>;
  /** Контакт технического отдела */
  tech?: InputMaybe<CompanyContactData>;
  /** Тип компании */
  type?: InputMaybe<Scalars['String']>;
};

/** Статистика по компании */
export type CompanyStat = {
  activeDriversCount: Scalars['Int'];
  allDepartmentsCount: Scalars['Int'];
  departmentsCount: Scalars['Int'];
  driversCount: Scalars['Int'];
};

export enum CompanyStatus {
  Awaiting = 'AWAITING',
  Off = 'OFF',
  On = 'ON'
}

/** Права доступа пользователя внутри компании */
export type CompanyUserAccess = {
  /** Название отдела */
  name: Scalars['String'];
  /** Идентификатор отдела */
  partnerId: Scalars['String'];
  /** Идентификатор родительского отдела */
  partnerParentId?: Maybe<Scalars['String']>;
  /** Роль */
  role: Scalars['String'];
};

export type ConstraintsAzs = {
  address?: Maybe<Scalars['String']>;
  corpName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  taxiPartnerId: Scalars['String'];
};

export type ConstraintsAzsItems = {
  count: Scalars['Int'];
  items: Array<ConstraintsAzs>;
};

export type ConstraintsContract = {
  allow: Scalars['Boolean'];
  azsContract: ContractInfo;
  contract: ContractInfo;
  corpId: Scalars['ID'];
  id: Scalars['ID'];
  officialName?: Maybe<Scalars['String']>;
};

export type ConstraintsContractTemplate = {
  allow: Scalars['Boolean'];
  azsBusinessType?: Maybe<Scalars['String']>;
  azsContract: Scalars['ID'];
  azsNumber?: Maybe<Scalars['String']>;
  contractBusinessType?: Maybe<Scalars['String']>;
  contractCorpClientId?: Maybe<Scalars['ID']>;
  contractNumber?: Maybe<Scalars['String']>;
  corpClientId: Scalars['ID'];
  corpOfficialName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ConstraintsContractTemplateData = {
  allow: Scalars['Boolean'];
  azsContract: Scalars['ID'];
  contractCorpClientId?: InputMaybe<Scalars['ID']>;
  corpClientId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
};

export type ConstraintsContracts = {
  count: Scalars['Int'];
  items: Array<ConstraintsContract>;
};

export type ConstraintsContractsData = {
  contracts?: Maybe<Array<ContractInfo>>;
  firmType?: Maybe<OrganizationType>;
  id: Scalars['ID'];
  officialName?: Maybe<Scalars['String']>;
  taxiPartnerId?: Maybe<Scalars['ID']>;
};

export type ConstraintsContractsQueryParams = {
  allow?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** Абстрактный класс контракта */
export type Contract = {
  /** Номер счёта */
  account?: Maybe<Scalars['String']>;
  /** Агентское вознаграждение */
  agentCommission?: Maybe<Scalars['Float']>;
  /** Баланс компании */
  balance: Scalars['Float'];
  /** Лимит по балансу */
  balanceLimit: Scalars['Float'];
  /** Номер счёта в банке */
  bank?: Maybe<Scalars['String']>;
  /** Город банка */
  bankCity?: Maybe<Scalars['String']>;
  /** БИК */
  bik?: Maybe<Scalars['String']>;
  /** Формат типа бизнеса */
  businessType: ContractBusinessType;
  /** Кор. счёт */
  correspondence?: Maybe<Scalars['String']>;
  /** Дата заключения контракта */
  date?: Maybe<Scalars['String']>;
  /** Работа по кэшбэку */
  delayedDiscount?: Maybe<Scalars['Boolean']>;
  /** Скидка */
  discount?: Maybe<Scalars['Float']>;
  /** Электронный документооборот */
  edo?: Maybe<Scalars['Boolean']>;
  /** Дата завершения контракта */
  finishDate?: Maybe<Scalars['String']>;
  /** Признак получения оригиналов контракта */
  got: Scalars['Boolean'];
  /** Уникальный идентификатор компании */
  id: Scalars['ID'];
  /** Номер договора */
  number?: Maybe<Scalars['String']>;
  /** Тип оплаты по контракту */
  paymentType?: Maybe<ContractPaymentType>;
  personalDiscount?: Maybe<Scalars['Boolean']>;
  /** Тип контракта */
  type: ContractType;
};

export enum ContractBusinessType {
  B2b = 'b2b',
  B2c = 'b2c',
  Custom = 'custom'
}

/** Настраиваемая скидка на отдельные виды топлива */
export type ContractCustumFuelDiscount = {
  /** Размер скидки */
  discount: Scalars['Float'];
  /** ID топлива */
  fuel: Scalars['Float'];
};

export type ContractCustumFuelDiscountData = {
  discount: Scalars['Float'];
  fuel: Scalars['Float'];
};

/** Контракт */
export type ContractData = {
  /** Расчётный счёт */
  account?: InputMaybe<Scalars['String']>;
  /** Агентское вознаграждение */
  agentCommission?: InputMaybe<Scalars['Float']>;
  /** Лимит баланса */
  balanceLimit?: InputMaybe<Scalars['Float']>;
  /** Банк */
  bank?: InputMaybe<Scalars['String']>;
  /** Город банка */
  bankCity?: InputMaybe<Scalars['String']>;
  /** БИК */
  bik?: InputMaybe<Scalars['String']>;
  /** Тип контракта (B2B/B2C) */
  businessType?: InputMaybe<Scalars['String']>;
  /** Корп. счёт */
  correspondence?: InputMaybe<Scalars['String']>;
  /** Настраиваемая скидка для указанных видов топлива */
  customFuelDiscount?: InputMaybe<Array<ContractCustumFuelDiscountData>>;
  /** Дата подписания контракта */
  date?: InputMaybe<Scalars['String']>;
  /** Работа по кешбеку? */
  delayedDiscount?: InputMaybe<Scalars['Boolean']>;
  /** Скидка */
  discount?: InputMaybe<Scalars['Float']>;
  /** Электронный документооборот? */
  edo?: InputMaybe<Scalars['Boolean']>;
  /** Дата окончания контракта */
  finishDate?: InputMaybe<Scalars['String']>;
  /** Оригинал документа получен? */
  got?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Номер договора */
  number?: InputMaybe<Scalars['String']>;
  /** Тип оплаты (acquiring/prepay/postpay) */
  paymentType?: InputMaybe<Scalars['String']>;
  personalDiscount?: InputMaybe<Scalars['Boolean']>;
  timezoneOffset?: InputMaybe<Scalars['Int']>;
};

export type ContractInfo = {
  businessType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
};

export enum ContractPaymentType {
  Acquiring = 'acquiring',
  Postpay = 'postpay',
  Prepay = 'prepay'
}

export enum ContractSubtype {
  Custom = 'custom',
  Info = 'info',
  Sale = 'sale'
}

export enum ContractType {
  Custom = 'custom',
  Offline = 'offline',
  Online = 'online'
}

/** Онлайн-контракт */
export type CustomContract = Contract & {
  /** Номер счёта */
  account?: Maybe<Scalars['String']>;
  /** Агентское вознаграждение */
  agentCommission?: Maybe<Scalars['Float']>;
  /** Баланс компании */
  balance: Scalars['Float'];
  /** Лимит по балансу */
  balanceLimit: Scalars['Float'];
  /** Номер счёта в банке */
  bank?: Maybe<Scalars['String']>;
  /** Город банка */
  bankCity?: Maybe<Scalars['String']>;
  /** БИК */
  bik?: Maybe<Scalars['String']>;
  /** Формат типа бизнеса */
  businessType: ContractBusinessType;
  /** Кор. счёт */
  correspondence?: Maybe<Scalars['String']>;
  customFuelDiscount?: Maybe<Array<ContractCustumFuelDiscount>>;
  /** Дата заключения контракта */
  date?: Maybe<Scalars['String']>;
  /** Работа по кэшбэку */
  delayedDiscount?: Maybe<Scalars['Boolean']>;
  /** Скидка */
  discount?: Maybe<Scalars['Float']>;
  /** Список компаний, на которые распространяется скидка */
  discountOrganizations?: Maybe<Array<Scalars['String']>>;
  /** Документы контракта */
  document?: Maybe<OnlineContractDocument>;
  /** Документы контракта */
  documents?: Maybe<OnlineContractDocuments>;
  /** Электронный документооборот */
  edo?: Maybe<Scalars['Boolean']>;
  finishDate?: Maybe<Scalars['String']>;
  /** Признак получения оригиналов контракта */
  got: Scalars['Boolean'];
  /** Уникальный идентификатор компании */
  id: Scalars['ID'];
  /** Номер договора */
  number?: Maybe<Scalars['String']>;
  /** Тип оплаты по контракту */
  paymentType?: Maybe<ContractPaymentType>;
  personalDiscount?: Maybe<Scalars['Boolean']>;
  timezoneOffset: Scalars['Int'];
  /** Тип контракта */
  type: ContractType;
};


/** Онлайн-контракт */
export type CustomContractDocumentArgs = {
  id: Scalars['ID'];
};

/** Отдел */
export type Department = {
  /** Подотделы */
  children: Array<Department>;
  id: Scalars['ID'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Роль */
  role: DepartmentRole;
};

/** Тип лимитов водителя */
export enum DepartmentDriverConstraintType {
  Api = 'API',
  /** Депозит */
  Balance = 'BALANCE',
  /** Календарные лимиты */
  Limits = 'LIMITS'
}

export enum DepartmentRole {
  Accountant = 'accountant',
  Admin = 'admin',
  AzsSales = 'azs_sales',
  Custom = 'custom',
  Lawyer = 'lawyer',
  Manager = 'manager',
  Readonly = 'readonly',
  Sales = 'sales',
  Support = 'support',
  TaxiSales = 'taxi_sales',
  User = 'user'
}

/** Водитель */
export type Driver = User & {
  apiUser?: Maybe<ApiUser>;
  balanceHistory?: Maybe<BalanceHistory>;
  car?: Maybe<Car>;
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyReportType?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  /** Есть ли транзакции у водителя */
  hasTransactions: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  isActive: Scalars['Boolean'];
  limits?: Maybe<DriverLimits>;
  limitsAndExpenses: DriverLimitsAndExpenses;
  name?: Maybe<Scalars['String']>;
  partnerCars: Array<DriverPartnerCar>;
  partnerDriverId: Scalars['String'];
  partnerId: Scalars['String'];
  partnerName: Scalars['String'];
  partnerParentId?: Maybe<Scalars['String']>;
  partnerParentName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state: RecordState;
};


/** Водитель */
export type DriverBalanceHistoryArgs = {
  filter: QueryParams;
};

/** Данные для добавления водителя */
export type DriverData = {
  /** ID автомобиля водителя */
  carId?: InputMaybe<Scalars['String']>;
  /** ? */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Лимиты водителя */
  limits: DriverLimitsData;
  /** ФИО */
  name: Scalars['String'];
  /** Идентификатор отделов (подотделов) */
  partnerIds: Array<Scalars['String']>;
  /** Телефон */
  phone: Scalars['String'];
  /** Состояние записи водителя */
  state?: RecordState;
};

/** Данные для редактирования водителя */
export type DriverEditData = {
  /** ? */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Лимиты водителя */
  limits?: InputMaybe<DriverLimitsData>;
  /** ФИО */
  name?: InputMaybe<Scalars['String']>;
  /** Идентификатор отдела (подотдела) */
  partnerId?: InputMaybe<Scalars['ID']>;
  /** Идентификатор отделов (подотделов) */
  partnersIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Телефон */
  phone?: InputMaybe<Scalars['String']>;
  /** Состояние записи водителя */
  state?: InputMaybe<RecordState>;
};

/** Лимиты водителя */
export type DriverLimits = {
  /** Текущий размер депозита */
  balance?: Maybe<Scalars['Float']>;
  /** Признак блокировки водителя */
  blocked: Scalars['Boolean'];
  /** Дневной лимит */
  day?: Maybe<Scalars['Float']>;
  /** Массив ID допустимых типов топлива для заправки */
  fuels?: Maybe<Array<Scalars['ID']>>;
  /** Массив ID допустимых групп топлива */
  fuelsGroups?: Maybe<Array<Scalars['ID']>>;
  /** Единицы измерения лимитов, true - литры, false - рубли. Только для лимитов типа "LIMITS" */
  isQuantity?: Maybe<Scalars['Boolean']>;
  /** Тип лимитов водителя */
  limitsType: DepartmentDriverConstraintType;
  /** Минимальное значение лимита, до которого может снизиться баланс водителя */
  minLeft: Scalars['Float'];
  /** Месячный лимит */
  month?: Maybe<Scalars['Float']>;
  /** Массив ID регионов, в которых можно заправляться */
  regions?: Maybe<Array<Scalars['ID']>>;
  /** Недельный лимит */
  week?: Maybe<Scalars['Float']>;
};

/** Лимиты водителя и остаток по ним */
export type DriverLimitsAndExpenses = {
  /** Текущий размер депозита */
  balance?: Maybe<Scalars['Float']>;
  /** Признак блокировки водителя */
  blocked: Scalars['Boolean'];
  /** Дневной лимит */
  day?: Maybe<Scalars['Float']>;
  /** Оставшийся суточный лимит */
  dayExpenses?: Maybe<Scalars['Float']>;
  /** Массив ID допустимых типов топлива для заправки */
  fuels?: Maybe<Array<Scalars['ID']>>;
  /** Массив ID допустимых групп топлива */
  fuelsGroups?: Maybe<Array<Scalars['ID']>>;
  /** Единицы измерения лимитов, true - литры, false - рубли. Только для лимитов типа "LIMITS" */
  isQuantity?: Maybe<Scalars['Boolean']>;
  /** Тип лимитов водителя */
  limitsType: DepartmentDriverConstraintType;
  /** Месячный лимит */
  month?: Maybe<Scalars['Float']>;
  /** Оставшийся месячный лимит */
  monthExpenses?: Maybe<Scalars['Float']>;
  /** Массив ID регионов, в которых можно заправляться */
  regions?: Maybe<Array<Scalars['ID']>>;
  /** Недельный лимит */
  week?: Maybe<Scalars['Float']>;
  /** Оставшийся недельный лимит */
  weekExpenses?: Maybe<Scalars['Float']>;
};

/** Операция по изменению депозита. Только для лимитов типа "BALANCE", для остальных типов игнорируется (считается равным "SET") */
export enum DriverLimitsChangeOperation {
  /** Увеличить депозит */
  Add = 'ADD',
  /** Установить точное знечение депозита */
  Set = 'SET',
  /** Уменьшить депозит */
  Substract = 'SUBSTRACT'
}

/** Лимиты водителя */
export type DriverLimitsData = {
  /** Положительное значение изменения величины депозита. Результат зависит от типа проводимой операции */
  balanceValue?: InputMaybe<Scalars['Float']>;
  /** Признак блокировки водителя */
  blocked?: InputMaybe<Scalars['Boolean']>;
  /** Дневной лимит */
  day?: InputMaybe<Scalars['Float']>;
  /** Массив ID допустимых типов топлива для заправки */
  fuels?: InputMaybe<Array<Scalars['ID']>>;
  /** Массив ID допустимых групп топлива */
  fuelsGroups?: InputMaybe<Array<Scalars['ID']>>;
  /** Единицы измерения лимитов, true - литры, false - рубли. Только для лимитов типа "LIMITS" */
  isQuantity?: InputMaybe<Scalars['Boolean']>;
  /** Операция по изменению депозита. Только для лимитов типа "BALANCE", для остальных типов игнорируется (считается равным "SET") */
  limitsOperation?: DriverLimitsChangeOperation;
  /** Тип лимитов водителя */
  limitsType: DepartmentDriverConstraintType;
  /** ? */
  minLeft?: InputMaybe<Scalars['Float']>;
  /** Месячный лимит */
  month?: InputMaybe<Scalars['Float']>;
  /** Массив ID регионов, в которых можно заправляться */
  regions?: InputMaybe<Array<Scalars['ID']>>;
  /** Недельный лимит */
  week?: InputMaybe<Scalars['Float']>;
};

/** Отдел и автомобиль водителя */
export type DriverPartnerCar = {
  car?: Maybe<Car>;
  isActive: Scalars['Boolean'];
  limits: DriverLimits;
  partner: Partner;
};

/** Состояние учётной записи водителя */
export enum DriverStatus {
  /** Активирована */
  Active = 'active',
  Blocked = 'blocked',
  /** Не активирована */
  Inactive = 'inactive'
}

/** Информация о водителях транспортной компании */
export type Drivers = {
  /** Количество активных водителей */
  activeCount: Scalars['Int'];
  /** Количество водителей */
  count: Scalars['Int'];
  /** Признак, что у компании есть ли хотя бы один водитель */
  hasAny: Scalars['Boolean'];
  /** Список водителей */
  items: Array<Driver>;
  /** Количество всех водителей */
  totalCount: Scalars['Int'];
};

/** Информация для редактирования АЗС */
export type EditStationData = {
  /** Вкл/выкл станцию */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Адрес */
  address?: InputMaybe<Scalars['String']>;
  /** Адрес */
  addressApi?: InputMaybe<Scalars['String']>;
  /** Бренд */
  brand?: InputMaybe<Scalars['String']>;
  /** Цвет АЗС */
  color?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  /** Координата широты АЗС */
  lat?: InputMaybe<Scalars['Float']>;
  /** Координата широты АЗС */
  latApi?: InputMaybe<Scalars['Float']>;
  /** Координата долготы АЗС */
  lng?: InputMaybe<Scalars['Float']>;
  /** Координата долготы АЗС */
  lngApi?: InputMaybe<Scalars['Float']>;
  /** Когда снимать пистолет */
  mode?: InputMaybe<StationMode>;
  /** Название АЗС */
  name?: InputMaybe<Scalars['String']>;
  /** Название АЗС */
  nameApi?: InputMaybe<Scalars['String']>;
  /** Информация об АЗС */
  promo?: InputMaybe<Scalars['String']>;
};

/** Часто задаваемый вопрос */
export type Faq = {
  /** Ответ */
  answer?: Maybe<Scalars['String']>;
  /** ID вопроса */
  id: Scalars['ID'];
  /** Вопрос */
  question?: Maybe<Scalars['String']>;
  /** Номер вопроса (используется для сортировки) */
  sorting?: Maybe<Scalars['Float']>;
};

/** Топливо */
export type Fuel = {
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  group?: Maybe<FuelGroup>;
  groupId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export type FuelData = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
};

export type FuelDiscount = {
  discount: Scalars['Float'];
  discountId: Scalars['ID'];
  endDate?: Maybe<Scalars['DateTime']>;
  fuelId: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
};

export type FuelDiscounts = {
  count: Scalars['Int'];
  items: Array<FuelDiscount>;
};

export type FuelDiscountsGroupItem = {
  contractId: Scalars['String'];
  contractNumber?: Maybe<Scalars['String']>;
  discounts: Array<Scalars['Float']>;
  fuels: Array<Scalars['Int']>;
  organizationName: Scalars['String'];
};

export type FuelDiscountsGroups = {
  count: Scalars['Int'];
  items: Array<FuelDiscountsGroupItem>;
};

/** Группа топлива */
export type FuelGroup = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Исходящее платежное поручение */
export type InvoiceItem = {
  amount: Scalars['Float'];
  contract: Scalars['String'];
  contractId: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  paymentPurpose: Scalars['String'];
  status: Scalars['String'];
};

/** Исходящие платежные поручения */
export type InvoiceItems = {
  /** Количество выбранных исходящих платежных поручений */
  count: Scalars['Int'];
  /** Исходящие платежные поручения */
  items: Array<InvoiceItem>;
  /** Сумма выбранных исходящих платежных поручений */
  total: Scalars['Float'];
};

/** Контрагент для выставления платежного поручения */
export type InvoiceOrganizationItem = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Счет на оплату */
export type InvoicePayment = Payment & {
  amount: Scalars['Float'];
  balances: Array<PaymentBalanceItem>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  provider: PaymentProvider;
  status: Scalars['String'];
  /** Статус платежа */
  statusDescription?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Онлайн-оплата */
export type InvoicePaymentResponse = PaymentResponse & {
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  number: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export enum InvoiceType {
  All = 'ALL',
  Postpaid = 'POSTPAID',
  Prepaid = 'PREPAID'
}

/** Обертка для методов с платежными поручениями */
export type InvoicesData = {
  /** Рассчетный счёт компании Фьюэл-Ап */
  fuelUpBankAccount: Scalars['String'];
  /** Список контрагентов для выставления платежных поручений */
  invoiceOrganizations: Array<InvoiceOrganizationItem>;
  /** Список готовых платежных поручений */
  invoicesList: InvoiceItems;
};


/** Обертка для методов с платежными поручениями */
export type InvoicesDataInvoicesListArgs = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  invoiceStatus?: InputMaybe<Array<Scalars['String']>>;
  organizationName?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
};

/** Пользователь ЛК */
export type LkUser = User & {
  access: Array<LkUserAccess>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastActivity?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** Ссылка для автоматической авторизации в старом кабинете */
  oldAuthLink: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<UsersRoles>;
};

/** Права пользователя */
export type LkUserAccess = {
  id: Scalars['ID'];
  partners?: Maybe<Array<Partner>>;
  role?: Maybe<UsersRoles>;
};

/** Базовый класс лимита */
export type Limit = {
  /** Тип записи лимита */
  type: Scalars['String'];
};

/** Лимиты */
export type Limits = {
  /** Число лимитов */
  count: Scalars['Int'];
  /** Записи лимитов */
  items: Array<Limit>;
};

/** Параметры выборки лимитов */
export type LimitsQueryParams = {
  /** Номер страницы */
  page?: Scalars['Int'];
  /** Поисковый запрос */
  query?: InputMaybe<Scalars['String']>;
  /** Число записей на странице */
  size?: Scalars['Int'];
  /** Тип лимитов */
  type: LimitsType;
};

export enum LimitsType {
  LkAuth = 'lkAuth',
  MaAuth = 'maAuth'
}

/** Запись лога */
export type Log = {
  /** Код лога */
  code?: Maybe<Scalars['Float']>;
  /** Дата записи */
  date: Scalars['DateTime'];
  /** Введённый код */
  input?: Maybe<Scalars['String']>;
  /** Название лога */
  logName: Scalars['String'];
  /** Тип лога */
  logType: Scalars['String'];
  /** Номер телефона */
  phone: Scalars['String'];
  /** Код для авторизации */
  smsCode?: Maybe<Scalars['String']>;
  /** Тип записи лога */
  type: Scalars['String'];
};

export enum LogType {
  LkAuth = 'lkAuth',
  MaAuth = 'maAuth'
}

/** Логи */
export type Logs = {
  /** Число логов */
  count: Scalars['Int'];
  /** Записи логов */
  items: Array<Log>;
  /** Число логов */
  summary: LogsSummary;
};

/** Параметры выборки логов */
export type LogsQueryParams = {
  /** Код ответа */
  code: Array<Scalars['Int']>;
  /** Начальная дата поиска логов */
  dateFrom: Scalars['DateTime'];
  /** Конечная дата поиска логов */
  dateTo: Scalars['DateTime'];
  /** Номер страницы */
  page?: Scalars['Int'];
  /** Поисковый запрос */
  query?: InputMaybe<Scalars['String']>;
  /** Число записей на странице */
  size?: Scalars['Int'];
  /** Тип логов */
  type: LogType;
};

/** Сводные данные по логам */
export type LogsSummary = {
  /** Число неуспешных авторизаций */
  errors?: Maybe<Scalars['Int']>;
  /** Число неправильных вводов */
  invalid?: Maybe<Scalars['Int']>;
  /** Число успешных авторизаций */
  successful?: Maybe<Scalars['Int']>;
  /** Число ошибок "нельзя отправить повторно" */
  timeouts?: Maybe<Scalars['Int']>;
  /** Всего отправленных SMS */
  total?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  addCar?: Maybe<MutationResult>;
  addCarToPartner?: Maybe<Car>;
  /** Добавление нового цвета */
  addColor?: Maybe<Color>;
  addCorpClientStationsGroupFuelDiscounts: Scalars['Boolean'];
  /** Добавление водителя */
  addDriver?: Maybe<Array<Driver>>;
  addDriverToCar?: Maybe<Car>;
  /** Добавление нового часто задаваемого вопроса */
  addFaq?: Maybe<Faq>;
  /** Добавление новой станции для оффлайн АЗС */
  addOfflineStation?: Maybe<Station>;
  /** Добавление партнера/отдела */
  addPartner?: Maybe<Partner>;
  /** Добавление шаблона ПП */
  addStatementsPattern: Scalars['Boolean'];
  /** Добавление новой станции для АЗС */
  addStation?: Maybe<MutationResult>;
  /** Добавление АСУ */
  addStationSystem?: Maybe<StationSystem>;
  addStationsGroup: Scalars['String'];
  addStationsToStationsGroup: Scalars['Boolean'];
  addUser?: Maybe<Scalars['String']>;
  /** Изменение информации о всех АЗС компании */
  bulkEditStations?: Maybe<Station>;
  bulkSetStationsState: Scalars['Boolean'];
  bulkSetStationsStateByGroupId: Scalars['Boolean'];
  /** Отмена заказа */
  cancelOrder: Order;
  /** Возврат бонусов Спасибо */
  cancelSberLoyaltyReceipt: Scalars['Boolean'];
  /** Перезапуск обработки платежа */
  cancelStatementReceipt?: Maybe<Scalars['Boolean']>;
  changeBusinessCardSettings: Scalars['Boolean'];
  checkContractPayments: CheckPaymentsResult;
  checkPayment?: Maybe<Payment>;
  /** Закрытие заказа */
  closeOrder: Order;
  copyStation: Scalars['Boolean'];
  copyStations: Scalars['Boolean'];
  /** Создание шаблона бизнес-карты */
  createCardTemplate: CardTemplate;
  /** Создание компании */
  createCompany?: Maybe<Company>;
  createConstraintByAzs: Scalars['Boolean'];
  createConstraintByContract: ConstraintsContractTemplate;
  createContract: MutationResult;
  createInvoices?: Maybe<Scalars['Boolean']>;
  createNotificationTemplate: NotificationTemplate;
  /** Создание оффлайн партнера */
  createOfflinePartner?: Maybe<Scalars['ID']>;
  createPayment?: Maybe<PaymentResponse>;
  /** Создание задачи */
  createScriptRun: RunResult;
  /** Удаление шаблона бизнес-карты */
  deleteCardTemplate: Scalars['Boolean'];
  deleteContractDocument: Scalars['Boolean'];
  deleteNotificationTemplate: Scalars['Boolean'];
  deletePayment?: Maybe<Scalars['String']>;
  /** Удаление шаблона ПП */
  deleteStatementsPattern: Scalars['Boolean'];
  deleteStationGroup: Scalars['Boolean'];
  deleteStationsGroupContractFuelDiscounts: Scalars['Boolean'];
  deleteStationsGroupFuelDiscount: Scalars['Boolean'];
  deleteStationsGroupFuelDiscounts: Scalars['Boolean'];
  deleteStationsGroupStation: Scalars['Boolean'];
  deleteStationsGroupStations: Scalars['Boolean'];
  /** Списание заказа в убыток */
  dismissOrder: Order;
  /** Списание заказа на доход */
  dismissOrderToIncome: Order;
  editAllConstraintsByContract: Scalars['Boolean'];
  editConstraintByContract: ConstraintsContractTemplate;
  editContractDocument: Scalars['Boolean'];
  editCorpClientStationsGroupFuelDiscount: Scalars['Boolean'];
  /** Добавление нового часто задаваемого вопроса */
  editFaq?: Maybe<Faq>;
  /** Изменение партнера/отдела */
  editPartner?: Maybe<Partner>;
  /** Редактирование информации АЗС */
  editStation?: Maybe<Station>;
  /** Изменение АСУ */
  editStationSystem?: Maybe<StationSystem>;
  editStationsGroup: Scalars['Boolean'];
  /** Запуск задачи */
  executeScriptRun: RunResult;
  /** Индексация заказа */
  indexOrder: Scalars['Boolean'];
  /** Индексация списка заказов */
  indexOrders: Scalars['Boolean'];
  indexStations?: Maybe<Scalars['Boolean']>;
  /** Ссылка на авторизацию через СберБизнесId */
  linkSberBusinessId: Scalars['String'];
  /** Изменение информации о заказе */
  modifyOrder: Order;
  /** Предпросмотр результатов задачи */
  previewScriptRun: Scalars['String'];
  /** Установка связи компании с владельцем карт */
  putCardsFirmReference: Scalars['Boolean'];
  /** Возврат заказа */
  refundOrder: Order;
  removeAllConstraintsByAzs: Scalars['Boolean'];
  removeAllConstraintsByContract: Scalars['Boolean'];
  removeCarFromPartner?: Maybe<Car>;
  removeCard?: Maybe<Scalars['String']>;
  removeConstraintByAzs: Scalars['Boolean'];
  removeConstraintByContract: Scalars['Boolean'];
  removeDriverFromCar?: Maybe<Car>;
  /** Удаление часто задаваемого вопроса */
  removeFaq?: Maybe<Scalars['Boolean']>;
  removeUser?: Maybe<Scalars['String']>;
  /** Обнуление лимитов авторизации */
  resetAuthLimits: Scalars['Boolean'];
  /** Перезапуск обработки платежа */
  restartStatementReceipt?: Maybe<Scalars['Boolean']>;
  saveBulkFuels: Scalars['Boolean'];
  saveCar?: Maybe<Car>;
  saveCompany: MutationResult;
  /** Сохранение водителя */
  saveDriver?: Maybe<Driver>;
  /** Изменение списка отделов водителя */
  saveDriverPartners?: Maybe<Scalars['String']>;
  saveInvoice?: Maybe<Scalars['Boolean']>;
  sendRestoreUserPasswordEmail: Scalars['String'];
  /** Установка состояния автомобиля */
  setCarState: Scalars['Boolean'];
  /** Установка состояния водителя */
  setDriverState?: Maybe<Scalars['Boolean']>;
  /** Изменение режима работы компании */
  setOrganizationMode: Scalars['Boolean'];
  /** Установка состояния (под)отдела */
  setPartnerState?: Maybe<Scalars['Boolean']>;
  setStationFuelDiscount?: Maybe<Scalars['Boolean']>;
  setStationFuelDiscounts?: Maybe<Scalars['Boolean']>;
  setStationState: Scalars['Boolean'];
  submitInvoices?: Maybe<Scalars['Boolean']>;
  /** Возврат заказа из убытка */
  undoLoss: OrderChangeResult;
  /** Отвязка СберБизнесId */
  unlinkSberBusinessId?: Maybe<Scalars['Boolean']>;
  unlinkUserSberId: Scalars['String'];
  /** Изменение лимитов бизнес-карты */
  updateCardLimits: Scalars['Boolean'];
  /** Изменение шаблона бизнес-карты */
  updateCardTemplate: CardTemplate;
  updateNotificationTemplate: NotificationTemplate;
  updatePartnerStations?: Maybe<Scalars['Boolean']>;
};


export type MutationAddCarArgs = {
  companyId: Scalars['ID'];
  data: CarData;
  partnerId: Array<Scalars['ID']>;
};


export type MutationAddCarToPartnerArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  partnerId: Array<Scalars['ID']>;
};


export type MutationAddColorArgs = {
  color: Scalars['String'];
  name: Scalars['String'];
  symbol?: InputMaybe<Scalars['String']>;
};


export type MutationAddCorpClientStationsGroupFuelDiscountsArgs = {
  contractId: Scalars['ID'];
  discount: Scalars['Float'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  fuelsIds: Array<Scalars['Int']>;
  groupId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationAddDriverArgs = {
  companyId: Scalars['ID'];
  data: DriverData;
};


export type MutationAddDriverToCarArgs = {
  companyId: Scalars['ID'];
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
  unblock?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddFaqArgs = {
  answer?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
  sorting?: InputMaybe<Scalars['Float']>;
};


export type MutationAddOfflineStationArgs = {
  partnerId: Scalars['ID'];
  stationData: NewOfflineStationData;
};


export type MutationAddPartnerArgs = {
  companyId: Scalars['ID'];
  data: PartnerData;
  moveDrivers?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddStatementsPatternArgs = {
  data: StatementPatternData;
};


export type MutationAddStationArgs = {
  companyId: Scalars['ID'];
  stationData: NewStationData;
};


export type MutationAddStationSystemArgs = {
  data: NewStationSystemData;
};


export type MutationAddStationsGroupArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  name: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  stationsIDs?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationAddStationsToStationsGroupArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  stationsIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationAddUserArgs = {
  companyId: Scalars['ID'];
  data: UserData;
};


export type MutationBulkEditStationsArgs = {
  companyId: Scalars['ID'];
  stationsData: BulkEditStationsData;
};


export type MutationBulkSetStationsStateArgs = {
  commentary: Scalars['String'];
  companyId: Scalars['ID'];
  groupId?: InputMaybe<Scalars['ID']>;
  newState: StationState;
  oldState: Array<StationState>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StationStatus>;
};


export type MutationBulkSetStationsStateByGroupIdArgs = {
  commentary: Scalars['String'];
  groupId: Scalars['ID'];
  state: StationState;
};


export type MutationCancelOrderArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationCancelSberLoyaltyReceiptArgs = {
  id: Scalars['String'];
  orderId: Scalars['ID'];
};


export type MutationCancelStatementReceiptArgs = {
  id: Scalars['ID'];
};


export type MutationChangeBusinessCardSettingsArgs = {
  companyId: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};


export type MutationCheckContractPaymentsArgs = {
  contractId: Scalars['ID'];
};


export type MutationCheckPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationCloseOrderArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  volume: Scalars['Float'];
};


export type MutationCopyStationArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCopyStationsArgs = {
  companyId: Scalars['ID'];
  ids: Array<Scalars['ID']>;
};


export type MutationCreateCardTemplateArgs = {
  companyId: Scalars['ID'];
  template: CardTemplateData;
};


export type MutationCreateCompanyArgs = {
  data: CompanyData;
  type: OrganizationType;
};


export type MutationCreateConstraintByAzsArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  stationsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCreateConstraintByContractArgs = {
  data: ConstraintsContractTemplateData;
};


export type MutationCreateContractArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  data: ContractData;
};


export type MutationCreateInvoicesArgs = {
  bankAccount: Scalars['String'];
  invoiceType: InvoiceType;
  organizations: Array<Scalars['String']>;
  prepayDays: Scalars['Float'];
};


export type MutationCreateNotificationTemplateArgs = {
  data: NotificationTemplateData;
};


export type MutationCreateOfflinePartnerArgs = {
  contract: Scalars['String'];
  firmId: Scalars['String'];
  name: Scalars['String'];
  organization: Scalars['ID'];
  osnovans?: InputMaybe<Array<Scalars['Float']>>;
};


export type MutationCreatePaymentArgs = {
  amount: Scalars['Float'];
  cardId?: InputMaybe<Scalars['ID']>;
  confirm?: InputMaybe<Scalars['Boolean']>;
  contractId: Scalars['ID'];
  date?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  providerId: Scalars['ID'];
};


export type MutationCreateScriptRunArgs = {
  id: Scalars['Int'];
  params: Scalars['String'];
};


export type MutationDeleteCardTemplateArgs = {
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type MutationDeleteContractDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNotificationTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentArgs = {
  contractId: Scalars['ID'];
  paymentId: Scalars['ID'];
};


export type MutationDeleteStatementsPatternArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStationGroupArgs = {
  groupId: Scalars['ID'];
};


export type MutationDeleteStationsGroupContractFuelDiscountsArgs = {
  contractId: Scalars['ID'];
  groupId: Scalars['ID'];
};


export type MutationDeleteStationsGroupFuelDiscountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStationsGroupFuelDiscountsArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStationsGroupStationArgs = {
  groupId: Scalars['ID'];
  stationId: Scalars['ID'];
};


export type MutationDeleteStationsGroupStationsArgs = {
  id: Scalars['ID'];
};


export type MutationDismissOrderArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  partial?: InputMaybe<Scalars['Boolean']>;
  volume?: InputMaybe<Scalars['Float']>;
};


export type MutationDismissOrderToIncomeArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  volume: Scalars['Float'];
};


export type MutationEditAllConstraintsByContractArgs = {
  allow: Scalars['Boolean'];
  filter: ConstraintsContractsQueryParams;
  id: Scalars['ID'];
};


export type MutationEditConstraintByContractArgs = {
  data: ConstraintsContractTemplateData;
};


export type MutationEditContractDocumentArgs = {
  data: OnlineContractDocumentData;
  id: Scalars['ID'];
};


export type MutationEditCorpClientStationsGroupFuelDiscountArgs = {
  discount: Scalars['Float'];
  discountId: Scalars['ID'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationEditFaqArgs = {
  answer?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Scalars['Float']>;
};


export type MutationEditPartnerArgs = {
  companyId: Scalars['ID'];
  data: PartnerData;
  partnerId: Scalars['ID'];
};


export type MutationEditStationArgs = {
  stationData: EditStationData;
  stationId: Scalars['ID'];
};


export type MutationEditStationSystemArgs = {
  data: StationSystemData;
};


export type MutationEditStationsGroupArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  stationsIDs?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationExecuteScriptRunArgs = {
  id: Scalars['Int'];
};


export type MutationIndexOrderArgs = {
  id: Scalars['String'];
  type: StationStatus;
};


export type MutationIndexOrdersArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationIndexStationsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationLinkSberBusinessIdArgs = {
  companyId: Scalars['ID'];
};


export type MutationModifyOrderArgs = {
  carId?: InputMaybe<Scalars['ID']>;
  commentary: Scalars['String'];
  costPromotion?: InputMaybe<Scalars['Float']>;
  discountCorp?: InputMaybe<Scalars['Float']>;
  discountStation?: InputMaybe<Scalars['Float']>;
  fuelId?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  stationId?: InputMaybe<Scalars['ID']>;
  volume?: InputMaybe<Scalars['Float']>;
};


export type MutationPreviewScriptRunArgs = {
  id: Scalars['Int'];
  params: Scalars['String'];
};


export type MutationPutCardsFirmReferenceArgs = {
  companyId: Scalars['ID'];
};


export type MutationRefundOrderArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  volume: Scalars['Float'];
};


export type MutationRemoveAllConstraintsByAzsArgs = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveAllConstraintsByContractArgs = {
  filter: ConstraintsContractsQueryParams;
  id: Scalars['ID'];
};


export type MutationRemoveCarFromPartnerArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type MutationRemoveCardArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveConstraintByAzsArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type MutationRemoveConstraintByContractArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveDriverFromCarArgs = {
  companyId: Scalars['ID'];
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type MutationRemoveFaqArgs = {
  id: Scalars['String'];
};


export type MutationRemoveUserArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationResetAuthLimitsArgs = {
  id: Scalars['String'];
  type: Scalars['String'];
};


export type MutationRestartStatementReceiptArgs = {
  customContractId?: InputMaybe<Scalars['ID']>;
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationSaveBulkFuelsArgs = {
  fuelData: Array<FuelData>;
};


export type MutationSaveCarArgs = {
  car: CarSaveData;
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationSaveCompanyArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  data: CompanyData;
  partnerId?: InputMaybe<Scalars['ID']>;
};


export type MutationSaveDriverArgs = {
  companyId: Scalars['ID'];
  driver: DriverEditData;
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type MutationSaveDriverPartnersArgs = {
  companyId: Scalars['ID'];
  driver: DriverEditData;
  id: Scalars['ID'];
};


export type MutationSaveInvoiceArgs = {
  amount: Scalars['Float'];
  invoiceId: Scalars['ID'];
  paymentPurpose: Scalars['String'];
  status: Scalars['String'];
};


export type MutationSendRestoreUserPasswordEmailArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationSetCarStateArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  state: RecordState;
};


export type MutationSetDriverStateArgs = {
  companyId: Scalars['ID'];
  driverId: Scalars['ID'];
  partnerId: Scalars['ID'];
  state: RecordState;
};


export type MutationSetOrganizationModeArgs = {
  companyId: Scalars['ID'];
  mode: OrganizationMode;
};


export type MutationSetPartnerStateArgs = {
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
  state: RecordState;
};


export type MutationSetStationFuelDiscountArgs = {
  discount: Scalars['Float'];
  discountId?: InputMaybe<Scalars['ID']>;
  fuelId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
};


export type MutationSetStationFuelDiscountsArgs = {
  discounts: Array<Scalars['Float']>;
  fuelIds: Array<Scalars['ID']>;
  stationId: Scalars['ID'];
};


export type MutationSetStationStateArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  state: StationState;
};


export type MutationUndoLossArgs = {
  commentary: Scalars['String'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationUnlinkSberBusinessIdArgs = {
  companyId: Scalars['ID'];
};


export type MutationUnlinkUserSberIdArgs = {
  userId: Scalars['ID'];
};


export type MutationUpdateCardLimitsArgs = {
  companyId: Scalars['ID'];
  limits: CardLimitsData;
  token: Scalars['String'];
};


export type MutationUpdateCardTemplateArgs = {
  companyId: Scalars['ID'];
  template: CardTemplateData;
  templateId: Scalars['ID'];
};


export type MutationUpdateNotificationTemplateArgs = {
  data: NotificationTemplateData;
  id: Scalars['ID'];
};


export type MutationUpdatePartnerStationsArgs = {
  companyId: Scalars['ID'];
};

export type MutationResult = {
  message?: Maybe<Scalars['String']>;
  result: Scalars['String'];
};

/** Информация для добавления новой станции в оффлайне */
export type NewOfflineStationData = {
  /** Адрес */
  address: Scalars['String'];
  /** Бренд */
  brand: Scalars['String'];
  /** Название АЗС */
  name: Scalars['String'];
  /** ID АЗС */
  partnerExtId: Scalars['String'];
  /** Регион */
  region: Scalars['String'];
};

/** Информация для добавления новой станции */
export type NewStationData = {
  /** Адрес */
  address: Scalars['String'];
  /** Координата широты АЗС */
  lat?: InputMaybe<Scalars['Float']>;
  /** Координата долготы АЗС */
  lng?: InputMaybe<Scalars['Float']>;
  /** Название АЗС */
  name: Scalars['String'];
  /** ID АЗС */
  partnerId: Scalars['String'];
};

export type NewStationSystemData = {
  /** Название АСУ */
  name: Scalars['String'];
  /** Протокол АСУ */
  protocol: Scalars['String'];
};

/** Отправленное уведомление */
export type Notification = {
  /** Канал отправки */
  channel: NotificationChannel;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** ID уведомления */
  id: Scalars['ID'];
  /** Сообщение */
  message: Scalars['String'];
  /** Получатель */
  recipient: Scalars['String'];
  /** Статус уведомления */
  status: NotificationStatus;
};

export enum NotificationChannel {
  /** Электронная почта */
  Email = 'Email',
  /** СМС */
  Sms = 'Sms'
}

export enum NotificationStatus {
  /** Получено */
  Delivered = 'Delivered',
  /** Ошибка */
  Error = 'Error',
  /** Отправлено */
  Sent = 'Sent'
}

/** Шаблон */
export type NotificationTemplate = {
  /** Канал отправки */
  channel: NotificationChannel;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** ID уведомления */
  id: Scalars['ID'];
  /** Название */
  name: Scalars['String'];
  /** Шаблон сообщения */
  template: Scalars['String'];
  /** Заголовок сообщения */
  title: Scalars['String'];
  /** Триггер */
  trigger: NotificationTrigger;
  /** Дата обновления */
  updatedAt: Scalars['DateTime'];
};

/** Данные шаблона */
export type NotificationTemplateData = {
  /** Канал отправки */
  channel: NotificationChannel;
  /** Название */
  name: Scalars['String'];
  /** Шаблон сообщения */
  template: Scalars['String'];
  /** Заголовок сообщения */
  title: Scalars['String'];
  /** Триггер */
  trigger: NotificationTrigger;
};

/** Шаблоны */
export type NotificationTemplates = {
  /** Количество */
  count: Scalars['Int'];
  /** Шаблоны */
  items: Array<NotificationTemplate>;
};

export enum NotificationTrigger {
  /** Задолженность */
  Debt = 'Debt',
  /** Изменена скидка */
  DiscountChange = 'DiscountChange',
  /** Низкий баланс */
  LowBalance = 'LowBalance'
}

/** Отправленные уведомления */
export type Notifications = {
  /** Количество */
  count: Scalars['Int'];
  /** Отправленные уведомления */
  items: Array<Notification>;
};

/** Параметры выборки уведомлений */
export type NotificationsQueryParams = {
  /** Канал отправки */
  channel?: InputMaybe<NotificationChannel>;
  /** Начальная дата формирования отчёта */
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  /** Конечная дата формирования отчёта */
  dateTo?: InputMaybe<Scalars['DateTime']>;
  /** Страница */
  page?: Scalars['Int'];
  /** Поисковый запрос */
  query?: InputMaybe<Scalars['String']>;
  /** Размер страницы */
  size?: Scalars['Int'];
  /** Статус */
  status?: InputMaybe<NotificationStatus>;
};

/** Параметры выборки шаблонов */
export type NotificationsTemplatesQueryParams = {
  /** Канал отправки */
  channel?: InputMaybe<NotificationChannel>;
  /** Начальная дата формирования отчёта */
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  /** Конечная дата формирования отчёта */
  dateTo?: InputMaybe<Scalars['DateTime']>;
  /** Страница */
  page?: Scalars['Int'];
  /** Поисковый запрос */
  query?: InputMaybe<Scalars['String']>;
  /** Размер страницы */
  size?: Scalars['Int'];
  /** Триггер */
  trigger?: InputMaybe<NotificationTrigger>;
};

/** Оффлайн-контракт */
export type OfflineContract = Contract & {
  /** Номер счёта */
  account?: Maybe<Scalars['String']>;
  /** Агентское вознаграждение */
  agentCommission?: Maybe<Scalars['Float']>;
  /** Баланс компании */
  balance: Scalars['Float'];
  /** Лимит по балансу */
  balanceLimit: Scalars['Float'];
  /** Номер счёта в банке */
  bank?: Maybe<Scalars['String']>;
  /** Город банка */
  bankCity?: Maybe<Scalars['String']>;
  /** БИК */
  bik?: Maybe<Scalars['String']>;
  /** Формат типа бизнеса */
  businessType: ContractBusinessType;
  /** Кор. счёт */
  correspondence?: Maybe<Scalars['String']>;
  /** Дата заключения контракта */
  date?: Maybe<Scalars['String']>;
  /** Работа по кэшбэку */
  delayedDiscount?: Maybe<Scalars['Boolean']>;
  /** Скидка */
  discount?: Maybe<Scalars['Float']>;
  /** Электронный документооборот */
  edo?: Maybe<Scalars['Boolean']>;
  finishDate?: Maybe<Scalars['String']>;
  /** Признак получения оригиналов контракта */
  got: Scalars['Boolean'];
  /** Уникальный идентификатор компании */
  id: Scalars['ID'];
  /** Номер договора */
  number?: Maybe<Scalars['String']>;
  /** Тип оплаты по контракту */
  paymentType?: Maybe<ContractPaymentType>;
  personalDiscount?: Maybe<Scalars['Boolean']>;
  /** Тип контракта */
  type: ContractType;
};

/** Оффлайн-заказ */
export type OfflineOrder = Order & {
  /** Тип карты (Visa/Master/Mir) */
  bankProduct?: Maybe<Scalars['String']>;
  /** Последние цифры банковской карты */
  cardNumber?: Maybe<Scalars['String']>;
  /** Компания-покупатель */
  corp?: Maybe<OrderCorp>;
  /** Дата начала заказа */
  date: Scalars['DateTime'];
  /** Дата завершения заказа */
  finished?: Maybe<Scalars['DateTime']>;
  hasOfflineOrder?: Maybe<Scalars['Boolean']>;
  hasOnlineOrder?: Maybe<Scalars['Boolean']>;
  /** Уникальный идентификатор заказа */
  id: Scalars['ID'];
  /** IP-адрес покупателя */
  ip?: Maybe<Scalars['String']>;
  /** Список купленных товаров */
  items: Array<OrderProductItem>;
  /** Международная платёжная система */
  mps?: Maybe<Scalars['String']>;
  /** Информация о владельце карты */
  owner?: Maybe<CardOwner>;
  /** Информация о платеже */
  payment?: Maybe<OrderPayment>;
  /** Признак наличия SberId */
  sberId?: Maybe<Scalars['Boolean']>;
  /** Информация по СберСпасибо (если имеется) */
  sberSpasiboDetails?: Maybe<OrderItemSberSpasiboDetails>;
  /** АЗС */
  station?: Maybe<Station>;
  /** Статус заказа */
  status: Scalars['String'];
  /** Текстовая информация о статусе заказа */
  statusMessage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  /** Пользователь приложения */
  user?: Maybe<AppUser>;
};

/** Онлайн-контракт */
export type OnlineContract = Contract & {
  /** Номер счёта */
  account?: Maybe<Scalars['String']>;
  /** Агентское вознаграждение */
  agentCommission?: Maybe<Scalars['Float']>;
  /** Баланс компании */
  balance: Scalars['Float'];
  /** Лимит по балансу */
  balanceLimit: Scalars['Float'];
  /** Номер счёта в банке */
  bank?: Maybe<Scalars['String']>;
  /** Город банка */
  bankCity?: Maybe<Scalars['String']>;
  /** БИК */
  bik?: Maybe<Scalars['String']>;
  /** Формат типа бизнеса */
  businessType: ContractBusinessType;
  /** Кор. счёт */
  correspondence?: Maybe<Scalars['String']>;
  customFuelDiscount?: Maybe<Array<ContractCustumFuelDiscount>>;
  /** Дата заключения контракта */
  date?: Maybe<Scalars['String']>;
  /** Работа по кэшбэку */
  delayedDiscount?: Maybe<Scalars['Boolean']>;
  /** Скидка */
  discount?: Maybe<Scalars['Float']>;
  /** Документы контракта */
  document?: Maybe<OnlineContractDocument>;
  /** Документы контракта */
  documents?: Maybe<OnlineContractDocuments>;
  /** Электронный документооборот */
  edo?: Maybe<Scalars['Boolean']>;
  /** Дата завершения контракта */
  finishDate?: Maybe<Scalars['String']>;
  /** Признак получения оригиналов контракта */
  got: Scalars['Boolean'];
  /** Уникальный идентификатор компании */
  id: Scalars['ID'];
  /** Номер договора */
  number?: Maybe<Scalars['String']>;
  /** Тип оплаты по контракту */
  paymentType?: Maybe<ContractPaymentType>;
  personalDiscount?: Maybe<Scalars['Boolean']>;
  timezoneOffset: Scalars['Int'];
  /** Тип контракта */
  type: ContractType;
};


/** Онлайн-контракт */
export type OnlineContractDocumentArgs = {
  id: Scalars['ID'];
};

export type OnlineContractDocument = {
  commentary?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  /** Ссылка на скачивание */
  url?: Maybe<Scalars['String']>;
};

export type OnlineContractDocumentData = {
  commentary?: InputMaybe<Scalars['String']>;
};

export type OnlineContractDocuments = {
  count: Scalars['Float'];
  items: Array<OnlineContractDocument>;
};

/** Онлайн-заказ */
export type OnlineOrder = Order & {
  /** Уникальный идентификатор резерва средств */
  bankReserveId?: Maybe<Scalars['ID']>;
  /** Компания-покупатель */
  corp?: Maybe<OrderCorp>;
  /** Дата начала заказа */
  date: Scalars['DateTime'];
  /** Дата завершения заказа */
  finished?: Maybe<Scalars['DateTime']>;
  hasOfflineOrder?: Maybe<Scalars['Boolean']>;
  hasOnlineOrder?: Maybe<Scalars['Boolean']>;
  /** Уникальный идентификатор заказа */
  id: Scalars['ID'];
  /** IP-адрес покупателя */
  ip?: Maybe<Scalars['String']>;
  /** Информация о купленном топливе */
  item?: Maybe<OrderFuelItem>;
  /** Информация о платеже */
  payment?: Maybe<OrderPayment>;
  /** Признак наличия SberId */
  sberId?: Maybe<Scalars['Boolean']>;
  /** Информация по СберСпасибо (если имеется) */
  sberSpasiboDetails?: Maybe<OrderItemSberSpasiboDetails>;
  /** АЗС */
  station?: Maybe<Station>;
  /** Уникальный идентификатор заказа на стороне АЗС */
  stationOrderId?: Maybe<Scalars['ID']>;
  /** Статус заказа */
  status: Scalars['String'];
  /** Текстовая информация о статусе заказа */
  statusMessage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  /** Пользователь приложения */
  user?: Maybe<AppUser>;
};

/** Онлайн-платеж */
export type OnlinePayment = Payment & {
  amount: Scalars['Float'];
  balances: Array<PaymentBalanceItem>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  pan?: Maybe<Scalars['String']>;
  provider: PaymentProvider;
  status: Scalars['String'];
  /** Статус платежа */
  statusDescription?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Онлайн-оплата */
export type OnlinePaymentResponse = PaymentResponse & {
  auto?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

/** Заказ */
export type Order = {
  /** Компания-покупатель */
  corp?: Maybe<OrderCorp>;
  date: Scalars['DateTime'];
  finished?: Maybe<Scalars['DateTime']>;
  hasOfflineOrder?: Maybe<Scalars['Boolean']>;
  hasOnlineOrder?: Maybe<Scalars['Boolean']>;
  /** Уникальный идентификатор заказа */
  id: Scalars['ID'];
  /** IP-адрес покупателя */
  ip?: Maybe<Scalars['String']>;
  /** Информация о платеже */
  payment?: Maybe<OrderPayment>;
  /** Признак наличия SberId */
  sberId?: Maybe<Scalars['Boolean']>;
  sberSpasiboDetails?: Maybe<OrderItemSberSpasiboDetails>;
  station?: Maybe<Station>;
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  /** Пользователь приложения */
  user?: Maybe<AppUser>;
};

/** Детали изменения заказа */
export type OrderChangeResult = {
  /** ID заказа */
  id: Scalars['String'];
  /** Сообщение */
  message?: Maybe<Scalars['String']>;
  /** Статус */
  status: Scalars['String'];
};

/** Компания-покупатель */
export type OrderCorp = {
  /** Автомобиль */
  car?: Maybe<Car>;
  /** Компания */
  company: Company;
  /** Водитель */
  driver?: Maybe<Driver>;
  /** Путевой лист */
  waybill?: Maybe<Waybill>;
};

/** Детали заказа */
export type OrderDetail = {
  /** Детали */
  details?: Maybe<Scalars['String']>;
  /** Почтовый адрес пользователя, изменившего заказ */
  email?: Maybe<Scalars['String']>;
  /** Параметры */
  params?: Maybe<Scalars['String']>;
  /** Статус */
  status: Scalars['String'];
  /** Дата */
  time: Scalars['String'];
};

export type OrderDetails = {
  cost: Scalars['Float'];
  stationCost: Scalars['Float'];
  userCost: Scalars['Float'];
  volume: Scalars['Float'];
};

/** Элемент заказа */
export type OrderFuelItem = OrderItem & {
  /** Итоговая стоимость заправки */
  cost?: Maybe<OrderItemDetails>;
  /** Информация для отчёта (цена минус возврат, если присутствует) */
  costReport?: Maybe<OrderItemRefundDetails>;
  /** Ожидаемая стоимость заправки (т.к. в итоге может быть недолив, перелив и т.д., что приведёт к изменению цены) */
  costReq?: Maybe<OrderItemDetails>;
  /** Информация о скидках */
  discount?: Maybe<OrderItemDetails>;
  /** Информация о купленном топливе */
  fuel: Fuel;
  /** Уникальный идентификатор заказа */
  id?: Maybe<Scalars['ID']>;
  /** Исходные цены заправки (до скидок) */
  prices?: Maybe<OrderItemDetails>;
  /** Номер колонки, на которой осуществлялась заправка */
  pump?: Maybe<Scalars['Int']>;
  /** Количество купленного товара в соответствующих единицах измерения */
  quantity: Scalars['Float'];
  /** Количество купленного товара в соответствующих единицах измерения с учётом возврата */
  quantityReport: Scalars['Float'];
  /** Запрошенное количество товара в соответствующих единицах измерения */
  quantityReq: Scalars['Float'];
  /** Информация о возврате (если таковая имеется) */
  refund?: Maybe<OrderItemRefundDetails>;
  /** Тип элемента */
  type: OrderItemType;
};

/** Элемент заказа */
export type OrderItem = {
  /** Уникальный идентификатор заказа */
  id?: Maybe<Scalars['ID']>;
  /** Количество купленного товара в соответствующих единицах измерения */
  quantity: Scalars['Float'];
  /** Количество купленного товара в соответствующих единицах измерения с учётом возврата */
  quantityReport: Scalars['Float'];
  /** Запрошенное количество товара в соответствующих единицах измерения */
  quantityReq: Scalars['Float'];
  /** Тип элемента */
  type: OrderItemType;
};

/** Сводка по ценам */
export type OrderItemDetails = OrderItemDetailsBase & {
  /** Итоговая стоимость продукта для юр. лица */
  corp?: Maybe<Scalars['Float']>;
  /** Фактическая стоимость товара (цена на АЗС) */
  fact?: Maybe<Scalars['Float']>;
  /** Итоговая стоимость продукта для АЗС */
  station?: Maybe<Scalars['Float']>;
  /** Итоговая стоимость продукта для физ. лица */
  user?: Maybe<Scalars['Float']>;
};

/** Абстрактный класс сводок по ценам */
export type OrderItemDetailsBase = {
  /** Итоговая стоимость продукта для юр. лица */
  corp?: Maybe<Scalars['Float']>;
  /** Фактическая стоимость товара (цена на АЗС) */
  fact?: Maybe<Scalars['Float']>;
  /** Итоговая стоимость продукта для АЗС */
  station?: Maybe<Scalars['Float']>;
  /** Итоговая стоимость продукта для физ. лица */
  user?: Maybe<Scalars['Float']>;
};

/** Сводка по возврату */
export type OrderItemRefundDetails = OrderItemDetailsBase & {
  /** Итоговая стоимость продукта для юр. лица */
  corp?: Maybe<Scalars['Float']>;
  /** Фактическая стоимость товара (цена на АЗС) */
  fact?: Maybe<Scalars['Float']>;
  /** Объём возвращённого топлива, литры */
  quantity?: Maybe<Scalars['Float']>;
  /** Итоговая стоимость продукта для АЗС */
  station?: Maybe<Scalars['Float']>;
  /** Итоговая стоимость продукта для физ. лица */
  user?: Maybe<Scalars['Float']>;
};

/** Информация по СберСпасибо */
export type OrderItemSberSpasiboDetails = {
  /** Количество использованных бонусов */
  costPromotion?: Maybe<Scalars['Float']>;
  /** Количество списанных бонусов */
  credit?: Maybe<Scalars['Float']>;
  /** Количество начисленных бонусов */
  debit?: Maybe<Scalars['Float']>;
  /** Внешний ID заказа */
  oid?: Maybe<Scalars['String']>;
  /** Количество возвращённых бонусов (если был возврат) */
  refund?: Maybe<Scalars['Float']>;
  /** Последний статус заказа */
  status?: Maybe<SberSpasiboStatus>;
  /** ID пользователя */
  subId: Scalars['String'];
};

export enum OrderItemType {
  Fuel = 'fuel',
  Product = 'product'
}

/** Информация о способе оплаты заказа */
export type OrderPayment = {
  cardPan?: Maybe<Scalars['String']>;
  /** Почта */
  email?: Maybe<Scalars['String']>;
  /** ID платежа */
  id?: Maybe<Scalars['String']>;
  loyalty?: Maybe<OrderPaymentLoyalty>;
  /** Маскированный номер карты - 4 цифры */
  maskedPan?: Maybe<Scalars['String']>;
  merchantName?: Maybe<Scalars['String']>;
  rrn?: Maybe<Scalars['String']>;
  /** Источник оплаты [Компания, отдел] */
  source: Array<Scalars['String']>;
  /** Тип платежа, taxi/corp */
  type: Scalars['String'];
};

/** Информация о бонусах Спасибо */
export type OrderPaymentLoyalty = {
  /** Первоначальная сумма, на которую было произведено начисление бонусных баллов */
  approvedAmountAward?: Maybe<Scalars['Float']>;
  /** Сумма баллов к списанию при оплате заказа */
  approvedAmountBonus?: Maybe<Scalars['Float']>;
  /** Подтверждённая сумма заказа, на которую произведено начисление бонусных баллов */
  depositedAmountAward?: Maybe<Scalars['Float']>;
  /** Подтвержденная сумма в баллах для списания на момент запроса */
  depositedAmountBonus?: Maybe<Scalars['Float']>;
  /** Сумма возврата заказа, на которую произведено начисление бонусных баллов */
  refundedAmountAward?: Maybe<Scalars['Float']>;
  /** Сумма возврата в баллах на момент запроса */
  refundedAmountBonus?: Maybe<Scalars['Float']>;
  /** Признак успешности операции начисления */
  successfulAward?: Maybe<Scalars['Boolean']>;
  /** Признак успешности операции списания */
  successfulBonus?: Maybe<Scalars['Boolean']>;
};

/** Информация о товаре в оффлайн-заказе */
export type OrderProductItem = OrderItem & {
  /** Итоговая стоимость товара */
  cost?: Maybe<OrderItemDetails>;
  /** Название группы товара */
  groupName?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор заказа */
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  /** Отображаемые цены на товар на АЗС */
  prices?: Maybe<OrderItemDetails>;
  pump?: Maybe<Scalars['Int']>;
  /** Количество купленного товара в соответствующих единицах измерения */
  quantity: Scalars['Float'];
  /** Количество купленного товара в соответствующих единицах измерения с учётом возврата */
  quantityReport: Scalars['Float'];
  /** Запрошенное количество товара в соответствующих единицах измерения */
  quantityReq: Scalars['Float'];
  /** Краткое наименование товара */
  shortName?: Maybe<Scalars['String']>;
  /** Тип элемента */
  type: OrderItemType;
};

/** Статус заказа */
export type OrderStatusResult = {
  /** Объём топлива, литры */
  quantity: Scalars['Float'];
  /** Статус заказа */
  status: Scalars['Boolean'];
};

export type OrderSummaryItem = {
  /** ? */
  count: Scalars['Int'];
  /** Скидка */
  discount: Scalars['Float'];
  /** Название товара */
  name: Scalars['String'];
  /** Количество */
  quantity: Scalars['Float'];
  /** Полная стоимость */
  total: Scalars['Float'];
  /** @deprecated Не работает */
  volume: Scalars['Float'];
};

/** Выборка заказов */
export type Orders = {
  /** Количество заказов */
  count: Scalars['Int'];
  /** Список заказов */
  items: Array<Order>;
  /** Сводка по заказам */
  summary: Array<OrderSummaryItem>;
};

/** Параметры выборки заказов */
export type OrdersQueryParams = {
  /** Идентификатор автомобиля */
  carId?: InputMaybe<Scalars['String']>;
  /** ID бизнес-карты */
  cardHash?: InputMaybe<Scalars['String']>;
  /** Тип контрактов */
  contractsType?: InputMaybe<Scalars['String']>;
  /** Начальная дата формирования отчёта */
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  /** Конечная дата формирования отчёта */
  dateTo?: InputMaybe<Scalars['DateTime']>;
  /** Идентификатор водителя */
  driverId?: InputMaybe<Scalars['String']>;
  /** Телефон водителя */
  driverPhone?: InputMaybe<Scalars['String']>;
  /** Страница */
  page?: Scalars['Int'];
  /** Идентификатор партнера */
  partnerId?: InputMaybe<Scalars['String']>;
  /** Идентификаторы (под)отделов, для которых формируется отчёт */
  partners?: InputMaybe<Array<Scalars['String']>>;
  /** Тип оплаты */
  paymentType?: InputMaybe<OrdersQueryPaymentType>;
  /** Поисковая строка */
  query?: InputMaybe<Scalars['String']>;
  /** Получить транзакции с ошибками (только для сотрудников FuelUp) */
  showErrors?: InputMaybe<Scalars['Boolean']>;
  /** Размер страницы */
  size?: Scalars['Int'];
  /** Идентификатор АЗС */
  stationId?: InputMaybe<Scalars['String']>;
  /** Отбор заказов по статусу */
  status?: OrdersQueryStatus;
  /** Внешний ID SberSpasibo */
  subId?: InputMaybe<Scalars['String']>;
  /** ID путевого листа */
  waybillId?: InputMaybe<Scalars['String']>;
};

export enum OrdersQueryPaymentType {
  Card = 'card',
  CardBusiness = 'cardBusiness',
  Sberpay = 'sberpay',
  Sberspasibo = 'sberspasibo',
  Taxi = 'taxi'
}

export enum OrdersQueryStatus {
  Active = 'active',
  All = 'all',
  Fail = 'fail',
  Refund = 'refund',
  Success = 'success'
}

export enum OrganizationMode {
  Cards = 'CARDS',
  Drivers = 'DRIVERS',
  Full = 'FULL',
  Inactive = 'INACTIVE',
  Simple = 'SIMPLE'
}

export enum OrganizationType {
  Aggregator = 'AGGREGATOR',
  Azs = 'AZS',
  Internal = 'INTERNAL',
  Taxi = 'TAXI',
  Tk = 'TK'
}

/** Партнер (группа) */
export type Partner = {
  /** Признак, имеет ли отдел подотделы (права доступа пользователя игнорируются) */
  hasChildren?: Maybe<Scalars['Boolean']>;
  /** Признак наличия транзакций в отделе */
  hasTransactions?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Название */
  name: Scalars['String'];
  /** Родительский отдел */
  parent?: Maybe<Partner>;
  /** Статистика */
  statistics?: Maybe<PartnerStatistics>;
  /** Статус */
  status: TaxiPartnerStatus;
};

export type PartnerData = {
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<RecordState>;
};

export type PartnerOffline = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PartnerProduct = {
  discount?: Maybe<Scalars['Float']>;
  internalId: Scalars['Float'];
  productId: Scalars['String'];
  productName: Scalars['String'];
};

export type PartnerProductData = {
  discount?: InputMaybe<Scalars['Float']>;
  internalId: Scalars['Float'];
  productId: Scalars['String'];
  productName: Scalars['String'];
};

export type PartnerProductGroup = {
  discount?: Maybe<Scalars['Float']>;
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  internalId: Scalars['Float'];
  parentGroupId?: Maybe<Scalars['String']>;
  products?: Maybe<Array<PartnerProduct>>;
};

export type PartnerProductGroupData = {
  discount?: InputMaybe<Scalars['Float']>;
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  internalId: Scalars['Float'];
  parentGroupId?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<PartnerProductData>>;
};

export type PartnerSettings = {
  osnovans?: Maybe<Array<Scalars['Float']>>;
};

export type PartnerSettingsData = {
  osnovans?: InputMaybe<Array<Scalars['Float']>>;
};

/** Статистика партнера (группы) */
export type PartnerStatistics = {
  /** Количество автомобилей */
  carsCount: Scalars['Int'];
  /** Количество водителей */
  driversCount: Scalars['Int'];
  /** Количество водителей, прошедших регистрацию */
  registeredDriversCount: Scalars['Int'];
};

/** Транзакция */
export type Payment = {
  amount: Scalars['Float'];
  balances: Array<PaymentBalanceItem>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  provider: PaymentProvider;
  status: Scalars['String'];
  /** Статус платежа */
  statusDescription?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Баланс */
export type PaymentBalanceItem = {
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
};

/** Сохраненная карта */
export type PaymentCard = {
  id: Scalars['ID'];
  name: Scalars['String'];
  provider: PaymentProvider;
};

/** Провайдер оплаты */
export type PaymentProvider = {
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Сервис оплаты */
  service: PaymentService;
  /** Тип оплаты */
  type: PaymentType;
};

export type PaymentResponse = {
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export enum PaymentService {
  Invoice = 'INVOICE',
  Sberbank = 'SBERBANK',
  Sbid = 'SBID'
}

export enum PaymentType {
  Card = 'CARD',
  Invoice = 'INVOICE'
}

/** Информация по платежам компании */
export type Payments = {
  /** Баланс */
  balance: Scalars['Float'];
  /** Список карт */
  cards: Array<PaymentCard>;
  /** Количество платежей */
  count: Scalars['Int'];
  /** Список платежей */
  items: Array<Payment>;
  /** Признак необходимости пополнить баланс */
  needMoney: Scalars['Boolean'];
};


/** Информация по платежам компании */
export type PaymentsItemsArgs = {
  filter?: InputMaybe<PaymentsQueryParams>;
};

export type PaymentsQueryParams = {
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};

export type Product = {
  productId: Scalars['Float'];
  productName: Scalars['String'];
};

export type ProductGroup = {
  groupId: Scalars['Float'];
  groupName: Scalars['String'];
  products?: Maybe<Array<Product>>;
};

export type Query = {
  /** Кабинет пользователя */
  cabinet?: Maybe<Cabinet>;
  /** Доступные цвета */
  colors?: Maybe<Array<Color>>;
  /** Часто задаваемые вопросы */
  faq?: Maybe<Array<Faq>>;
  fuel: Array<Fuel>;
  fuelGroups: Array<FuelGroup>;
  /** Обертка для получения статуса заказа */
  getOrderStatus: OrderStatusResult;
  getOrganizationData: ConstraintsContractsData;
  getStationGroups?: Maybe<Array<StationGroupDetails>>;
  /** Обертка для методов платежных поручений */
  invoices: InvoicesData;
  paymentProviders: Array<PaymentProvider>;
  productCatalog: Array<ProductGroup>;
  regions: Array<Region>;
  /** Задача */
  run?: Maybe<Run>;
  /** Задачи */
  runs: Runs;
  /** Скрипт */
  script?: Maybe<Script>;
  /** Скрипты */
  scripts: Array<Script>;
  /** Поиск АЗС по идентификатору */
  station?: Maybe<Station>;
  stations: Array<Station>;
  /** Поиск станций заправок. Обязательно нужно указать или bounds, или point! */
  stationsByES: Stations;
  /** Поиск организации */
  suggest: Array<SuggestCompany>;
  /** Список АСУ */
  systems?: Maybe<Array<StationSystem>>;
};


export type QueryGetOrderStatusArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationDataArgs = {
  getPartnerId?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryPaymentProvidersArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
};


export type QueryRunArgs = {
  id: Scalars['Int'];
};


export type QueryRunsArgs = {
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type QueryScriptArgs = {
  id: Scalars['Int'];
};


export type QueryStationArgs = {
  id: Scalars['ID'];
};


export type QueryStationsByEsArgs = {
  bounds?: InputMaybe<Array<Array<Scalars['Float']>>>;
  fuels?: InputMaybe<Array<Scalars['Int']>>;
  offset?: Scalars['Int'];
  point?: InputMaybe<Array<Scalars['Float']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  sort?: InputMaybe<StationsSort>;
  sortDir?: InputMaybe<SortDirection>;
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type QuerySuggestArgs = {
  query: Scalars['String'];
};

/** Стандартные параметры выборки */
export type QueryParams = {
  /** Начальная дата формирования отчёта */
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  /** Конечная дата формирования отчёта */
  dateTo?: InputMaybe<Scalars['DateTime']>;
  /** Страница */
  page?: Scalars['Int'];
  /** Поисковый запрос */
  query?: InputMaybe<Scalars['String']>;
  /** Размер страницы */
  size?: Scalars['Int'];
};

/** Состояние записи */
export enum RecordState {
  /** Активна */
  Active = 'ACTIVE',
  /** Архивирована */
  Archived = 'ARCHIVED',
  /** Удалена */
  Deleted = 'DELETED',
  /** Неактивна */
  Inactive = 'INACTIVE'
}

/** Регион */
export type Region = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum ReportFormat {
  Csv = 'csv',
  Excel = 'excel',
  Pdf = 'pdf'
}

export type ReportGroup = {
  cardCount?: Maybe<Scalars['Int']>;
  credit: Scalars['Float'];
  creditCount: Scalars['Int'];
  debit: Scalars['Float'];
  debitCount: Scalars['Int'];
  month: Scalars['Int'];
  returns: Scalars['Float'];
  year: Scalars['Int'];
};

export type ReportItem = {
  balance: Scalars['Float'];
  credit: Scalars['Float'];
  day: Scalars['Int'];
  debit: Scalars['Float'];
  returns: Scalars['Float'];
};

export enum ReportStatusFilter {
  Active = 'active',
  Error = 'error',
  Refund = 'refund',
  Success = 'success'
}

export enum ReportType {
  Car = 'CAR',
  Default = 'DEFAULT'
}

/** Водитель */
export type Rider = {
  id: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

/** Задача */
export type Run = {
  /** Дата запуска задачи */
  date?: Maybe<Scalars['DateTime']>;
  /** ID задачи */
  id: Scalars['ID'];
  /** Параметры задачи */
  params: Scalars['String'];
  /** Скрипт */
  script?: Maybe<Script>;
  /** Статус задачи */
  state: RunState;
  user?: Maybe<LkUser>;
};

/** Результат запуска задачи */
export type RunResult = {
  /** Результат в формате json (опционально) */
  data?: Maybe<Scalars['String']>;
  /** Статус */
  status: RunResultStatus;
};

export enum RunResultStatus {
  Created = 'created',
  Error = 'error',
  Ok = 'ok'
}

export enum RunState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED'
}

/** Результат выборки задач */
export type Runs = {
  /** Количество задач */
  count: Scalars['Int'];
  /** Список задач */
  items: Array<Run>;
};

/** Онлайн-оплата */
export type SberInvoicePaymentResponse = PaymentResponse & {
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

/** Статус СберСпасибо */
export enum SberSpasiboStatus {
  /** Подтверждённый чек */
  Cld = 'CLD',
  /** Отмена чека */
  Cnd = 'CND',
  /** Списание бонусов */
  Hld = 'HLD',
  /** Регистрация чека */
  New = 'NEW',
  /** Возврат товара по чеку */
  Prf = 'PRF',
  /** Подтверждение чека (после возврата) */
  Rcf = 'RCF'
}

/** Скрипт */
export type Script = {
  /** Параметры */
  args: Scalars['String'];
  /** Точка входа */
  entry: Scalars['String'];
  /** ID скрипта */
  id: Scalars['ID'];
  /** Название скрипта */
  name: Scalars['String'];
  /** Наличие предпросмотра */
  preview: Scalars['Boolean'];
  /** Порядковый номер */
  sorting: Scalars['Float'];
};

export type SettlementItem = {
  costFact: Scalars['Float'];
  costFirm: Scalars['Float'];
  costRefund: Scalars['Float'];
  firmCostRefund: Scalars['Float'];
  /** Название компании */
  name: Scalars['String'];
  /** Название топлива (95, 98+ и т.д.) */
  shortName: Scalars['String'];
  volumeFact: Scalars['Float'];
  volumeRefund: Scalars['Float'];
};

export type SettlementsItem = {
  companyId?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
  contract?: Maybe<Scalars['String']>;
  contractId?: Maybe<Scalars['String']>;
  contractType?: Maybe<Scalars['String']>;
  costFact: Scalars['Float'];
  costPromotion: Scalars['Float'];
  costPromotionRefund: Scalars['Float'];
  costRefund: Scalars['Float'];
  credit: Scalars['Float'];
  debit: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  payments: Scalars['Float'];
  refunds: Scalars['Float'];
  saldoIn: Scalars['Float'];
  saldoOut: Scalars['Float'];
  volumeFact: Scalars['Float'];
  volumeRefund: Scalars['Float'];
};

export enum SettlementsReportType {
  AccountTopups = 'accountTopups',
  AcquiringTopups = 'acquiringTopups',
  B2b1c = 'b2b1c',
  B2cCorpClients1c = 'b2cCorpClients1c',
  Default = 'default',
  IndividualsAmounts = 'individualsAmounts',
  OfflineOrdersByClientByDate = 'offlineOrdersByClientByDate',
  SberLeasingClients = 'sberLeasingClients',
  SberLogisticsSupplies = 'sberLogisticsSupplies',
  SberSpasibo = 'sberSpasibo',
  Stations = 'stations',
  Stations1c = 'stations1c',
  StationsOffline = 'stationsOffline',
  Taxi = 'taxi',
  TaxiOffline = 'taxiOffline'
}

/** Запись об авторизации в мобильном приложении (MA) */
export type SmsLimit = Limit & {
  /** Номер телефона */
  phone: Scalars['String'];
  /** Тип записи лимита */
  type: Scalars['String'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

/** Шаблон платёжного поручения */
export type StatementPattern = {
  /** Комментарий */
  commentary: Scalars['String'];
  /** Название фирмы-получателя */
  companyName: Scalars['String'];
  /** Название контракта фирмы-получателя */
  contractName: Scalars['String'];
  /** Внутренний ID ПП */
  id: Scalars['ID'];
  /** Шаблон */
  pattern: Scalars['String'];
  /** Название фирмы-плательщика */
  payerName?: Maybe<Scalars['String']>;
};

/** Шаблон платёжного поручения */
export type StatementPatternData = {
  /** Комментарий */
  commentary: Scalars['String'];
  /** Id фирмы-получателя */
  companyId: Scalars['String'];
  /** Id контракта фирмы-получателя */
  contractId: Scalars['String'];
  /** Шаблон */
  pattern: Scalars['String'];
  /** Id фирмы-плательщика */
  payerId: Scalars['String'];
};

/** Выписка по счёту */
export type StatementReceipt = {
  /** Счёт */
  account: Scalars['String'];
  /** Сумма */
  amount: Scalars['String'];
  /** Контракт компании */
  contractId?: Maybe<Scalars['String']>;
  /** Название контрагента */
  contragent: Scalars['String'];
  /** Дата платежа */
  date: Scalars['String'];
  /** Направление платежа (списание/поступление) */
  direction: Scalars['String'];
  /** Внутренний ID выписки по счёту */
  id: Scalars['ID'];
  /** ИНН плательщика */
  inn: Scalars['String'];
  /** Сообщение от ошибках */
  message?: Maybe<Scalars['String']>;
  /** Номер транзакции */
  number: Scalars['String'];
  /** Организация */
  organizationId?: Maybe<Scalars['String']>;
  /** Назначение платежа */
  purpose: Scalars['String'];
  /** Статус платежа */
  status: Scalars['String'];
};

/** Договор по реквизитам плательщика */
export type StatementReceiptContract = {
  /** Номер договора */
  contract: Scalars['String'];
  /** Внутренний ID договора */
  id: Scalars['ID'];
};

/** Выписки по счетам */
export type StatementsReceipts = {
  /** Количество выписок */
  count: Scalars['Int'];
  /** Выписки */
  items: Array<StatementReceipt>;
};

/** Параметры выборки выписок по счетам */
export type StatementsReceiptsQueryParams = {
  /** Начальная дата формирования отчёта */
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  /** Конечная дата формирования отчёта */
  dateTo?: InputMaybe<Scalars['DateTime']>;
  /** Страница */
  page?: Scalars['Int'];
  /** Поисковый запрос */
  query?: InputMaybe<Scalars['String']>;
  /** Размер страницы */
  size?: Scalars['Int'];
  /** Фильтр по статусу */
  status?: InputMaybe<Scalars['String']>;
};

/** АЗС */
export type Station = {
  /** Название автоматической системы управления станцией */
  acs?: Maybe<Scalars['String']>;
  /** Адрес */
  address?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  /** Клиентский сертификат для ServioPump (только для сотрудников FuelUp) */
  certificate?: Maybe<Scalars['String']>;
  /** Срок действия сертификата (только для сотрудников FuelUp) */
  certificateExpiration?: Maybe<Scalars['DateTime']>;
  /** Ключ от клиентского сертификата для ServioPump (только для сотрудников FuelUp) */
  certificateKey?: Maybe<Scalars['String']>;
  /** Цвет станции на карте */
  color?: Maybe<Scalars['String']>;
  /** ID контракта (только для сотрудников FuelUp) */
  contractId?: Maybe<Scalars['String']>;
  /** При поиске: расстояние от водителя или центра области в метрах */
  distance?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  /** Параметры интеграции */
  integration?: Maybe<StationIntegration>;
  /** Признак активности */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Дата последней индексации */
  lastIndexed?: Maybe<Scalars['DateTime']>;
  /** Дата последней активности */
  lastOnline?: Maybe<Scalars['DateTime']>;
  /** Режим работы пистолета станции */
  mode?: Maybe<StationModeInfo>;
  /** Название станции */
  name: Scalars['String'];
  /** Название станции (api) */
  nameApi: Scalars['String'];
  /** Адрес организации */
  officialAddress?: Maybe<Scalars['String']>;
  /** ID организации (только для сотрудников FuelUp) */
  organizationId?: Maybe<Scalars['String']>;
  /** Название организации */
  organizationName?: Maybe<Scalars['String']>;
  /** Внешний идентификатор станции */
  partnerExtId?: Maybe<Scalars['String']>;
  /** Координаты в формате [lat, lng] */
  point?: Maybe<Array<Scalars['Float']>>;
  /** Стоимость топлива по этой станции */
  prices: Array<StationFuelPrice>;
  /** Сообщение на станции (промо) */
  promo?: Maybe<Scalars['String']>;
  /** Код региона станции */
  region?: Maybe<Scalars['String']>;
  /** Состояние */
  state: StationState;
  /** Информация о состоянии */
  stateDetails?: Maybe<StationStateDetails>;
  /** Логи состояний */
  stateLogs?: Maybe<StationStageLogs>;
  /** Скидки по видам топлива на АЗС */
  stationFuelDiscounts: Array<StationFuelDiscount>;
  /** Название станции */
  stationName?: Maybe<Scalars['String']>;
  /** Статус */
  status?: Maybe<StationStatus>;
};


/** АЗС */
export type StationStateLogsArgs = {
  filter: QueryParams;
};

export type StationFuelDiscount = {
  discount: Scalars['Float'];
  fuel: Scalars['Float'];
  id: Scalars['ID'];
};

/** Топливо */
export type StationFuelPrice = {
  fuel: Fuel;
  price: Scalars['Float'];
  pumps?: Maybe<Array<Scalars['Int']>>;
};

export type StationGroupDetails = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Параметры интеграции */
export type StationIntegration = {
  login: Scalars['String'];
  password?: Maybe<Scalars['String']>;
};

export enum StationMode {
  After = 'After',
  Before = 'Before',
  Both = 'Both'
}

export type StationModeInfo = {
  message?: Maybe<Scalars['String']>;
  type: StationMode;
};

/** Параметры автоматической системы управления (АСУ) */
export type StationPartner = {
  /** Ключ API */
  apiKey?: Maybe<Scalars['String']>;
  /** Название протокола */
  apiType?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['ID'];
  /** Название АЗС? */
  name: Scalars['String'];
  /** Исходящие данные (копия apiKey + apiUrl) */
  outgoing?: Maybe<Scalars['String']>;
  /** АСУ */
  system?: Maybe<StationSystem>;
};

export type StationPartnerData = {
  /** Ключ API */
  apiKey?: InputMaybe<Scalars['String']>;
  /** Адрес API */
  apiUrl?: InputMaybe<Scalars['String']>;
  /** Айди АСУ */
  systemId?: InputMaybe<Scalars['ID']>;
};

export type StationPartnerFuel = {
  ename?: Maybe<Scalars['String']>;
  fuelId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  partnerFuelId: Scalars['String'];
};

export type StationPartnerFuelData = {
  ename?: InputMaybe<Scalars['String']>;
  fuelId: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
  partnerFuelId: Scalars['String'];
};

export type StationStageLog = {
  commentary: Scalars['String'];
  date: Scalars['DateTime'];
  state: StationState;
  user: Scalars['String'];
};

export type StationStageLogs = {
  count: Scalars['Float'];
  items: Array<StationStageLog>;
};

export enum StationState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type StationStateDetails = {
  commentary: Scalars['String'];
  date: Scalars['String'];
  email?: Maybe<Scalars['String']>;
};

export enum StationStatus {
  Offline = 'offline',
  Online = 'online',
  Unknown = 'unknown'
}

/** Автоматическая система управления (АСУ) */
export type StationSystem = {
  /** Идентификатор АСУ */
  id: Scalars['ID'];
  /** Мониторинг АСУ */
  isPing: Scalars['Boolean'];
  /** Название АСУ */
  name?: Maybe<Scalars['String']>;
  /** Протокол АСУ */
  protocol?: Maybe<Scalars['String']>;
};

export type StationSystemData = {
  /** Идентификатор АСУ */
  id: Scalars['ID'];
  /** Статус мониторинга */
  isPing?: InputMaybe<Scalars['Boolean']>;
};

/** Результат поиска станций заправок */
export type Stations = {
  /** Количество активных станций */
  active: Scalars['Int'];
  /** Количество найденных станций */
  count: Scalars['Int'];
  /** Список найденных станций */
  items: Array<Station>;
  /** Статистика по АЗС */
  status: Array<StationsStatus>;
};

export type StationsGroup = {
  contractDiscount: FuelDiscount;
  contractDiscounts: FuelDiscounts;
  description: Scalars['String'];
  discountsGroups: FuelDiscountsGroups;
  id: Scalars['ID'];
  name: Scalars['String'];
  stations: Stations;
};


export type StationsGroupContractDiscountArgs = {
  id: Scalars['ID'];
};


export type StationsGroupContractDiscountsArgs = {
  contractId: Scalars['ID'];
};


export type StationsGroupDiscountsGroupsArgs = {
  filter: QueryParams;
};


export type StationsGroupStationsArgs = {
  filter: QueryParams;
};

export type StationsGroupQueryParams = {
  /** Начальная дата формирования отчёта */
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  /** Конечная дата формирования отчёта */
  dateTo?: InputMaybe<Scalars['DateTime']>;
  /** Страница */
  page?: Scalars['Int'];
  /** Поисковый запрос */
  query?: InputMaybe<Scalars['String']>;
  /** Размер страницы */
  size?: Scalars['Int'];
  sort?: InputMaybe<StationsGroupSort>;
  sortDir?: InputMaybe<SortDirection>;
};

export enum StationsGroupSort {
  Name = 'name'
}

export type StationsGroups = {
  count: Scalars['Int'];
  items: Array<StationsGroup>;
};

export enum StationsSort {
  Acs = 'acs',
  LastOnline = 'lastOnline',
  OrganizationName = 'organizationName',
  StationName = 'stationName',
  TurnOffDate = 'turnOffDate',
  TurnOffUser = 'turnOffUser'
}

export type StationsStateLogsGroup = {
  commentary: Scalars['String'];
  date: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  state: StationState;
};

export type StationsStateLogsGroups = {
  count: Scalars['Float'];
  items: Array<StationsStateLogsGroup>;
};

/** Статистика по статусам АЗС */
export type StationsStatus = {
  count: Scalars['Int'];
  status: StationStatus;
};

/** Информация о компании */
export type SuggestCompany = {
  /** Адрес */
  address?: Maybe<Scalars['String']>;
  /** ИНН */
  inn?: Maybe<Scalars['String']>;
  /** КПП */
  kpp?: Maybe<Scalars['String']>;
  /** Название */
  name: Scalars['String'];
  /** ОГРН */
  ogrn?: Maybe<Scalars['String']>;
  /** Тип */
  type?: Maybe<Scalars['String']>;
};

export type SummaryByFuelTypeItem = {
  costFact: Scalars['Float'];
  costFirm: Scalars['Float'];
  costRefund: Scalars['Float'];
  firmCostRefund: Scalars['Float'];
  /** Название топлива (95, 98+ и т.д.) */
  shortName?: Maybe<Scalars['String']>;
  volumeFact: Scalars['Float'];
  volumeRefund: Scalars['Float'];
};

export type TkCompany = Company & {
  /** Ссылка на отчет с транзакциями */
  accountantDashboardReportUrl: Scalars['String'];
  /** Дополнительная информация */
  additional: CompanyAdditional;
  /** Пользователь API */
  apiUser?: Maybe<ApiUser>;
  /** Пользователи API */
  apiUsers: ApiUsersQuery;
  /** B2B */
  b2b: Scalars['Boolean'];
  /** Бренд */
  brand?: Maybe<Scalars['String']>;
  /** Контакт бухгалтера */
  buh: CompanyContact;
  /** Автомобиль */
  car?: Maybe<Car>;
  /** Бизнес-карты */
  cards?: Maybe<Cards>;
  cars: Cars;
  /** Тип компании */
  companyType?: Maybe<Scalars['String']>;
  /** Контактное лицо */
  contact?: Maybe<Scalars['String']>;
  /** Контракт */
  contract?: Maybe<Contract>;
  /** Контракты компании */
  contracts: Array<Contract>;
  /** Отделы/подотделы */
  departments: Array<Department>;
  /** Контактное лицо */
  director?: Maybe<Scalars['String']>;
  /** Ссылка на отчет с транзакциями */
  downloadStatementsReceiptsReport: Scalars['String'];
  /** Водитель */
  driver?: Maybe<Driver>;
  /** Водители */
  drivers: Drivers;
  /** Контактный Email */
  email?: Maybe<Scalars['String']>;
  getBalanceReportLink?: Maybe<Scalars['String']>;
  getCompanyStationsByConstraints: Stations;
  getConstraintsByAZS: ConstraintsAzsItems;
  getConstraintsByContracts: ConstraintsContracts;
  getStationsByCompany: Stations;
  id: Scalars['ID'];
  /** ИНН */
  inn?: Maybe<Scalars['String']>;
  integrationsReportLink?: Maybe<Scalars['String']>;
  /** КПП */
  kpp?: Maybe<Scalars['String']>;
  /** Лимиты */
  limits: Limits;
  /** Логи */
  logs: Logs;
  /** Режим отображения */
  mode: OrganizationMode;
  monthlyReportLink: Scalars['String'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Отправленные сообщения */
  notifications: Notifications;
  /** Официальный адрес */
  officialAddress?: Maybe<Scalars['String']>;
  /** ОГРН (ОГРНИП) */
  ogrn?: Maybe<Scalars['String']>;
  /** Детали заказа компании */
  orderDetails: Array<OrderDetail>;
  /** Заказ */
  orderNew?: Maybe<Order>;
  /** Заказы */
  ordersNew: Orders;
  ordersNewReportLink?: Maybe<Scalars['String']>;
  ordersReportLink?: Maybe<Scalars['String']>;
  /** Группы/подгруппы */
  partner?: Maybe<Partner>;
  /** Группы/подгруппы */
  partners: Array<Partner>;
  /** Платежи компании */
  payments: Payments;
  /** Контактный телефон */
  phone?: Maybe<Scalars['String']>;
  /** Почтовый адрес */
  postAddress?: Maybe<Scalars['String']>;
  profitabilityReportUrl: Scalars['String'];
  /** Дата регистрации */
  registered: Scalars['DateTime'];
  /** Отчет по балансу */
  report: Array<ReportItem>;
  /** Тип отчетов */
  reportType: ReportType;
  /** Отчеты по балансу */
  reports: Array<ReportGroup>;
  /** Роль авторизованного пользователя */
  role: Scalars['String'];
  /** Взаиморасчёт */
  settlement: Array<SettlementItem>;
  /** Ссылка на скачивание взаиморасчёта с компанией по контракту */
  settlementLink: Scalars['String'];
  /** Взаиморасчёты */
  settlements: Array<SettlementsItem>;
  /** Ссылка на скачивание взаиморасчётов */
  settlementsLink: Scalars['String'];
  /** Режим отображения (простой/полный) */
  simple: Scalars['Boolean'];
  /** Источник */
  source?: Maybe<Scalars['String']>;
  /** Статистика транспортной компании */
  stat: CompanyStat;
  /** Поиск контрактов по реквизитам плательщика */
  statementReceiptContracts: Array<StatementReceiptContract>;
  /** Шаблоны платёжных поручений */
  statementsPatterns: Array<StatementPattern>;
  /** Выписки по счёту */
  statementsReceipts: StatementsReceipts;
  /** АЗС компании */
  station?: Maybe<Station>;
  /** Станции АЗС */
  stations: Stations;
  /** Логи состояний */
  stationsStateLogsGroups?: Maybe<StationsStateLogsGroups>;
  /** Статус */
  status: CompanyStatus;
  /** Свод по видам топлива */
  summaryByFuelType: Array<SummaryByFuelTypeItem>;
  /** Ссылка на скачивание свода по видам топлива */
  summaryByFuelTypeLink: Scalars['String'];
  /** Контакт технического отдела */
  tech: CompanyContact;
  /** Шаблоны сообщений */
  templates: NotificationTemplates;
  /** Ссылка на отчет с транзакциями */
  terBankReportUrl: Scalars['String'];
  /** Тип доступа */
  type: Scalars['String'];
  /** Обновлённые станции */
  updatedStations?: Maybe<UpdatedStations>;
  /** Пользователь */
  user?: Maybe<User>;
  /** Права доступа текущего пользователя */
  userAccess?: Maybe<Array<CompanyUserAccess>>;
  /** Пользователи */
  users: UsersQuery;
  /** Признак верификации компании */
  verified: Scalars['Boolean'];
  /** Путевой лист */
  waybill: Waybill;
  /** Путевые листы */
  waybills: Waybills;
};


export type TkCompanyAccountantDashboardReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanyApiUserArgs = {
  phone: Scalars['String'];
};


export type TkCompanyApiUsersArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type TkCompanyCarArgs = {
  id: Scalars['ID'];
};


export type TkCompanyCarsArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type TkCompanyContractsArgs = {
  contractsSubtype?: InputMaybe<Array<ContractSubtype>>;
  contractsType?: InputMaybe<ContractType>;
};


export type TkCompanyDriverArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type TkCompanyDriversArgs = {
  page?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: RecordState;
  status?: InputMaybe<DriverStatus>;
};


export type TkCompanyGetBalanceReportLinkArgs = {
  month: Scalars['String'];
};


export type TkCompanyGetCompanyStationsByConstraintsArgs = {
  filter: QueryParams;
};


export type TkCompanyGetConstraintsByAzsArgs = {
  filter: QueryParams;
};


export type TkCompanyGetConstraintsByContractsArgs = {
  filter: ConstraintsContractsQueryParams;
};


export type TkCompanyGetStationsByCompanyArgs = {
  filter?: InputMaybe<QueryParams>;
};


export type TkCompanyLimitsArgs = {
  filter: LimitsQueryParams;
};


export type TkCompanyLogsArgs = {
  filter: LogsQueryParams;
};


export type TkCompanyMonthlyReportLinkArgs = {
  month: Scalars['String'];
};


export type TkCompanyNotificationsArgs = {
  filter: NotificationsQueryParams;
};


export type TkCompanyOrderDetailsArgs = {
  id: Scalars['ID'];
};


export type TkCompanyOrderNewArgs = {
  id: Scalars['ID'];
};


export type TkCompanyOrdersNewArgs = {
  filter: OrdersQueryParams;
};


export type TkCompanyOrdersNewReportLinkArgs = {
  filter: OrdersQueryParams;
  format?: ReportFormat;
};


export type TkCompanyOrdersReportLinkArgs = {
  format?: ReportFormat;
  from: Scalars['DateTime'];
  stationId?: InputMaybe<Scalars['ID']>;
  status?: ReportStatusFilter;
  to: Scalars['DateTime'];
};


export type TkCompanyPartnersArgs = {
  state?: RecordState;
};


export type TkCompanyProfitabilityReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanyReportArgs = {
  month: Scalars['ID'];
};


export type TkCompanySettlementArgs = {
  contractId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanySettlementLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanySettlementsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanySettlementsLinkArgs = {
  companyType?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  reportType: SettlementsReportType;
  to: Scalars['String'];
};


export type TkCompanyStatementReceiptContractsArgs = {
  statementReceiptId: Scalars['ID'];
};


export type TkCompanyStatementsReceiptsArgs = {
  filter: StatementsReceiptsQueryParams;
};


export type TkCompanyStationArgs = {
  id: Scalars['ID'];
};


export type TkCompanyStationsArgs = {
  contractsType?: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  page?: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Array<StationState>>;
  status?: InputMaybe<StationStatus>;
};


export type TkCompanyStationsStateLogsGroupsArgs = {
  filter: QueryParams;
};


export type TkCompanySummaryByFuelTypeArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanySummaryByFuelTypeLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanyTemplatesArgs = {
  filter: NotificationsTemplatesQueryParams;
};


export type TkCompanyTerBankReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanyUpdatedStationsArgs = {
  filter: QueryParams;
};


export type TkCompanyUserArgs = {
  id: Scalars['ID'];
};


export type TkCompanyUsersArgs = {
  filter?: UsersQueryParams;
  query?: InputMaybe<Scalars['String']>;
};


export type TkCompanyWaybillArgs = {
  id: Scalars['ID'];
};


export type TkCompanyWaybillsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
};

/** Транспортная компания */
export type Taxi = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum TaxiPartnerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Статистика по статусам АЗС */
export type UpdatedStation = {
  address: Scalars['String'];
  addressApi: Scalars['String'];
  id: Scalars['ID'];
  lat: Scalars['Float'];
  latApi: Scalars['Float'];
  lng: Scalars['Float'];
  lngApi: Scalars['Float'];
  name: Scalars['String'];
  nameApi: Scalars['String'];
  organizationName: Scalars['String'];
};

/** Статистика по статусам АЗС */
export type UpdatedStations = {
  count: Scalars['Int'];
  items: Array<UpdatedStation>;
};

export type User = {
  id?: Maybe<Scalars['ID']>;
  phone?: Maybe<Scalars['String']>;
};

/** Данные для добавления пользователя */
export type UserData = {
  /** Адрес электронной почты */
  email?: InputMaybe<Scalars['String']>;
  /** Имя */
  name?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<Array<Scalars['ID']>>;
  /** Телефон */
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UsersRoles>;
};

/** Выборка заказов */
export type UsersQuery = {
  /** Количество пользователей */
  count: Scalars['Int'];
  /** Список пользователей */
  items: Array<User>;
};

/** Параметры выборки пользователей */
export type UsersQueryParams = {
  /** Страница */
  page?: Scalars['Int'];
  /** Размер страницы */
  size?: Scalars['Int'];
};

export enum UsersRoles {
  Accountant = 'accountant',
  Admin = 'admin',
  AzsSales = 'azsSales',
  Custom = 'custom',
  FirstLineSupport = 'firstLineSupport',
  Lawyer = 'lawyer',
  Manager = 'manager',
  Sales = 'sales',
  Support = 'support',
  TaxiSales = 'taxiSales',
  User = 'user'
}

/** Путевой лист */
export type Waybill = {
  /** Виды топлива */
  allowedFuels?: Maybe<Array<Scalars['Int']>>;
  /** Виды групп топлива */
  allowedFuelsGroups?: Maybe<Array<Scalars['Int']>>;
  /** Автомобиль */
  car: Car;
  /** Создан */
  createdAt: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
  /** Лимит */
  limit: Scalars['Float'];
  /** Тип лимита (литры/рубли) */
  limitQuantity: Scalars['Boolean'];
  /** Номер */
  number: Scalars['String'];
  /** Автомобиль */
  partner: Car;
  /** Водители */
  riders: WaybillRiders;
  /** Статус */
  state: Scalars['String'];
  /** Выезд */
  validSince: Scalars['String'];
  /** Приезд */
  validTo: Scalars['String'];
};


/** Путевой лист */
export type WaybillRidersArgs = {
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};

/** Водитель путевого листа */
export type WaybillRider = {
  id: Scalars['String'];
  isBlocked: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

/** Водители путевого листа */
export type WaybillRiders = {
  count: Scalars['Int'];
  items: Array<WaybillRider>;
};

/** Путевые листы */
export type Waybills = {
  /** Количество путевых листов */
  count: Scalars['Int'];
  /** Список путевых листов */
  items: Array<Waybill>;
};

export type GetPaymentsByContractIdQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type GetPaymentsByContractIdQuery = { cabinet?: { company?: { payments: { items: Array<{ id: string, type: string, balances: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> } | { id: string, type: string, balances: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> }> } } | { payments: { items: Array<{ id: string, type: string, balances: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> } | { id: string, type: string, balances: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> }> } } | { payments: { items: Array<{ id: string, type: string, balances: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> } | { id: string, type: string, balances: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> }> } } | null } | null };

export type GetStatementsReceiptsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: StatementsReceiptsQueryParams;
}>;


export type GetStatementsReceiptsQuery = { cabinet?: { company?: { statementsReceipts: { count: number, items: Array<{ id: string, number: string, date: string, contragent: string, inn: string, purpose: string, amount: string, status: string, message?: string | null, contractId?: string | null, organizationId?: string | null }> } } | { statementsReceipts: { count: number, items: Array<{ id: string, number: string, date: string, contragent: string, inn: string, purpose: string, amount: string, status: string, message?: string | null, contractId?: string | null, organizationId?: string | null }> } } | { statementsReceipts: { count: number, items: Array<{ id: string, number: string, date: string, contragent: string, inn: string, purpose: string, amount: string, status: string, message?: string | null, contractId?: string | null, organizationId?: string | null }> } } | null } | null };

export type AccountantRestartStatementReceiptMutationVariables = Exact<{
  id: Scalars['ID'];
  customContractId?: InputMaybe<Scalars['ID']>;
  force?: InputMaybe<Scalars['Boolean']>;
}>;


export type AccountantRestartStatementReceiptMutation = { restartStatementReceipt?: boolean | null };

export type GetStatementReceiptContractsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  statementReceiptId: Scalars['ID'];
}>;


export type GetStatementReceiptContractsQuery = { cabinet?: { company?: { statementReceiptContracts: Array<{ id: string, contract: string }> } | { statementReceiptContracts: Array<{ id: string, contract: string }> } | { statementReceiptContracts: Array<{ id: string, contract: string }> } | null } | null };

export type AccountantCancelStatementReceiptMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountantCancelStatementReceiptMutation = { cancelStatementReceipt?: boolean | null };

export type GetStatementsReceiptsReportUrlQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
}>;


export type GetStatementsReceiptsReportUrlQuery = { cabinet?: { company?: { downloadStatementsReceiptsReport: string } | { downloadStatementsReceiptsReport: string } | { downloadStatementsReceiptsReport: string } | null } | null };

export type GetInvoicesQueryVariables = Exact<{
  page: Scalars['Int'];
  size: Scalars['Int'];
  organizationName?: InputMaybe<Scalars['String']>;
  invoiceStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
}>;


export type GetInvoicesQuery = { invoices: { invoicesList: { count: number, total: number, items: Array<{ id: string, createdAt: string, organizationId: string, organizationName: string, contract: string, contractId: string, paymentPurpose: string, amount: number, status: string }> } } };

export type GetInvoiceOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceOrganizationsQuery = { invoices: { fuelUpBankAccount: string, invoiceOrganizations: Array<{ name: string, id: string }> } };

export type CreateInvoicesMutationVariables = Exact<{
  organizations: Array<Scalars['String']> | Scalars['String'];
  invoiceType: InvoiceType;
  bankAccount: Scalars['String'];
  prepayDays: Scalars['Float'];
}>;


export type CreateInvoicesMutation = { createInvoices?: boolean | null };

export type SaveInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  amount: Scalars['Float'];
  paymentPurpose: Scalars['String'];
  status: Scalars['String'];
}>;


export type SaveInvoiceMutation = { saveInvoice?: boolean | null };

export type SubmitInvoicesMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitInvoicesMutation = { submitInvoices?: boolean | null };

export type AccountantFetchOfflineCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  contractsType: Scalars['String'];
  partnerId?: InputMaybe<Scalars['ID']>;
}>;


export type AccountantFetchOfflineCompanyStationsQuery = { regions: Array<{ id: string, name: string }>, cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null, region?: string | null, partnerExtId?: string | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null, region?: string | null, partnerExtId?: string | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null, region?: string | null, partnerExtId?: string | null }>, status: Array<{ status: StationStatus, count: number }> } } | null } | null };

export type AccountantGetCompanyOrdersWithContractsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type AccountantGetCompanyOrdersWithContractsQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type GetStatementsPatternsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetStatementsPatternsQuery = { cabinet?: { company?: { statementsPatterns: Array<{ id: string, payerName?: string | null, companyName: string, contractName: string, pattern: string, commentary: string }> } | { statementsPatterns: Array<{ id: string, payerName?: string | null, companyName: string, contractName: string, pattern: string, commentary: string }> } | { statementsPatterns: Array<{ id: string, payerName?: string | null, companyName: string, contractName: string, pattern: string, commentary: string }> } | null } | null };

export type AddStatementsPatternMutationVariables = Exact<{
  data: StatementPatternData;
}>;


export type AddStatementsPatternMutation = { addStatementsPattern: boolean };

export type DeleteStatementsPatternMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStatementsPatternMutation = { deleteStatementsPattern: boolean };

export type GetProfitabilityReportUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type GetProfitabilityReportUrlQuery = { cabinet?: { company?: { profitabilityReportUrl: string } | { profitabilityReportUrl: string } | { profitabilityReportUrl: string } | null } | null };

export type AdminFetchCompanyUsersQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UsersQueryParams>;
}>;


export type AdminFetchCompanyUsersQuery = { cabinet?: { company?: { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null }> } } | { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null }> } } | { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null }> } } | null } | null };

export type GetAuthLogsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: LogsQueryParams;
}>;


export type GetAuthLogsQuery = { cabinet?: { company?: { logs: { count: number, items: Array<{ date: any, phone: string, logType: string, logName: string, smsCode?: string | null, input?: string | null }>, summary: { total?: number | null, successful?: number | null, errors?: number | null, invalid?: number | null, timeouts?: number | null } } } | { logs: { count: number, items: Array<{ date: any, phone: string, logType: string, logName: string, smsCode?: string | null, input?: string | null }>, summary: { total?: number | null, successful?: number | null, errors?: number | null, invalid?: number | null, timeouts?: number | null } } } | { logs: { count: number, items: Array<{ date: any, phone: string, logType: string, logName: string, smsCode?: string | null, input?: string | null }>, summary: { total?: number | null, successful?: number | null, errors?: number | null, invalid?: number | null, timeouts?: number | null } } } | null } | null };

export type AdminGetCompanyLimitsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: LimitsQueryParams;
}>;


export type AdminGetCompanyLimitsQuery = { cabinet?: { company?: { limits: { count: number, items: Array<{ phone: string }> } } | { limits: { count: number, items: Array<{ phone: string }> } } | { limits: { count: number, items: Array<{ phone: string }> } } | null } | null };

export type AdminResetAuthLimitMutationVariables = Exact<{
  type: Scalars['String'];
  id: Scalars['String'];
}>;


export type AdminResetAuthLimitMutation = { resetAuthLimits: boolean };

export type AdminFetchAzsInfoQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AdminFetchAzsInfoQuery = { cabinet?: { company?: { id: string, name?: string | null, status: CompanyStatus, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }> } | { id: string, name?: string | null, status: CompanyStatus, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }> } | { id: string, name?: string | null, status: CompanyStatus, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }> } | null } | null };

export type AdminGetAzsInfoTabQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type AdminGetAzsInfoTabQuery = { cabinet?: { company?: { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type AdminGetAzsCompanyInfoQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AdminGetAzsCompanyInfoQuery = { cabinet?: { company?: { id: string, name?: string | null, type: string, brand?: string | null, director?: string | null, phone?: string | null, email?: string | null, inn?: string | null, kpp?: string | null, ogrn?: string | null, postAddress?: string | null, officialAddress?: string | null, companyType?: string | null, buh: { name?: string | null, phone?: string | null, email?: string | null }, tech: { name?: string | null, phone?: string | null, email?: string | null }, additional: { commentary?: string | null }, contract?: { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | null, contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null }> } | { id: string, name?: string | null, type: string, brand?: string | null, director?: string | null, phone?: string | null, email?: string | null, inn?: string | null, kpp?: string | null, ogrn?: string | null, postAddress?: string | null, officialAddress?: string | null, companyType?: string | null, buh: { name?: string | null, phone?: string | null, email?: string | null }, tech: { name?: string | null, phone?: string | null, email?: string | null }, additional: { commentary?: string | null }, contract?: { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | null, contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null }> } | { id: string, name?: string | null, type: string, brand?: string | null, director?: string | null, phone?: string | null, email?: string | null, inn?: string | null, kpp?: string | null, ogrn?: string | null, postAddress?: string | null, officialAddress?: string | null, companyType?: string | null, buh: { name?: string | null, phone?: string | null, email?: string | null }, tech: { name?: string | null, phone?: string | null, email?: string | null }, additional: { commentary?: string | null }, contract?: { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | null, contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null }> } | null } | null };

export type AdminGetContractDataQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type AdminGetContractDataQuery = { cabinet?: { company?: { type: string, contract?: { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | null } | { type: string, contract?: { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | null } | { type: string, contract?: { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | null } | null } | null };

export type AdminGetContractDiscountsQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type AdminGetContractDiscountsQuery = { cabinet?: { company?: { contract?: { discount?: number | null } | { discount?: number | null } | { discount?: number | null, customFuelDiscount?: Array<{ fuel: number, discount: number }> | null } | null } | { contract?: { discount?: number | null } | { discount?: number | null } | { discount?: number | null, customFuelDiscount?: Array<{ fuel: number, discount: number }> | null } | null } | { contract?: { discount?: number | null } | { discount?: number | null } | { discount?: number | null, customFuelDiscount?: Array<{ fuel: number, discount: number }> | null } | null } | null } | null };

export type AdminGetStationIntegrationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdminGetStationIntegrationQuery = { cabinet?: { company?: { stationPartner?: { id: string, name: string, outgoing?: string | null, apiType?: string | null, system?: { id: string, name?: string | null, protocol?: string | null, isPing: boolean } | null } | null, stationPartnerFuels?: Array<{ partnerFuelId: string, fuelId: string, name?: string | null, ename?: string | null }> | null } | {} | null } | null, systems?: Array<{ id: string, name?: string | null, protocol?: string | null, isPing: boolean }> | null, fuel: Array<{ id: string, name: string }> };

export type AdminGetSbidAuthLinkStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetSbidAuthLinkStatusQuery = { cabinet?: { isSberBusinessIdLinked?: boolean | null } | null };

export type AdminLinkSberBusinessIdMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AdminLinkSberBusinessIdMutation = { linkSberBusinessId: string };

export type AdminUnlinkSberBusinessIdMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AdminUnlinkSberBusinessIdMutation = { unlinkSberBusinessId?: boolean | null };

export type AdminGetContractDocumentsQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type AdminGetContractDocumentsQuery = { cabinet?: { company?: { contract?: { documents?: { count: number, items: Array<{ id: string, filename: string, commentary?: string | null, createdAt: any }> } | null } | {} | null } | { contract?: { documents?: { count: number, items: Array<{ id: string, filename: string, commentary?: string | null, createdAt: any }> } | null } | {} | null } | { contract?: { documents?: { count: number, items: Array<{ id: string, filename: string, commentary?: string | null, createdAt: any }> } | null } | {} | null } | null } | null };

export type AdminDownloadContractDocumentQueryVariables = Exact<{
  contractId: Scalars['ID'];
  documentId: Scalars['ID'];
}>;


export type AdminDownloadContractDocumentQuery = { cabinet?: { company?: { contract?: { document?: { url?: string | null } | null } | {} | null } | { contract?: { document?: { url?: string | null } | null } | {} | null } | { contract?: { document?: { url?: string | null } | null } | {} | null } | null } | null };

export type AdminEditContractDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  data: OnlineContractDocumentData;
}>;


export type AdminEditContractDocumentMutation = { editContractDocument: boolean };

export type AdminDeleteContractDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminDeleteContractDocumentMutation = { deleteContractDocument: boolean };

export type GetTerBankReportUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type GetTerBankReportUrlQuery = { cabinet?: { company?: { terBankReportUrl: string } | { terBankReportUrl: string } | { terBankReportUrl: string } | null } | null };

export type GetAccountantDashboardReportUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type GetAccountantDashboardReportUrlQuery = { cabinet?: { company?: { accountantDashboardReportUrl: string } | { accountantDashboardReportUrl: string } | { accountantDashboardReportUrl: string } | null } | null };

export type FindCompaniesQueryVariables = Exact<{
  filter: CompaniesFilterParams;
}>;


export type FindCompaniesQuery = { cabinet?: { findCompanies: { items: Array<{ id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }> } } | null };

export type GetCompanyContractsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetCompanyContractsQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | null } | null };

export type IndexOrderMutationVariables = Exact<{
  id: Scalars['String'];
  type: StationStatus;
}>;


export type IndexOrderMutation = { indexOrder: boolean };

export type GetNotificationsTemplatesQueryVariables = Exact<{
  id: Scalars['ID'];
  filter: NotificationsTemplatesQueryParams;
}>;


export type GetNotificationsTemplatesQuery = { cabinet?: { company?: { templates: { count: number, items: Array<{ id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger }> } } | { templates: { count: number, items: Array<{ id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger }> } } | { templates: { count: number, items: Array<{ id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger }> } } | null } | null };

export type CreateNotificationTemplateMutationVariables = Exact<{
  data: NotificationTemplateData;
}>;


export type CreateNotificationTemplateMutation = { createNotificationTemplate: { id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger, createdAt: any } };

export type UpdateNotificationTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: NotificationTemplateData;
}>;


export type UpdateNotificationTemplateMutation = { updateNotificationTemplate: { id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger, createdAt: any } };

export type DeleteNotificationTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNotificationTemplateMutation = { deleteNotificationTemplate: boolean };

export type GetNotificationsQueryVariables = Exact<{
  id: Scalars['ID'];
  filter: NotificationsQueryParams;
}>;


export type GetNotificationsQuery = { cabinet?: { company?: { notifications: { count: number, items: Array<{ recipient: string, message: string, channel: NotificationChannel, status: NotificationStatus, createdAt: any }> } } | { notifications: { count: number, items: Array<{ recipient: string, message: string, channel: NotificationChannel, status: NotificationStatus, createdAt: any }> } } | { notifications: { count: number, items: Array<{ recipient: string, message: string, channel: NotificationChannel, status: NotificationStatus, createdAt: any }> } } | null } | null };

export type GetServerAsuQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServerAsuQuery = { cabinet?: { serverAsu: Array<string> } | null };

export type GetOrderStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrderStatusQuery = { getOrderStatus: { status: boolean, quantity: number } };

export type GetStationsByCompanyQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter?: InputMaybe<QueryParams>;
}>;


export type GetStationsByCompanyQuery = { cabinet?: { company?: { getStationsByCompany: { count: number, items: Array<{ id: string, name: string, address?: string | null }> } } | { getStationsByCompany: { count: number, items: Array<{ id: string, name: string, address?: string | null }> } } | { getStationsByCompany: { count: number, items: Array<{ id: string, name: string, address?: string | null }> } } | null } | null };

export type DeleteStationGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type DeleteStationGroupMutation = { deleteStationGroup: boolean };

export type GetStationGroupsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetStationGroupsQuery = { cabinet?: { stationGroups: Array<{ id: string, name: string, description: string }> } | null };

export type CreateConstraintByContractMutationVariables = Exact<{
  data: ConstraintsContractTemplateData;
}>;


export type CreateConstraintByContractMutation = { createConstraintByContract: { id: string, azsContract: string, corpClientId: string, contractCorpClientId?: string | null, allow: boolean, azsBusinessType?: string | null, azsNumber?: string | null, corpOfficialName?: string | null, contractBusinessType?: string | null, contractNumber?: string | null } };

export type EditConstraintByContractMutationVariables = Exact<{
  data: ConstraintsContractTemplateData;
}>;


export type EditConstraintByContractMutation = { editConstraintByContract: { id: string, azsContract: string, corpClientId: string, contractCorpClientId?: string | null, allow: boolean, azsBusinessType?: string | null, azsNumber?: string | null, corpOfficialName?: string | null, contractBusinessType?: string | null, contractNumber?: string | null } };

export type GetOrganizationDataQueryVariables = Exact<{
  id: Scalars['ID'];
  getPartnerId?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOrganizationDataQuery = { getOrganizationData: { id: string, officialName?: string | null, firmType?: OrganizationType | null, taxiPartnerId?: string | null, contracts?: Array<{ id: string, number?: string | null, businessType?: string | null }> | null } };

export type GetConstraintsByContractsQueryVariables = Exact<{
  id: Scalars['ID'];
  filter: ConstraintsContractsQueryParams;
}>;


export type GetConstraintsByContractsQuery = { cabinet?: { company?: { getConstraintsByContracts: { count: number, items: Array<{ id: string, allow: boolean, corpId: string, officialName?: string | null, contract: { id: string, businessType?: string | null, number?: string | null }, azsContract: { id: string, businessType?: string | null, number?: string | null } }> } } | { getConstraintsByContracts: { count: number, items: Array<{ id: string, allow: boolean, corpId: string, officialName?: string | null, contract: { id: string, businessType?: string | null, number?: string | null }, azsContract: { id: string, businessType?: string | null, number?: string | null } }> } } | { getConstraintsByContracts: { count: number, items: Array<{ id: string, allow: boolean, corpId: string, officialName?: string | null, contract: { id: string, businessType?: string | null, number?: string | null }, azsContract: { id: string, businessType?: string | null, number?: string | null } }> } } | null } | null };

export type RemoveAllConstraintsByContractMutationVariables = Exact<{
  id: Scalars['ID'];
  filter: ConstraintsContractsQueryParams;
}>;


export type RemoveAllConstraintsByContractMutation = { removeAllConstraintsByContract: boolean };

export type EditAllConstraintsByContractMutationVariables = Exact<{
  id: Scalars['ID'];
  filter: ConstraintsContractsQueryParams;
  allow: Scalars['Boolean'];
}>;


export type EditAllConstraintsByContractMutation = { editAllConstraintsByContract: boolean };

export type RemoveConstraintByContractMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveConstraintByContractMutation = { removeConstraintByContract: boolean };

export type GetConstraintsByAzsQueryVariables = Exact<{
  id: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetConstraintsByAzsQuery = { cabinet?: { company?: { getConstraintsByAZS: { count: number, items: Array<{ id: string, taxiPartnerId: string, corpName?: string | null, name?: string | null, address?: string | null }> } } | { getConstraintsByAZS: { count: number, items: Array<{ id: string, taxiPartnerId: string, corpName?: string | null, name?: string | null, address?: string | null }> } } | { getConstraintsByAZS: { count: number, items: Array<{ id: string, taxiPartnerId: string, corpName?: string | null, name?: string | null, address?: string | null }> } } | null } | null };

export type GetCompanyStationsByConstraintsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetCompanyStationsByConstraintsQuery = { cabinet?: { company?: { getCompanyStationsByConstraints: { count: number, items: Array<{ id: string, name: string, address?: string | null }> } } | { getCompanyStationsByConstraints: { count: number, items: Array<{ id: string, name: string, address?: string | null }> } } | { getCompanyStationsByConstraints: { count: number, items: Array<{ id: string, name: string, address?: string | null }> } } | null } | null };

export type CreateConstraintByAzsMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
  stationsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type CreateConstraintByAzsMutation = { createConstraintByAzs: boolean };

export type RemoveAllConstraintsByAzsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type RemoveAllConstraintsByAzsMutation = { removeAllConstraintsByAzs: boolean };

export type RemoveConstraintByAzsMutationVariables = Exact<{
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
}>;


export type RemoveConstraintByAzsMutation = { removeConstraintByAzs: boolean };

export type CarsGetCompanyCarPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  carId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type CarsGetCompanyCarPageQuery = { cabinet?: { company?: { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type CarsRefreshCompanyCarPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  carId: Scalars['ID'];
}>;


export type CarsRefreshCompanyCarPageQuery = { cabinet?: { company?: { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null } | { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null } | { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null } | null } | null };

export type CarsAddCarMutationVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Array<Scalars['ID']> | Scalars['ID'];
  car: CarData;
}>;


export type CarsAddCarMutation = { addCar?: { result: string, message?: string | null } | null };

export type CarsGetCarsByQueryQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type CarsGetCarsByQueryQuery = { cabinet?: { company?: { cars: { items: Array<{ id: string, number: string, partners: Array<{ name: string }> }> } } | { cars: { items: Array<{ id: string, number: string, partners: Array<{ name: string }> }> } } | { cars: { items: Array<{ id: string, number: string, partners: Array<{ name: string }> }> } } | null } | null };

export type CodegenMockQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CodegenMockQuery = { cabinet?: { company?: { id: string } | { id: string } | { id: string } | null } | null };

export type CommonGetCompanyUsersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type CommonGetCompanyUsersQuery = { cabinet?: { company?: { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null, access: Array<{ id: string, partners?: Array<{ id: string, name: string }> | null }> }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null, access: Array<{ id: string, partners?: Array<{ id: string, name: string }> | null }> }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null, access: Array<{ id: string, partners?: Array<{ id: string, name: string }> | null }> }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | null } | null };

export type CommonAddUserMutationVariables = Exact<{
  companyId: Scalars['ID'];
  user: UserData;
}>;


export type CommonAddUserMutation = { addUser?: string | null };

export type CommonRequestUserPasswordResetMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type CommonRequestUserPasswordResetMutation = { sendRestoreUserPasswordEmail: string };

export type CommonDeleteUserMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type CommonDeleteUserMutation = { removeUser?: string | null };

export type CommonSaveCompanyDataMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  data: CompanyData;
}>;


export type CommonSaveCompanyDataMutation = { saveCompany: { result: string, message?: string | null } };

export type CommonFetchCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  contractsType: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StationStatus>;
  partnerId?: InputMaybe<Scalars['ID']>;
}>;


export type CommonFetchCompanyStationsQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null }>, status: Array<{ status: StationStatus, count: number }> } } | null } | null };

export type CommonGetCompanyOrdersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type CommonGetCompanyOrdersQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type CommonDownloadReportQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type CommonDownloadReportQuery = { cabinet?: { company?: { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | null } | null };

export type SetOrganizationModeMutationVariables = Exact<{
  companyId: Scalars['ID'];
  mode: OrganizationMode;
}>;


export type SetOrganizationModeMutation = { setOrganizationMode: boolean };

export type GetCompanyContractsDatesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
}>;


export type GetCompanyContractsDatesQuery = { cabinet?: { company?: { contracts: Array<{ id: string, date?: string | null, finishDate?: string | null } | { id: string, date?: string | null, finishDate?: string | null } | { id: string, date?: string | null, finishDate?: string | null }> } | { contracts: Array<{ id: string, date?: string | null, finishDate?: string | null } | { id: string, date?: string | null, finishDate?: string | null } | { id: string, date?: string | null, finishDate?: string | null }> } | { contracts: Array<{ id: string, date?: string | null, finishDate?: string | null } | { id: string, date?: string | null, finishDate?: string | null } | { id: string, date?: string | null, finishDate?: string | null }> } | null } | null };

export type SaveBulkFuelsMutationVariables = Exact<{
  fuelData: Array<FuelData> | FuelData;
}>;


export type SaveBulkFuelsMutation = { saveBulkFuels: boolean };

export type CompanyAddUserToCompanyMutationVariables = Exact<{
  companyId: Scalars['ID'];
  user: UserData;
}>;


export type CompanyAddUserToCompanyMutation = { addUser?: string | null };

export type RemoveCompanyUserMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveCompanyUserMutation = { removeUser?: string | null };

export type GetCompanyDepartmentStatsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
}>;


export type GetCompanyDepartmentStatsQuery = { cabinet?: { company?: { partners: Array<{ id: string }>, drivers: { count: number }, cars: { count: number } } | { partners: Array<{ id: string }>, drivers: { count: number }, cars: { count: number } } | { partners: Array<{ id: string }>, drivers: { count: number }, cars: { count: number } } | null } | null };

export type AddCompanyDepartmentMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: PartnerData;
  parentId?: InputMaybe<Scalars['ID']>;
  moveDrivers?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddCompanyDepartmentMutation = { addPartner?: { id: string, name: string } | null };

export type CompanyCreateNewContractMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: ContractData;
}>;


export type CompanyCreateNewContractMutation = { createContract: { result: string, message?: string | null } };

export type CompanyUpdateCompanyContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
  data: CompanyData;
}>;


export type CompanyUpdateCompanyContractMutation = { saveCompany: { result: string, message?: string | null } };

export type GetCompanyPaymentsByCompanyIdQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type GetCompanyPaymentsByCompanyIdQuery = { cabinet?: { company?: { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null };

export type GetCompanyPaymentsByContractIdQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type GetCompanyPaymentsByContractIdQuery = { cabinet?: { company?: { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null };

export type GetAdminAzsStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  state: Array<StationState> | StationState;
  status?: InputMaybe<StationStatus>;
  region?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
}>;


export type GetAdminAzsStationsQuery = { cabinet?: { company?: { stationPartner?: { system?: { protocol?: string | null } | null } | null, stations: { active: number, count: number, items: Array<{ id: string, name: string, nameApi: string, brand?: string | null, address?: string | null, color?: string | null, state: StationState, status?: StationStatus | null, groupId?: string | null }> } } | {} | null } | null };

export type GetColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetColorsQuery = { colors?: Array<{ id: string, name?: string | null }> | null };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { regions: Array<{ id: string, name: string }> };

export type GetAdminAzsStationsPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  state: Array<StationState> | StationState;
  status?: InputMaybe<StationStatus>;
  region?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type GetAdminAzsStationsPageQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, brand?: string | null, address?: string | null, color?: string | null, status?: StationStatus | null, state: StationState, point?: Array<number> | null, promo?: string | null, groupId?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, brand?: string | null, address?: string | null, color?: string | null, status?: StationStatus | null, state: StationState, point?: Array<number> | null, promo?: string | null, groupId?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, brand?: string | null, address?: string | null, color?: string | null, status?: StationStatus | null, state: StationState, point?: Array<number> | null, promo?: string | null, groupId?: string | null }> } } | null } | null };

export type GetCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanyStationsQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | null } | null };

export type GetCompaniesQueryVariables = Exact<{
  filter: CompaniesFilterParams;
}>;


export type GetCompaniesQuery = { cabinet?: { findCompanies: { items: Array<{ id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }> } } | null };

export type FetchCompanyContractsAndBalanceQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type FetchCompanyContractsAndBalanceQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, contract?: { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | null, payments: { count: number, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, contract?: { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | null, payments: { count: number, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, contract?: { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | null, payments: { count: number, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null, paymentProviders: Array<{ id: string, name: string, service: PaymentService, type: PaymentType }> };

export type RefetchCompanyContractsAndBalanceQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type RefetchCompanyContractsAndBalanceQuery = { cabinet?: { company?: { contract?: { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | null, payments: { items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { contract?: { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | null, payments: { items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { contract?: { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | null, payments: { items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null };

export type CompanyFetchAggregatorTransactionsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type CompanyFetchAggregatorTransactionsQuery = { cabinet?: { company?: { ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type CompanyFetchAggregatorContractsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyFetchAggregatorContractsQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType }> } | { contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType }> } | { contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType }> } | null } | null };

export type CompanyGetCustomContractsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyGetCustomContractsQuery = { cabinet?: { company?: { verified: boolean, contracts: Array<{ discountOrganizations?: Array<string> | null, number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null }> } | { verified: boolean, contracts: Array<{ discountOrganizations?: Array<string> | null, number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null }> } | { verified: boolean, contracts: Array<{ discountOrganizations?: Array<string> | null, number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null }> } | null } | null };

export type FetchAdminAzsTransactionsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type FetchAdminAzsTransactionsQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, date: any, status: string, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, total: number, quantity: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, date: any, status: string, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, total: number, quantity: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, date: any, status: string, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, total: number, quantity: number, discount: number }> } } | null } | null };

export type DownloadAdminAzsTransactionsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type DownloadAdminAzsTransactionsQuery = { cabinet?: { company?: { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | null } | null };

export type CompanyGetCompanyNameByIdQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyGetCompanyNameByIdQuery = { cabinet?: { company?: { name?: string | null } | { name?: string | null } | { name?: string | null } | null } | null };

export type CompanyGetCompanyContractsByIdQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyGetCompanyContractsByIdQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | null } | null };

export type CompanyGetCardsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type CompanyGetCardsQuery = { cabinet?: { company?: { cards?: { cards: Array<{ token: string, psp: number, number: string, label: string, status: boolean, limitsShort: string }> } | null } | { cards?: { cards: Array<{ token: string, psp: number, number: string, label: string, status: boolean, limitsShort: string }> } | null } | { cards?: { cards: Array<{ token: string, psp: number, number: string, label: string, status: boolean, limitsShort: string }> } | null } | null } | null };

export type CompanyGetCardQueryVariables = Exact<{
  companyId: Scalars['ID'];
  token: Scalars['String'];
  filter: OrdersQueryParams;
}>;


export type CompanyGetCardQuery = { cabinet?: { company?: { cards?: { card: { psp: number, number: string, label: string, status: boolean } } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { cards?: { card: { psp: number, number: string, label: string, status: boolean } } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { cards?: { card: { psp: number, number: string, label: string, status: boolean } } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type ChangeBusinessCardSettingsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  token: Scalars['String'];
  status?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
}>;


export type ChangeBusinessCardSettingsMutation = { changeBusinessCardSettings: boolean };

export type GetCardTemplatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCardTemplatesQuery = { cabinet?: { company?: { cards?: { templates: Array<{ id: string, name: string }> } | null } | { cards?: { templates: Array<{ id: string, name: string }> } | null } | { cards?: { templates: Array<{ id: string, name: string }> } | null } | null } | null };

export type GetCardTemplateQueryVariables = Exact<{
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
}>;


export type GetCardTemplateQuery = { cabinet?: { company?: { cards?: { template: { name: string, regions: Array<string>, nets: Array<string>, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } } } | null } | { cards?: { template: { name: string, regions: Array<string>, nets: Array<string>, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } } } | null } | { cards?: { template: { name: string, regions: Array<string>, nets: Array<string>, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } } } | null } | null } | null };

export type CreateCardTemplateMutationVariables = Exact<{
  companyId: Scalars['ID'];
  template: CardTemplateData;
}>;


export type CreateCardTemplateMutation = { createCardTemplate: { name: string } };

export type UpdateCardTemplateMutationVariables = Exact<{
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
  template: CardTemplateData;
}>;


export type UpdateCardTemplateMutation = { updateCardTemplate: { name: string } };

export type DeleteCardTemplateMutationVariables = Exact<{
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
}>;


export type DeleteCardTemplateMutation = { deleteCardTemplate: boolean };

export type GetCardLimitsQueryVariables = Exact<{
  id: Scalars['ID'];
  token: Scalars['String'];
}>;


export type GetCardLimitsQuery = { cabinet?: { company?: { cards?: { card: { balance: Array<{ id: string, name: string, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean, balanceQuantity?: number | null, usedQuantity: number }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } }>, limits: Array<{ regions: Array<string>, nets: Array<string> }> } } | null } | { cards?: { card: { balance: Array<{ id: string, name: string, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean, balanceQuantity?: number | null, usedQuantity: number }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } }>, limits: Array<{ regions: Array<string>, nets: Array<string> }> } } | null } | { cards?: { card: { balance: Array<{ id: string, name: string, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean, balanceQuantity?: number | null, usedQuantity: number }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } }>, limits: Array<{ regions: Array<string>, nets: Array<string> }> } } | null } | null } | null };

export type UpdateCardLimitsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  token: Scalars['String'];
  limits: CardLimitsData;
}>;


export type UpdateCardLimitsMutation = { updateCardLimits: boolean };

export type GetCardsDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCardsDataQuery = { cabinet?: { company?: { cards?: { fuels: Array<{ name: string }>, regions: Array<{ name: string }>, nets: Array<{ name: string }> } | null } | { cards?: { fuels: Array<{ name: string }>, regions: Array<{ name: string }>, nets: Array<{ name: string }> } | null } | { cards?: { fuels: Array<{ name: string }>, regions: Array<{ name: string }>, nets: Array<{ name: string }> } | null } | null } | null };

export type GetCompanyVerifiedQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
}>;


export type GetCompanyVerifiedQuery = { cabinet?: { company?: { verified: boolean } | { verified: boolean } | { verified: boolean } | null } | null };

export type GetCompanyTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyTypeQuery = { cabinet?: { company?: { type: string } | { type: string } | { type: string } | null } | null };

export type CorpClientGetCompanyPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type CorpClientGetCompanyPageQuery = { cabinet?: { company?: { id: string, name?: string | null, type: string, status: CompanyStatus, source?: string | null, mode: OrganizationMode, registered: any, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, cars: { count: number }, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { id: string, name?: string | null, type: string, status: CompanyStatus, source?: string | null, mode: OrganizationMode, registered: any, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, cars: { count: number }, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { id: string, name?: string | null, type: string, status: CompanyStatus, source?: string | null, mode: OrganizationMode, registered: any, stat: { driversCount: number, departmentsCount: number, allDepartmentsCount: number, activeDriversCount: number }, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, cars: { count: number }, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment?: { type: string, source: Array<string> } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | null } | null };

export type CorpClientGetContractBalanceQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type CorpClientGetContractBalanceQuery = { cabinet?: { company?: { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null } | { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null } | { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null } | null } | null };

export type CorpClientFetchDriversTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type CorpClientFetchDriversTabQuery = { cabinet?: { company?: { reportType: ReportType, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }>, drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | { reportType: ReportType, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }>, drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | { reportType: ReportType, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }>, drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | null } | null };

export type CorpClientRefetchDriversTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type CorpClientRefetchDriversTabQuery = { cabinet?: { company?: { drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | { drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | { drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | null } | null };

export type GetOfflineClientsQueryVariables = Exact<{
  filter: CompaniesFilterParams;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetOfflineClientsQuery = { cabinet?: { findCompanies: { count: number, items: Array<{ id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }> } } | null };

export type GetCompanyOfflineTransactionsQueryVariables = Exact<{
  cardOwnerId?: InputMaybe<Scalars['ID']>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
}>;


export type GetCompanyOfflineTransactionsQuery = { cabinet?: { company?: { name?: string | null, summaryByFuelType: Array<{ shortName?: string | null, volumeFact: number, costFact: number, costFirm: number, costRefund: number, firmCostRefund: number, volumeRefund: number }> } | { name?: string | null, summaryByFuelType: Array<{ shortName?: string | null, volumeFact: number, costFact: number, costFirm: number, costRefund: number, firmCostRefund: number, volumeRefund: number }> } | { name?: string | null, summaryByFuelType: Array<{ shortName?: string | null, volumeFact: number, costFact: number, costFirm: number, costRefund: number, firmCostRefund: number, volumeRefund: number }> } | null } | null };

export type GetDriversQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DriverStatus>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetDriversQuery = { cabinet?: { company?: { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | null } | null };

export type GetDriversListPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetDriversListPageQuery = { cabinet?: { company?: { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | null } | null };

export type DriversGetDriverPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
  driverId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type DriversGetDriverPageQuery = { cabinet?: { company?: { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | null } | null };

export type DriversRefreshDriverPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
  driverId: Scalars['ID'];
}>;


export type DriversRefreshDriverPageQuery = { cabinet?: { company?: { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: DepartmentDriverConstraintType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | null } | null };

export type DriversAddDriverMutationVariables = Exact<{
  companyId: Scalars['ID'];
  driver: DriverData;
}>;


export type DriversAddDriverMutation = { addDriver?: Array<{ id?: string | null }> | null };

export type GetDriverBalanceHistoryQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
  contractId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetDriverBalanceHistoryQuery = { cabinet?: { company?: { driver?: { balanceHistory?: { count: number, items: Array<{ total: number, date: any }> } | null } | null } | { driver?: { balanceHistory?: { count: number, items: Array<{ total: number, date: any }> } | null } | null } | { driver?: { balanceHistory?: { count: number, items: Array<{ total: number, date: any }> } | null } | null } | null } | null };

export type GetDriverExpensesQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
  driverId: Scalars['ID'];
}>;


export type GetDriverExpensesQuery = { cabinet?: { company?: { driver?: { limitsAndExpenses: { limitsType: DepartmentDriverConstraintType, isQuantity?: boolean | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null } } | null } | { driver?: { limitsAndExpenses: { limitsType: DepartmentDriverConstraintType, isQuantity?: boolean | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null } } | null } | { driver?: { limitsAndExpenses: { limitsType: DepartmentDriverConstraintType, isQuantity?: boolean | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null } } | null } | null } | null };

export type GetFaqQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFaqQuery = { faq?: Array<{ id: string, question?: string | null, answer?: string | null, sorting?: number | null }> | null };

export type AddFaqMutationVariables = Exact<{
  question: Scalars['String'];
  answer?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Scalars['Float']>;
}>;


export type AddFaqMutation = { addFaq?: { id: string } | null };

export type RemoveQuestionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveQuestionMutation = { removeFaq?: boolean | null };

export type UpdateQuestionMutationVariables = Exact<{
  id: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateQuestionMutation = { editFaq?: { id: string } | null };

export type GetStationsGroupsQueryVariables = Exact<{
  filter: StationsGroupQueryParams;
}>;


export type GetStationsGroupsQuery = { cabinet?: { stationsGroups: { count: number, items: Array<{ id: string, name: string, description: string }> } } | null };

export type GetIndividualDiscountsGroupPageQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GetIndividualDiscountsGroupPageQuery = { cabinet?: { stationsGroup?: { name: string, description: string, stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, organizationName?: string | null }> }, discountsGroups: { count: number, items: Array<{ contractId: string, contractNumber?: string | null, organizationName: string, fuels: Array<number>, discounts: Array<number> }> } } | null } | null };

export type GetStationsGroupStationsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetStationsGroupStationsQuery = { cabinet?: { stationsGroup?: { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, organizationName?: string | null }> } } | null } | null };

export type GetStationsGroupDiscountsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetStationsGroupDiscountsQuery = { cabinet?: { stationsGroup?: { discountsGroups: { count: number, items: Array<{ contractId: string, contractNumber?: string | null, organizationName: string, fuels: Array<number>, discounts: Array<number> }> } } | null } | null };

export type GetStationsGroupFuelDiscountQueryVariables = Exact<{
  groupId: Scalars['ID'];
  discountId: Scalars['ID'];
}>;


export type GetStationsGroupFuelDiscountQuery = { cabinet?: { stationsGroup?: { contractDiscount: { fuelId: number, discount: number, startDate?: any | null, endDate?: any | null } } | null } | null };

export type GetStationsGroupContractDiscountsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  contractId: Scalars['ID'];
}>;


export type GetStationsGroupContractDiscountsQuery = { cabinet?: { company?: { name?: string | null, contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | { name?: string | null, contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | { name?: string | null, contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | null, stationsGroup?: { name: string, contractDiscounts: { count: number, items: Array<{ discountId: string, fuelId: number, discount: number, startDate?: any | null, endDate?: any | null }> } } | null } | null };

export type GetStationsGroupNameAndDescriptionQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GetStationsGroupNameAndDescriptionQuery = { cabinet?: { stationsGroup?: { name: string, description: string } | null } | null };

export type AddStationsGroupMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  companyId?: InputMaybe<Scalars['ID']>;
  stationsIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AddStationsGroupMutation = { addStationsGroup: string };

export type EditStationsGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
  stationsIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type EditStationsGroupMutation = { editStationsGroup: boolean };

export type AddCorpClientStationsGroupFuelDiscountsMutationVariables = Exact<{
  groupId: Scalars['ID'];
  contractId: Scalars['ID'];
  discount: Scalars['Float'];
  fuelsIds: Array<Scalars['Int']> | Scalars['Int'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type AddCorpClientStationsGroupFuelDiscountsMutation = { addCorpClientStationsGroupFuelDiscounts: boolean };

export type EditCorpClientStationsGroupFuelDiscountMutationVariables = Exact<{
  discountId: Scalars['ID'];
  discount: Scalars['Float'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type EditCorpClientStationsGroupFuelDiscountMutation = { editCorpClientStationsGroupFuelDiscount: boolean };

export type DeleteStationsGroupStationsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStationsGroupStationsMutation = { deleteStationsGroupStations: boolean };

export type DeleteStationsGroupStationMutationVariables = Exact<{
  groupId: Scalars['ID'];
  stationId: Scalars['ID'];
}>;


export type DeleteStationsGroupStationMutation = { deleteStationsGroupStation: boolean };

export type DeleteStationsGroupFuelDiscountsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStationsGroupFuelDiscountsMutation = { deleteStationsGroupFuelDiscounts: boolean };

export type DeleteStationsGroupContractFuelDiscountsMutationVariables = Exact<{
  groupId: Scalars['ID'];
  contractId: Scalars['ID'];
}>;


export type DeleteStationsGroupContractFuelDiscountsMutation = { deleteStationsGroupContractFuelDiscounts: boolean };

export type DeleteStationsGroupFuelDiscountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStationsGroupFuelDiscountMutation = { deleteStationsGroupFuelDiscount: boolean };

export type MapsFetchStationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MapsFetchStationsQuery = { stations: Array<{ id: string, name: string, address?: string | null, point?: Array<number> | null, prices: Array<{ price: number, fuel: { code: string } }> }> };

export type MapsFetchFindStationsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type MapsFetchFindStationsQuery = { stationsByES: { items: Array<{ id: string, name: string, address?: string | null }> } };

export type MapsFetchStationPointQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MapsFetchStationPointQuery = { station?: { point?: Array<number> | null } | null };

export type FetchOfflineCompanySettingsAndCatalogQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
}>;


export type FetchOfflineCompanySettingsAndCatalogQuery = { productCatalog: Array<{ groupId: number, groupName: string, products?: Array<{ productId: number, productName: string }> | null }>, cabinet?: { company?: { settings?: { osnovans?: Array<number> | null } | null, productCatalog?: Array<{ groupId: string, groupName: string, parentGroupId?: string | null, discount?: number | null, internalId: number, products?: Array<{ productId: string, productName: string, discount?: number | null, internalId: number }> | null }> | null } | {} | null } | null };

export type OfflineSaveCompanySettingsAndCatalogMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: CompanyData;
  partnerId: Scalars['ID'];
}>;


export type OfflineSaveCompanySettingsAndCatalogMutation = { saveCompany: { result: string, message?: string | null } };

export type CreateOfflinePartnerMutationVariables = Exact<{
  contract: Scalars['String'];
  firmId: Scalars['String'];
  name: Scalars['String'];
  organization: Scalars['ID'];
  osnovans?: InputMaybe<Array<Scalars['Float']> | Scalars['Float']>;
}>;


export type CreateOfflinePartnerMutation = { createOfflinePartner?: string | null };

export type AddOfflineStationMutationVariables = Exact<{
  partnerId: Scalars['ID'];
  stationData: NewOfflineStationData;
}>;


export type AddOfflineStationMutation = { addOfflineStation?: { id: string } | null };

export type GetOfflineTransactionsPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type GetOfflineTransactionsPageQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | null } | null };

export type GetOfflineTransactionsDownloadLinkQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type GetOfflineTransactionsDownloadLinkQuery = { cabinet?: { company?: { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | null } | null };

export type GetOfflineOrderQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
}>;


export type GetOfflineOrderQuery = { cabinet?: { company?: { orderNew?: { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { mps?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | null } | { orderNew?: { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { mps?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | null } | { orderNew?: { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { mps?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | null } | null } | null };

export type OrdersGetOrderDataQueryVariables = Exact<{
  fuelUpCompanyId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type OrdersGetOrderDataQuery = { cabinet?: { company?: { orderNew?: { station?: { id: string, name: string, address?: string | null } | null, sberSpasiboDetails?: { credit?: number | null } | null, item?: { quantityReport: number, quantityReq: number, fuel: { id: string, name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null, user?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null, discount?: { station?: number | null, corp?: number | null } | null } | null, corp?: { car?: { id: string, number: string } | null, driver?: { id?: string | null } | null, company: { id: string } | { id: string } | { id: string } } | null } | {} | null } | { orderNew?: { station?: { id: string, name: string, address?: string | null } | null, sberSpasiboDetails?: { credit?: number | null } | null, item?: { quantityReport: number, quantityReq: number, fuel: { id: string, name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null, user?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null, discount?: { station?: number | null, corp?: number | null } | null } | null, corp?: { car?: { id: string, number: string } | null, driver?: { id?: string | null } | null, company: { id: string } | { id: string } | { id: string } } | null } | {} | null } | { orderNew?: { station?: { id: string, name: string, address?: string | null } | null, sberSpasiboDetails?: { credit?: number | null } | null, item?: { quantityReport: number, quantityReq: number, fuel: { id: string, name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null, user?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null, discount?: { station?: number | null, corp?: number | null } | null } | null, corp?: { car?: { id: string, number: string } | null, driver?: { id?: string | null } | null, company: { id: string } | { id: string } | { id: string } } | null } | {} | null } | null } | null };

export type OrdersModifyOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume?: InputMaybe<Scalars['Float']>;
  discountCorp?: InputMaybe<Scalars['Float']>;
  discountStation?: InputMaybe<Scalars['Float']>;
  carId?: InputMaybe<Scalars['ID']>;
  fuelId?: InputMaybe<Scalars['Int']>;
  stationId?: InputMaybe<Scalars['ID']>;
  costPromotion?: InputMaybe<Scalars['Float']>;
  commentary: Scalars['String'];
}>;


export type OrdersModifyOrderMutation = { modifyOrder: { id: string } | { id: string } | { id: string } };

export type GetPaymentsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type GetPaymentsQuery = { cabinet?: { company?: { payments: { balance: number, needMoney: boolean, count: number, cards: Array<{ id: string, name: string, provider: { id: string, name: string } }>, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { balance: number, needMoney: boolean, count: number, cards: Array<{ id: string, name: string, provider: { id: string, name: string } }>, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { balance: number, needMoney: boolean, count: number, cards: Array<{ id: string, name: string, provider: { id: string, name: string } }>, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balances: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null };

export type GetPaymentProvidersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
}>;


export type GetPaymentProvidersQuery = { paymentProviders: Array<{ id: string, name: string, service: PaymentService, type: PaymentType }> };

export type CreatePaymentMutationVariables = Exact<{
  contractId: Scalars['ID'];
  providerId: Scalars['ID'];
  cardId?: InputMaybe<Scalars['ID']>;
  amount: Scalars['Float'];
}>;


export type CreatePaymentMutation = { createPayment?: { url?: string | null, number: string, id?: string | null, error?: string | null } | { url?: string | null, auto?: boolean | null, id?: string | null, error?: string | null } | { url?: string | null, id?: string | null, error?: string | null } | null };

export type GetMonthlyReportLinkQueryVariables = Exact<{
  id: Scalars['ID'];
  month: Scalars['String'];
}>;


export type GetMonthlyReportLinkQuery = { cabinet?: { company?: { monthlyReportLink: string } | { monthlyReportLink: string } | { monthlyReportLink: string } | null } | null };

export type StationsGetStationPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type StationsGetStationPageQuery = { cabinet?: { company?: { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type AdminGetStationPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type AdminGetStationPageQuery = { cabinet?: { company?: { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, lastOnline?: any | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { id: string, name?: string | null, stationPartner?: { system?: { isPing: boolean } | null } | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, lastOnline?: any | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, lastOnline?: any | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type GetStationDataQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
}>;


export type GetStationDataQuery = { cabinet?: { company?: { station?: { id: string, name: string, promo?: string | null, address?: string | null, color?: string | null, point?: Array<number> | null, groupId?: string | null } | null } | { station?: { id: string, name: string, promo?: string | null, address?: string | null, color?: string | null, point?: Array<number> | null, groupId?: string | null } | null } | { station?: { id: string, name: string, promo?: string | null, address?: string | null, color?: string | null, point?: Array<number> | null, groupId?: string | null } | null } | null } | null };

export type StationsRefreshStationPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
}>;


export type StationsRefreshStationPageQuery = { cabinet?: { company?: { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null } | null } | null };

export type StationsGetStationOrdersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type StationsGetStationOrdersQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment?: { type: string, source: Array<string> } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type StationsGetStationCoordsQueryVariables = Exact<{
  stationId: Scalars['ID'];
}>;


export type StationsGetStationCoordsQuery = { station?: { name: string, point?: Array<number> | null, address?: string | null } | null };

export type StationsGetStationPricesQueryVariables = Exact<{
  stationId: Scalars['ID'];
}>;


export type StationsGetStationPricesQuery = { station?: { prices: Array<{ pumps?: Array<number> | null, price: number, fuel: { shortName: string } }> } | null };

export type StationsGetStationPricesDiscountsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
}>;


export type StationsGetStationPricesDiscountsQuery = { cabinet?: { company?: { station?: { prices: Array<{ pumps?: Array<number> | null, price: number, fuel: { id: string, shortName: string } }>, stationFuelDiscounts: Array<{ id: string, fuel: number, discount: number }> } | null } | { station?: { prices: Array<{ pumps?: Array<number> | null, price: number, fuel: { id: string, shortName: string } }>, stationFuelDiscounts: Array<{ id: string, fuel: number, discount: number }> } | null } | { station?: { prices: Array<{ pumps?: Array<number> | null, price: number, fuel: { id: string, shortName: string } }>, stationFuelDiscounts: Array<{ id: string, fuel: number, discount: number }> } | null } | null } | null };

export type SetStationDiscountPriceMutationVariables = Exact<{
  discountId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
  fuelId?: InputMaybe<Scalars['ID']>;
  discount: Scalars['Float'];
}>;


export type SetStationDiscountPriceMutation = { setStationFuelDiscount?: boolean | null };

export type AddCompanyStationMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: NewStationData;
}>;


export type AddCompanyStationMutation = { addStation?: { result: string, message?: string | null } | null };

export type EditCompanyStationMutationVariables = Exact<{
  stationId: Scalars['ID'];
  data: EditStationData;
}>;


export type EditCompanyStationMutation = { editStation?: { id: string } | null };

export type BulkEditCompanyStationsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: BulkEditStationsData;
}>;


export type BulkEditCompanyStationsMutation = { bulkEditStations?: { id: string } | null };

export type GetStationCompanyIdQueryVariables = Exact<{
  stationId: Scalars['ID'];
}>;


export type GetStationCompanyIdQuery = { station?: { organizationId?: string | null } | null };

export type AddColorMutationVariables = Exact<{
  name: Scalars['String'];
  color: Scalars['String'];
}>;


export type AddColorMutation = { addColor?: { id: string } | null };

export type DownloadStationsIntegrationsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
}>;


export type DownloadStationsIntegrationsQuery = { cabinet?: { company?: { integrationsReportLink?: string | null } | { integrationsReportLink?: string | null } | { integrationsReportLink?: string | null } | null } | null };

export type GetOfflineStationPageQueryVariables = Exact<{
  contractId: Scalars['ID'];
  stationId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type GetOfflineStationPageQuery = { cabinet?: { company?: { station?: { name: string, address?: string | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | { station?: { name: string, address?: string | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | { station?: { name: string, address?: string | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | null } | null };

export type StationsFetchStationsListQueryVariables = Exact<{
  size: Scalars['Int'];
  offset: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type StationsFetchStationsListQuery = { stationsByES: { count: number, items: Array<{ id: string, name: string, address?: string | null }> } };

export type StationsGetStationsPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type StationsGetStationsPageQuery = { station?: { name: string, address?: string | null } | null, cabinet?: { company?: { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | null } | null };

export type StationsUpdateStationInfoAndTransactionsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type StationsUpdateStationInfoAndTransactionsQuery = { cabinet?: { company?: { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | null } | null };

export type StationsAddAsuMutationVariables = Exact<{
  data: NewStationSystemData;
}>;


export type StationsAddAsuMutation = { addStationSystem?: { id: string } | null };

export type StationsFetchStationIntegrationTabQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type StationsFetchStationIntegrationTabQuery = { cabinet?: { serverAsu: Array<string>, company?: { stationPartner?: { id: string, name: string, outgoing?: string | null, apiType?: string | null, apiKey?: string | null, system?: { id: string, name?: string | null, protocol?: string | null, isPing: boolean } | null } | null, stationPartnerFuels?: Array<{ partnerFuelId: string, fuelId: string, name?: string | null, ename?: string | null }> | null } | {} | null } | null, systems?: Array<{ id: string, name?: string | null, protocol?: string | null, isPing: boolean }> | null, fuel: Array<{ id: string, name: string, description?: string | null }> };

export type StationsSaveStationIntegrationMutationVariables = Exact<{
  companyId: Scalars['ID'];
  companyData: CompanyData;
  stationData: StationSystemData;
}>;


export type StationsSaveStationIntegrationMutation = { editStationSystem?: { id: string } | null, saveCompany: { result: string, message?: string | null } };

export type StationsUpdatePartnerStationsMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type StationsUpdatePartnerStationsMutation = { updatePartnerStations?: boolean | null };

export type StationsIndexStationsMutationVariables = Exact<{
  stationId?: InputMaybe<Scalars['ID']>;
}>;


export type StationsIndexStationsMutation = { indexStations?: boolean | null };

export type GetAzsCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  contractsType: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StationStatus>;
}>;


export type GetAzsCompanyStationsQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, status?: StationStatus | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, status?: StationStatus | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, status?: StationStatus | null }>, status: Array<{ status: StationStatus, count: number }> } } | null } | null };

export type GetCompanyStationsForStationsGroupQueryVariables = Exact<{
  companyId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetCompanyStationsForStationsGroupQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | null } | null };

export type AddStationsToStationsGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  stationsIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AddStationsToStationsGroupMutation = { addStationsToStationsGroup: boolean };

export type StationsGetCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type StationsGetCompanyStationsQuery = { cabinet?: { company?: { stations: { items: Array<{ id: string, name: string, address?: string | null }> } } | { stations: { items: Array<{ id: string, name: string, address?: string | null }> } } | { stations: { items: Array<{ id: string, name: string, address?: string | null }> } } | null } | null };

export type StationsGetStationsQueryVariables = Exact<{ [key: string]: never; }>;


export type StationsGetStationsQuery = { stationsByES: { items: Array<{ id: string, name: string, address?: string | null, point?: Array<number> | null, prices: Array<{ price: number, fuel: { code: string } }> }> } };

export type StationsGetMapStationsQueryVariables = Exact<{ [key: string]: never; }>;


export type StationsGetMapStationsQuery = { stationsByES: { items: Array<{ id: string, point?: Array<number> | null }> } };

export type StationsGetMapStationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StationsGetMapStationQuery = { station?: { name: string, address?: string | null, prices: Array<{ price: number, fuel: { code: string } }> } | null };

export type StationsSetStationStateMutationVariables = Exact<{
  id: Scalars['ID'];
  state: StationState;
  commentary: Scalars['String'];
}>;


export type StationsSetStationStateMutation = { setStationState: boolean };

export type StationsBulkSetStationStateMutationVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StationStatus>;
  region?: InputMaybe<Scalars['String']>;
  commentary: Scalars['String'];
  oldState: Array<StationState> | StationState;
  newState: StationState;
  groupId?: InputMaybe<Scalars['ID']>;
}>;


export type StationsBulkSetStationStateMutation = { bulkSetStationsState: boolean };

export type BulkSetStationsStateByGroupIdMutationVariables = Exact<{
  groupId: Scalars['ID'];
  state: StationState;
  commentary: Scalars['String'];
}>;


export type BulkSetStationsStateByGroupIdMutation = { bulkSetStationsStateByGroupId: boolean };

export type StationsStateLogsGroupsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type StationsStateLogsGroupsQuery = { cabinet?: { company?: { stationsStateLogsGroups?: { count: number, items: Array<{ id: string, date: any, state: StationState, email: string, commentary: string }> } | null } | { stationsStateLogsGroups?: { count: number, items: Array<{ id: string, date: any, state: StationState, email: string, commentary: string }> } | null } | { stationsStateLogsGroups?: { count: number, items: Array<{ id: string, date: any, state: StationState, email: string, commentary: string }> } | null } | null } | null };

export type StationsGetStationStateLogsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type StationsGetStationStateLogsQuery = { cabinet?: { company?: { station?: { stateLogs?: { count: number, items: Array<{ date: any, user: string, state: StationState, commentary: string }> } | null } | null } | { station?: { stateLogs?: { count: number, items: Array<{ date: any, user: string, state: StationState, commentary: string }> } | null } | null } | { station?: { stateLogs?: { count: number, items: Array<{ date: any, user: string, state: StationState, commentary: string }> } | null } | null } | null } | null };

export type CopyStationsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CopyStationsMutation = { copyStations: boolean };

export type GetUpdatedStationsQueryVariables = Exact<{
  id: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetUpdatedStationsQuery = { cabinet?: { company?: { updatedStations?: { count: number, items: Array<{ id: string, name: string, nameApi: string, address: string, addressApi: string, organizationName: string, lng: number, lngApi: number, lat: number, latApi: number }> } | null } | { updatedStations?: { count: number, items: Array<{ id: string, name: string, nameApi: string, address: string, addressApi: string, organizationName: string, lng: number, lngApi: number, lat: number, latApi: number }> } | null } | { updatedStations?: { count: number, items: Array<{ id: string, name: string, nameApi: string, address: string, addressApi: string, organizationName: string, lng: number, lngApi: number, lat: number, latApi: number }> } | null } | null } | null };

export type GetStationDataToEditQueryVariables = Exact<{
  stationId: Scalars['ID'];
}>;


export type GetStationDataToEditQuery = { station?: { name: string, brand?: string | null, address?: string | null, promo?: string | null, color?: string | null, point?: Array<number> | null, groupId?: string | null, mode?: { type: StationMode } | null } | null };

export type GetInternalOrdersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type GetInternalOrdersQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, pump?: number | null, name?: string | null, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, pump?: number | null, name?: string | null, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, pump?: number | null, name?: string | null, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { id: string, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string>, email?: string | null, maskedPan?: string | null } | null, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type GetInternalOrderQueryVariables = Exact<{
  companyId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type GetInternalOrderQuery = { cabinet?: { company?: { orderNew?: { id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, items: Array<{ id?: string | null, type: OrderItemType, pump?: number | null, name?: string | null, groupName?: string | null, shortName?: string | null }>, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { stationOrderId?: string | null, bankReserveId?: string | null, id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, item?: { pump?: number | null, quantityReq: number, quantityReport: number, fuel: { name: string }, costReport?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, costReq?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, refund?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null, quantity?: number | null } | null } | null, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | null, orderDetails: Array<{ time: string, params?: string | null, details?: string | null, status: string, email?: string | null }> } | { orderNew?: { id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, items: Array<{ id?: string | null, type: OrderItemType, pump?: number | null, name?: string | null, groupName?: string | null, shortName?: string | null }>, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { stationOrderId?: string | null, bankReserveId?: string | null, id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, item?: { pump?: number | null, quantityReq: number, quantityReport: number, fuel: { name: string }, costReport?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, costReq?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, refund?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null, quantity?: number | null } | null } | null, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | null, orderDetails: Array<{ time: string, params?: string | null, details?: string | null, status: string, email?: string | null }> } | { orderNew?: { id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, items: Array<{ id?: string | null, type: OrderItemType, pump?: number | null, name?: string | null, groupName?: string | null, shortName?: string | null }>, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { stationOrderId?: string | null, bankReserveId?: string | null, id: string, date: any, finished?: any | null, type?: string | null, hasOnlineOrder?: boolean | null, hasOfflineOrder?: boolean | null, sberId?: boolean | null, item?: { pump?: number | null, quantityReq: number, quantityReport: number, fuel: { name: string }, costReport?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, costReq?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, refund?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null, quantity?: number | null } | null } | null, payment?: { id?: string | null, type: string, source: Array<string>, rrn?: string | null, merchantName?: string | null, email?: string | null, maskedPan?: string | null } | null, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | null, orderDetails: Array<{ time: string, params?: string | null, details?: string | null, status: string, email?: string | null }> } | null } | null };

export type SupportFetchDriversTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type SupportFetchDriversTabQuery = { cabinet?: { company?: { drivers: { activeCount: number, totalCount: number, items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | { drivers: { activeCount: number, totalCount: number, items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | { drivers: { activeCount: number, totalCount: number, items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | null } | null };

export type SupportRefetchDriversTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type SupportRefetchDriversTabQuery = { cabinet?: { company?: { drivers: { items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | { drivers: { items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | { drivers: { items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | null } | null };

export type SupportFetchUsersTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type SupportFetchUsersTabQuery = { cabinet?: { company?: { apiUsers: { count: number, items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, phone?: string | null } | { phone?: string | null } | { phone?: string | null } | { phone?: string | null }> } } | { apiUsers: { count: number, items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, phone?: string | null } | { phone?: string | null } | { phone?: string | null } | { phone?: string | null }> } } | { apiUsers: { count: number, items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, phone?: string | null } | { phone?: string | null } | { phone?: string | null } | { phone?: string | null }> } } | null } | null };

export type SupportRefetchUsersTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type SupportRefetchUsersTabQuery = { cabinet?: { company?: { apiUsers: { items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, phone?: string | null } | { phone?: string | null } | { phone?: string | null } | { phone?: string | null }> } } | { apiUsers: { items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, phone?: string | null } | { phone?: string | null } | { phone?: string | null } | { phone?: string | null }> } } | { apiUsers: { items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, phone?: string | null } | { phone?: string | null } | { phone?: string | null } | { phone?: string | null }> } } | null } | null };

export type SupportFetchUserPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  phone: Scalars['String'];
  filter: OrdersQueryParams;
}>;


export type SupportFetchUserPageQuery = { cabinet?: { company?: { type: string, apiUser?: { id?: string | null, email?: string | null, registered?: any | null, sberLoyaltyBalance?: number | null, lastActivity?: any | null, version?: { os?: string | null, osVersion?: string | null, appType?: string | null, appVersion?: string | null } | null, drivers: Array<{ id?: string | null, companyId?: string | null, companyName?: string | null, companyReportType?: string | null, partnerId: string, partnerName: string, isActive: boolean, limitsAndExpenses: { limitsType: DepartmentDriverConstraintType, balance?: number | null, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null }, car?: { id: string, number: string } | null }> } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { type: string, apiUser?: { id?: string | null, email?: string | null, registered?: any | null, sberLoyaltyBalance?: number | null, lastActivity?: any | null, version?: { os?: string | null, osVersion?: string | null, appType?: string | null, appVersion?: string | null } | null, drivers: Array<{ id?: string | null, companyId?: string | null, companyName?: string | null, companyReportType?: string | null, partnerId: string, partnerName: string, isActive: boolean, limitsAndExpenses: { limitsType: DepartmentDriverConstraintType, balance?: number | null, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null }, car?: { id: string, number: string } | null }> } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { type: string, apiUser?: { id?: string | null, email?: string | null, registered?: any | null, sberLoyaltyBalance?: number | null, lastActivity?: any | null, version?: { os?: string | null, osVersion?: string | null, appType?: string | null, appVersion?: string | null } | null, drivers: Array<{ id?: string | null, companyId?: string | null, companyName?: string | null, companyReportType?: string | null, partnerId: string, partnerName: string, isActive: boolean, limitsAndExpenses: { limitsType: DepartmentDriverConstraintType, balance?: number | null, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null }, car?: { id: string, number: string } | null }> } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type SupportGetUserOrdersQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type SupportGetUserOrdersQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment?: { type: string, source: Array<string> } | null, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type GetMonitoringTabQueryVariables = Exact<{
  status?: InputMaybe<StationStatus>;
  query?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Array<StationState> | StationState>;
  sort?: InputMaybe<StationsSort>;
  sortDir?: InputMaybe<SortDirection>;
}>;


export type GetMonitoringTabQuery = { stationsByES: { count: number, status: Array<{ status: StationStatus, count: number }>, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, organizationName?: string | null, organizationId?: string | null, stationName?: string | null, state: StationState, status?: StationStatus | null, acs?: string | null, stateDetails?: { date: string, email?: string | null, commentary: string } | null }> } };

export type SupportRequestUserRestorePasswordEmailMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type SupportRequestUserRestorePasswordEmailMutation = { result: string };

export type SupportDismissOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume: Scalars['Float'];
  commentary: Scalars['String'];
  partial?: InputMaybe<Scalars['Boolean']>;
}>;


export type SupportDismissOrderMutation = { dismissOrder: { id: string } | { id: string } | { id: string } };

export type SupportDismissOrderToIncomeMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume: Scalars['Float'];
  commentary: Scalars['String'];
}>;


export type SupportDismissOrderToIncomeMutation = { dismissOrderToIncome: { id: string } | { id: string } | { id: string } };

export type SupportRefundOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume: Scalars['Float'];
  commentary: Scalars['String'];
}>;


export type SupportRefundOrderMutation = { refundOrder: { id: string } | { id: string } | { id: string } };

export type SupportUndoLossMutationVariables = Exact<{
  orderId: Scalars['ID'];
  companyId: Scalars['ID'];
  commentary: Scalars['String'];
}>;


export type SupportUndoLossMutation = { undoLoss: { id: string, status: string, message?: string | null } };

export type SupportCancelOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  commentary: Scalars['String'];
}>;


export type SupportCancelOrderMutation = { cancelOrder: { id: string } | { id: string } | { id: string } };

export type SupportCloseOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume: Scalars['Float'];
  commentary: Scalars['String'];
}>;


export type SupportCloseOrderMutation = { closeOrder: { id: string } | { id: string } | { id: string } };

export type SupportGetScriptsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportGetScriptsQuery = { scripts: Array<{ id: string, name: string }> };

export type SupportGetScriptByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SupportGetScriptByIdQuery = { script?: { name: string, args: string, entry: string, preview: boolean } | null };

export type SupportCreateScriptRunMutationVariables = Exact<{
  id: Scalars['Int'];
  params: Scalars['String'];
}>;


export type SupportCreateScriptRunMutation = { createScriptRun: { status: RunResultStatus, data?: string | null } };

export type SupportPreviewScriptRunMutationVariables = Exact<{
  id: Scalars['Int'];
  params: Scalars['String'];
}>;


export type SupportPreviewScriptRunMutation = { previewScriptRun: string };

export type SupportExecuteScriptRunMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SupportExecuteScriptRunMutation = { executeScriptRun: { status: RunResultStatus, data?: string | null } };

export type SupportGetRunsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SupportGetRunsQuery = { runs: { count: number, items: Array<{ id: string, date?: any | null, state: RunState, script?: { name: string } | null }> } };

export type SupportGetRunQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SupportGetRunQuery = { run?: { id: string, date?: any | null, state: RunState, params: string, script?: { id: string, name: string, args: string, preview: boolean } | null, user?: { email?: string | null } | null } | null };

export type SupportGetCompanyNameByContractIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SupportGetCompanyNameByContractIdQuery = { cabinet?: { company?: { contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | { contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | { contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | null } | null };

export type RefundSpasiboBonusesMutationVariables = Exact<{
  id: Scalars['String'];
  orderId: Scalars['ID'];
}>;


export type RefundSpasiboBonusesMutation = { result: boolean };

export type CheckContractPaymentsMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type CheckContractPaymentsMutation = { checkContractPayments: { completed: number, amount: number } };

export type PutCardsFirmReferenceMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type PutCardsFirmReferenceMutation = { putCardsFirmReference: boolean };

export type UnlinkUserSberIdMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UnlinkUserSberIdMutation = { unlinkUserSberId: string };

export type GetWaybillsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWaybillsQuery = { cabinet?: { company?: { waybills: { count: number, items: Array<{ id: string, number: string, validSince: string, validTo: string, allowedFuels?: Array<number> | null, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string }> } }> } } | { waybills: { count: number, items: Array<{ id: string, number: string, validSince: string, validTo: string, allowedFuels?: Array<number> | null, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string }> } }> } } | { waybills: { count: number, items: Array<{ id: string, number: string, validSince: string, validTo: string, allowedFuels?: Array<number> | null, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string }> } }> } } | null } | null };

export type GetWaybillQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  waybillId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type GetWaybillQuery = { cabinet?: { company?: { waybill: { id: string, number: string, validSince: string, validTo: string, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } }, ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { waybill: { id: string, number: string, validSince: string, validTo: string, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } }, ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { waybill: { id: string, number: string, validSince: string, validTo: string, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } }, ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type GetWaybillRidersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  waybillId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetWaybillRidersQuery = { cabinet?: { company?: { waybill: { riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } } } | { waybill: { riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } } } | { waybill: { riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } } } | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: { hash: string }) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetPaymentsByContractIdDocument = new TypedDocumentString(`
    query GetPaymentsByContractId($contractId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(contractId: $contractId) {
      payments {
        items(filter: $filter) {
          id
          type
          balances {
            amount
            createdAt
            description
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetPaymentsByContractIdQuery, GetPaymentsByContractIdQueryVariables>;
export const GetStatementsReceiptsDocument = new TypedDocumentString(`
    query getStatementsReceipts($companyId: ID!, $filter: StatementsReceiptsQueryParams!) {
  cabinet {
    company(id: $companyId) {
      statementsReceipts(filter: $filter) {
        count
        items {
          id
          number
          date
          contragent
          inn
          purpose
          amount
          status
          message
          contractId
          organizationId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatementsReceiptsQuery, GetStatementsReceiptsQueryVariables>;
export const AccountantRestartStatementReceiptDocument = new TypedDocumentString(`
    mutation AccountantRestartStatementReceipt($id: ID!, $customContractId: ID, $force: Boolean) {
  restartStatementReceipt(
    id: $id
    customContractId: $customContractId
    force: $force
  )
}
    `) as unknown as TypedDocumentString<AccountantRestartStatementReceiptMutation, AccountantRestartStatementReceiptMutationVariables>;
export const GetStatementReceiptContractsDocument = new TypedDocumentString(`
    query getStatementReceiptContracts($companyId: ID!, $statementReceiptId: ID!) {
  cabinet {
    company(id: $companyId) {
      statementReceiptContracts(statementReceiptId: $statementReceiptId) {
        id
        contract
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatementReceiptContractsQuery, GetStatementReceiptContractsQueryVariables>;
export const AccountantCancelStatementReceiptDocument = new TypedDocumentString(`
    mutation AccountantCancelStatementReceipt($id: ID!) {
  cancelStatementReceipt(id: $id)
}
    `) as unknown as TypedDocumentString<AccountantCancelStatementReceiptMutation, AccountantCancelStatementReceiptMutationVariables>;
export const GetStatementsReceiptsReportUrlDocument = new TypedDocumentString(`
    query getStatementsReceiptsReportUrl($companyId: ID) {
  cabinet {
    company(id: $companyId) {
      downloadStatementsReceiptsReport
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatementsReceiptsReportUrlQuery, GetStatementsReceiptsReportUrlQueryVariables>;
export const GetInvoicesDocument = new TypedDocumentString(`
    query getInvoices($page: Int!, $size: Int!, $organizationName: String, $invoiceStatus: [String!], $dateFrom: DateTime!, $dateTo: DateTime!) {
  invoices {
    invoicesList(
      organizationName: $organizationName
      invoiceStatus: $invoiceStatus
      dateFrom: $dateFrom
      dateTo: $dateTo
      page: $page
      size: $size
    ) {
      items {
        id
        createdAt
        organizationId
        organizationName
        contract
        contractId
        paymentPurpose
        amount
        status
      }
      count
      total
    }
  }
}
    `) as unknown as TypedDocumentString<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetInvoiceOrganizationsDocument = new TypedDocumentString(`
    query getInvoiceOrganizations {
  invoices {
    invoiceOrganizations {
      name
      id
    }
    fuelUpBankAccount
  }
}
    `) as unknown as TypedDocumentString<GetInvoiceOrganizationsQuery, GetInvoiceOrganizationsQueryVariables>;
export const CreateInvoicesDocument = new TypedDocumentString(`
    mutation createInvoices($organizations: [String!]!, $invoiceType: InvoiceType!, $bankAccount: String!, $prepayDays: Float!) {
  createInvoices(
    organizations: $organizations
    invoiceType: $invoiceType
    bankAccount: $bankAccount
    prepayDays: $prepayDays
  )
}
    `) as unknown as TypedDocumentString<CreateInvoicesMutation, CreateInvoicesMutationVariables>;
export const SaveInvoiceDocument = new TypedDocumentString(`
    mutation saveInvoice($invoiceId: ID!, $amount: Float!, $paymentPurpose: String!, $status: String!) {
  saveInvoice(
    invoiceId: $invoiceId
    amount: $amount
    paymentPurpose: $paymentPurpose
    status: $status
  )
}
    `) as unknown as TypedDocumentString<SaveInvoiceMutation, SaveInvoiceMutationVariables>;
export const SubmitInvoicesDocument = new TypedDocumentString(`
    mutation submitInvoices {
  submitInvoices
}
    `) as unknown as TypedDocumentString<SubmitInvoicesMutation, SubmitInvoicesMutationVariables>;
export const AccountantFetchOfflineCompanyStationsDocument = new TypedDocumentString(`
    query AccountantFetchOfflineCompanyStations($companyId: ID!, $contractsType: String!, $partnerId: ID) {
  regions {
    id
    name
  }
  cabinet {
    company(id: $companyId) {
      stations(contractsType: $contractsType, partnerId: $partnerId) {
        count
        items {
          id
          name
          address
          lastOnline
          certificate
          certificateKey
          certificateExpiration
          region
          partnerExtId
        }
        status {
          status
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AccountantFetchOfflineCompanyStationsQuery, AccountantFetchOfflineCompanyStationsQueryVariables>;
export const AccountantGetCompanyOrdersWithContractsDocument = new TypedDocumentString(`
    query AccountantGetCompanyOrdersWithContracts($companyId: ID, $contractId: ID, $partnerId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId, contractId: $contractId) {
      contracts {
        id
        number
        businessType
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          payment {
            type
            source
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AccountantGetCompanyOrdersWithContractsQuery, AccountantGetCompanyOrdersWithContractsQueryVariables>;
export const GetStatementsPatternsDocument = new TypedDocumentString(`
    query getStatementsPatterns($id: ID!) {
  cabinet {
    company(id: $id) {
      statementsPatterns {
        id
        payerName
        companyName
        contractName
        pattern
        commentary
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatementsPatternsQuery, GetStatementsPatternsQueryVariables>;
export const AddStatementsPatternDocument = new TypedDocumentString(`
    mutation addStatementsPattern($data: StatementPatternData!) {
  addStatementsPattern(data: $data)
}
    `) as unknown as TypedDocumentString<AddStatementsPatternMutation, AddStatementsPatternMutationVariables>;
export const DeleteStatementsPatternDocument = new TypedDocumentString(`
    mutation deleteStatementsPattern($id: ID!) {
  deleteStatementsPattern(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteStatementsPatternMutation, DeleteStatementsPatternMutationVariables>;
export const GetProfitabilityReportUrlDocument = new TypedDocumentString(`
    query getProfitabilityReportUrl($id: ID!, $from: String!, $to: String!) {
  cabinet {
    company(id: $id) {
      profitabilityReportUrl(from: $from, to: $to)
    }
  }
}
    `) as unknown as TypedDocumentString<GetProfitabilityReportUrlQuery, GetProfitabilityReportUrlQueryVariables>;
export const AdminFetchCompanyUsersDocument = new TypedDocumentString(`
    query AdminFetchCompanyUsers($companyId: ID!, $query: String, $filter: UsersQueryParams) {
  cabinet {
    company(id: $companyId) {
      users(filter: $filter, query: $query) {
        count
        items {
          id
          phone
          ... on LKUser {
            name
            email
            role
            lastActivity
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminFetchCompanyUsersQuery, AdminFetchCompanyUsersQueryVariables>;
export const GetAuthLogsDocument = new TypedDocumentString(`
    query getAuthLogs($companyId: ID!, $filter: LogsQueryParams!) {
  cabinet {
    company(id: $companyId) {
      logs(filter: $filter) {
        count
        items {
          date
          phone
          logType
          logName
          smsCode
          input
        }
        summary {
          total
          successful
          errors
          invalid
          timeouts
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAuthLogsQuery, GetAuthLogsQueryVariables>;
export const AdminGetCompanyLimitsDocument = new TypedDocumentString(`
    query AdminGetCompanyLimits($companyId: ID!, $filter: LimitsQueryParams!) {
  cabinet {
    company(id: $companyId) {
      limits(filter: $filter) {
        count
        items {
          ... on SmsLimit {
            phone
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetCompanyLimitsQuery, AdminGetCompanyLimitsQueryVariables>;
export const AdminResetAuthLimitDocument = new TypedDocumentString(`
    mutation AdminResetAuthLimit($type: String!, $id: String!) {
  resetAuthLimits(type: $type, id: $id)
}
    `) as unknown as TypedDocumentString<AdminResetAuthLimitMutation, AdminResetAuthLimitMutationVariables>;
export const AdminFetchAzsInfoDocument = new TypedDocumentString(`
    query AdminFetchAzsInfo($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      id
      name
      status
      contracts {
        id
        number
        businessType
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminFetchAzsInfoQuery, AdminFetchAzsInfoQueryVariables>;
export const AdminGetAzsInfoTabDocument = new TypedDocumentString(`
    query adminGetAzsInfoTab($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      contract {
        balance
        balanceLimit
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          corp {
            company {
              name
            }
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          sberSpasiboDetails {
            subId
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetAzsInfoTabQuery, AdminGetAzsInfoTabQueryVariables>;
export const AdminGetAzsCompanyInfoDocument = new TypedDocumentString(`
    query adminGetAzsCompanyInfo($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      id
      name
      type
      brand
      director
      phone
      email
      buh {
        name
        phone
        email
      }
      tech {
        name
        phone
        email
      }
      additional {
        commentary
      }
      inn
      kpp
      ogrn
      postAddress
      officialAddress
      companyType
      contract {
        bik
        account
        correspondence
      }
      contracts {
        id
        number
        date
        finishDate
        paymentType
        discount
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetAzsCompanyInfoQuery, AdminGetAzsCompanyInfoQueryVariables>;
export const AdminGetContractDataDocument = new TypedDocumentString(`
    query adminGetContractData($contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      type
      contract {
        id
        number
        bik
        account
        bank
        bankCity
        correspondence
        date
        finishDate
        got
        edo
        paymentType
        businessType
        delayedDiscount
        personalDiscount
        discount
        agentCommission
        ... on OnlineContract {
          timezoneOffset
        }
        ... on CustomContract {
          timezoneOffset
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetContractDataQuery, AdminGetContractDataQueryVariables>;
export const AdminGetContractDiscountsDocument = new TypedDocumentString(`
    query adminGetContractDiscounts($contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      contract {
        discount
        ... on OnlineContract {
          customFuelDiscount {
            fuel
            discount
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetContractDiscountsQuery, AdminGetContractDiscountsQueryVariables>;
export const AdminGetStationIntegrationDocument = new TypedDocumentString(`
    query AdminGetStationIntegration($id: ID) {
  cabinet {
    company(id: $id) {
      ... on AzsCompany {
        stationPartner {
          id
          name
          outgoing
          apiType
          system {
            id
            name
            protocol
            isPing
          }
        }
        stationPartnerFuels {
          partnerFuelId
          fuelId
          name
          ename
        }
      }
    }
  }
  systems {
    id
    name
    protocol
    isPing
  }
  fuel {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AdminGetStationIntegrationQuery, AdminGetStationIntegrationQueryVariables>;
export const AdminGetSbidAuthLinkStatusDocument = new TypedDocumentString(`
    query AdminGetSbidAuthLinkStatus {
  cabinet {
    isSberBusinessIdLinked
  }
}
    `) as unknown as TypedDocumentString<AdminGetSbidAuthLinkStatusQuery, AdminGetSbidAuthLinkStatusQueryVariables>;
export const AdminLinkSberBusinessIdDocument = new TypedDocumentString(`
    mutation AdminLinkSberBusinessId($companyId: ID!) {
  linkSberBusinessId(companyId: $companyId)
}
    `) as unknown as TypedDocumentString<AdminLinkSberBusinessIdMutation, AdminLinkSberBusinessIdMutationVariables>;
export const AdminUnlinkSberBusinessIdDocument = new TypedDocumentString(`
    mutation AdminUnlinkSberBusinessId($companyId: ID!) {
  unlinkSberBusinessId(companyId: $companyId)
}
    `) as unknown as TypedDocumentString<AdminUnlinkSberBusinessIdMutation, AdminUnlinkSberBusinessIdMutationVariables>;
export const AdminGetContractDocumentsDocument = new TypedDocumentString(`
    query adminGetContractDocuments($contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      contract {
        ... on OnlineContract {
          documents {
            items {
              id
              filename
              commentary
              createdAt
            }
            count
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetContractDocumentsQuery, AdminGetContractDocumentsQueryVariables>;
export const AdminDownloadContractDocumentDocument = new TypedDocumentString(`
    query adminDownloadContractDocument($contractId: ID!, $documentId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      contract {
        ... on OnlineContract {
          document(id: $documentId) {
            url
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminDownloadContractDocumentQuery, AdminDownloadContractDocumentQueryVariables>;
export const AdminEditContractDocumentDocument = new TypedDocumentString(`
    mutation adminEditContractDocument($id: ID!, $data: OnlineContractDocumentData!) {
  editContractDocument(id: $id, data: $data)
}
    `) as unknown as TypedDocumentString<AdminEditContractDocumentMutation, AdminEditContractDocumentMutationVariables>;
export const AdminDeleteContractDocumentDocument = new TypedDocumentString(`
    mutation adminDeleteContractDocument($id: ID!) {
  deleteContractDocument(id: $id)
}
    `) as unknown as TypedDocumentString<AdminDeleteContractDocumentMutation, AdminDeleteContractDocumentMutationVariables>;
export const GetTerBankReportUrlDocument = new TypedDocumentString(`
    query getTerBankReportUrl($id: ID!, $from: String!, $to: String!) {
  cabinet {
    company(id: $id) {
      terBankReportUrl(from: $from, to: $to)
    }
  }
}
    `) as unknown as TypedDocumentString<GetTerBankReportUrlQuery, GetTerBankReportUrlQueryVariables>;
export const GetAccountantDashboardReportUrlDocument = new TypedDocumentString(`
    query getAccountantDashboardReportUrl($id: ID!, $from: String!, $to: String!) {
  cabinet {
    company(id: $id) {
      accountantDashboardReportUrl(from: $from, to: $to)
    }
  }
}
    `) as unknown as TypedDocumentString<GetAccountantDashboardReportUrlQuery, GetAccountantDashboardReportUrlQueryVariables>;
export const FindCompaniesDocument = new TypedDocumentString(`
    query findCompanies($filter: CompaniesFilterParams!) {
  cabinet {
    findCompanies(filter: $filter, size: 5) {
      items {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FindCompaniesQuery, FindCompaniesQueryVariables>;
export const GetCompanyContractsDocument = new TypedDocumentString(`
    query getCompanyContracts($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        number
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyContractsQuery, GetCompanyContractsQueryVariables>;
export const IndexOrderDocument = new TypedDocumentString(`
    mutation indexOrder($id: String!, $type: StationStatus!) {
  indexOrder(id: $id, type: $type)
}
    `) as unknown as TypedDocumentString<IndexOrderMutation, IndexOrderMutationVariables>;
export const GetNotificationsTemplatesDocument = new TypedDocumentString(`
    query getNotificationsTemplates($id: ID!, $filter: NotificationsTemplatesQueryParams!) {
  cabinet {
    company(id: $id) {
      templates(filter: $filter) {
        items {
          id
          name
          channel
          title
          template
          trigger
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetNotificationsTemplatesQuery, GetNotificationsTemplatesQueryVariables>;
export const CreateNotificationTemplateDocument = new TypedDocumentString(`
    mutation createNotificationTemplate($data: NotificationTemplateData!) {
  createNotificationTemplate(data: $data) {
    id
    name
    channel
    title
    template
    trigger
    createdAt
  }
}
    `) as unknown as TypedDocumentString<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>;
export const UpdateNotificationTemplateDocument = new TypedDocumentString(`
    mutation updateNotificationTemplate($id: ID!, $data: NotificationTemplateData!) {
  updateNotificationTemplate(id: $id, data: $data) {
    id
    name
    channel
    title
    template
    trigger
    createdAt
  }
}
    `) as unknown as TypedDocumentString<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>;
export const DeleteNotificationTemplateDocument = new TypedDocumentString(`
    mutation deleteNotificationTemplate($id: ID!) {
  deleteNotificationTemplate(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>;
export const GetNotificationsDocument = new TypedDocumentString(`
    query getNotifications($id: ID!, $filter: NotificationsQueryParams!) {
  cabinet {
    company(id: $id) {
      notifications(filter: $filter) {
        items {
          recipient
          message
          channel
          status
          createdAt
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetServerAsuDocument = new TypedDocumentString(`
    query getServerAsu {
  cabinet {
    serverAsu
  }
}
    `) as unknown as TypedDocumentString<GetServerAsuQuery, GetServerAsuQueryVariables>;
export const GetOrderStatusDocument = new TypedDocumentString(`
    query getOrderStatus($id: ID!) {
  getOrderStatus(id: $id) {
    status
    quantity
  }
}
    `) as unknown as TypedDocumentString<GetOrderStatusQuery, GetOrderStatusQueryVariables>;
export const GetStationsByCompanyDocument = new TypedDocumentString(`
    query getStationsByCompany($companyId: ID!, $filter: QueryParams) {
  cabinet {
    company(id: $companyId) {
      getStationsByCompany(filter: $filter) {
        count
        items {
          id
          name
          address
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsByCompanyQuery, GetStationsByCompanyQueryVariables>;
export const DeleteStationGroupDocument = new TypedDocumentString(`
    mutation deleteStationGroup($groupId: ID!) {
  deleteStationGroup(groupId: $groupId)
}
    `) as unknown as TypedDocumentString<DeleteStationGroupMutation, DeleteStationGroupMutationVariables>;
export const GetStationGroupsDocument = new TypedDocumentString(`
    query getStationGroups($companyId: ID!) {
  cabinet {
    stationGroups(companyId: $companyId) {
      id
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationGroupsQuery, GetStationGroupsQueryVariables>;
export const CreateConstraintByContractDocument = new TypedDocumentString(`
    mutation createConstraintByContract($data: ConstraintsContractTemplateData!) {
  createConstraintByContract(data: $data) {
    id
    azsContract
    corpClientId
    contractCorpClientId
    allow
    azsBusinessType
    azsNumber
    corpOfficialName
    contractBusinessType
    contractNumber
  }
}
    `) as unknown as TypedDocumentString<CreateConstraintByContractMutation, CreateConstraintByContractMutationVariables>;
export const EditConstraintByContractDocument = new TypedDocumentString(`
    mutation editConstraintByContract($data: ConstraintsContractTemplateData!) {
  editConstraintByContract(data: $data) {
    id
    azsContract
    corpClientId
    contractCorpClientId
    allow
    azsBusinessType
    azsNumber
    corpOfficialName
    contractBusinessType
    contractNumber
  }
}
    `) as unknown as TypedDocumentString<EditConstraintByContractMutation, EditConstraintByContractMutationVariables>;
export const GetOrganizationDataDocument = new TypedDocumentString(`
    query getOrganizationData($id: ID!, $getPartnerId: Boolean) {
  getOrganizationData(id: $id, getPartnerId: $getPartnerId) {
    id
    officialName
    firmType
    contracts {
      id
      number
      businessType
    }
    taxiPartnerId
  }
}
    `) as unknown as TypedDocumentString<GetOrganizationDataQuery, GetOrganizationDataQueryVariables>;
export const GetConstraintsByContractsDocument = new TypedDocumentString(`
    query getConstraintsByContracts($id: ID!, $filter: ConstraintsContractsQueryParams!) {
  cabinet {
    company(id: $id) {
      getConstraintsByContracts(filter: $filter) {
        items {
          id
          allow
          corpId
          officialName
          contract {
            id
            businessType
            number
          }
          azsContract {
            id
            businessType
            number
          }
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetConstraintsByContractsQuery, GetConstraintsByContractsQueryVariables>;
export const RemoveAllConstraintsByContractDocument = new TypedDocumentString(`
    mutation removeAllConstraintsByContract($id: ID!, $filter: ConstraintsContractsQueryParams!) {
  removeAllConstraintsByContract(id: $id, filter: $filter)
}
    `) as unknown as TypedDocumentString<RemoveAllConstraintsByContractMutation, RemoveAllConstraintsByContractMutationVariables>;
export const EditAllConstraintsByContractDocument = new TypedDocumentString(`
    mutation editAllConstraintsByContract($id: ID!, $filter: ConstraintsContractsQueryParams!, $allow: Boolean!) {
  editAllConstraintsByContract(id: $id, filter: $filter, allow: $allow)
}
    `) as unknown as TypedDocumentString<EditAllConstraintsByContractMutation, EditAllConstraintsByContractMutationVariables>;
export const RemoveConstraintByContractDocument = new TypedDocumentString(`
    mutation removeConstraintByContract($id: ID!) {
  removeConstraintByContract(id: $id)
}
    `) as unknown as TypedDocumentString<RemoveConstraintByContractMutation, RemoveConstraintByContractMutationVariables>;
export const GetConstraintsByAzsDocument = new TypedDocumentString(`
    query getConstraintsByAZS($id: ID!, $filter: QueryParams!) {
  cabinet {
    company(id: $id) {
      getConstraintsByAZS(filter: $filter) {
        items {
          id
          taxiPartnerId
          corpName
          name
          address
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetConstraintsByAzsQuery, GetConstraintsByAzsQueryVariables>;
export const GetCompanyStationsByConstraintsDocument = new TypedDocumentString(`
    query getCompanyStationsByConstraints($companyId: ID!, $filter: QueryParams!) {
  cabinet {
    company(id: $companyId) {
      getCompanyStationsByConstraints(filter: $filter) {
        count
        items {
          id
          name
          address
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyStationsByConstraintsQuery, GetCompanyStationsByConstraintsQueryVariables>;
export const CreateConstraintByAzsDocument = new TypedDocumentString(`
    mutation createConstraintByAzs($companyId: ID, $partnerId: ID!, $stationsIds: [ID!], $query: String) {
  createConstraintByAzs(
    companyId: $companyId
    partnerId: $partnerId
    stationsIds: $stationsIds
    query: $query
  )
}
    `) as unknown as TypedDocumentString<CreateConstraintByAzsMutation, CreateConstraintByAzsMutationVariables>;
export const RemoveAllConstraintsByAzsDocument = new TypedDocumentString(`
    mutation removeAllConstraintsByAzs($companyId: ID!, $query: String) {
  removeAllConstraintsByAzs(companyId: $companyId, query: $query)
}
    `) as unknown as TypedDocumentString<RemoveAllConstraintsByAzsMutation, RemoveAllConstraintsByAzsMutationVariables>;
export const RemoveConstraintByAzsDocument = new TypedDocumentString(`
    mutation removeConstraintByAzs($id: ID!, $partnerId: ID!) {
  removeConstraintByAzs(id: $id, partnerId: $partnerId)
}
    `) as unknown as TypedDocumentString<RemoveConstraintByAzsMutation, RemoveConstraintByAzsMutationVariables>;
export const CarsGetCompanyCarPageDocument = new TypedDocumentString(`
    query carsGetCompanyCarPage($companyId: ID, $contractId: ID, $partnerId: ID, $carId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId, partnerId: $partnerId) {
      car(id: $carId) {
        id
        name
        number
        region
        drivers {
          id
          name
          phone
          partnerId
          partnerName
          isActive
          limits {
            day
            week
            month
            fuels
            blocked
            limitsType
            balance
          }
        }
        partners {
          id
          name
          status
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                corp
              }
              costReq {
                fact
                corp
              }
              prices {
                fact
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CarsGetCompanyCarPageQuery, CarsGetCompanyCarPageQueryVariables>;
export const CarsRefreshCompanyCarPageDocument = new TypedDocumentString(`
    query carsRefreshCompanyCarPage($companyId: ID, $partnerId: ID, $carId: ID!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      car(id: $carId) {
        id
        name
        number
        region
        drivers {
          id
          name
          phone
          partnerId
          partnerName
          isActive
          limits {
            day
            week
            month
            fuels
            blocked
            limitsType
            balance
          }
        }
        partners {
          id
          name
          status
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CarsRefreshCompanyCarPageQuery, CarsRefreshCompanyCarPageQueryVariables>;
export const CarsAddCarDocument = new TypedDocumentString(`
    mutation carsAddCar($companyId: ID!, $partnerId: [ID!]!, $car: CarData!) {
  addCar(companyId: $companyId, partnerId: $partnerId, data: $car) {
    result
    message
  }
}
    `) as unknown as TypedDocumentString<CarsAddCarMutation, CarsAddCarMutationVariables>;
export const CarsGetCarsByQueryDocument = new TypedDocumentString(`
    query carsGetCarsByQuery($companyId: ID, $contractId: ID, $query: String) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      cars(query: $query) {
        items {
          id
          number
          partners {
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CarsGetCarsByQueryQuery, CarsGetCarsByQueryQueryVariables>;
export const CodegenMockDocument = new TypedDocumentString(`
    query codegenMock($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<CodegenMockQuery, CodegenMockQueryVariables>;
export const CommonGetCompanyUsersDocument = new TypedDocumentString(`
    query CommonGetCompanyUsers($companyId: ID, $partnerId: ID, $contractId: ID, $query: String) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId, contractId: $contractId) {
      users(query: $query) {
        count
        items {
          id
          phone
          ... on LKUser {
            name
            email
            role
            access {
              id
              partners {
                id
                name
              }
            }
            lastActivity
          }
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CommonGetCompanyUsersQuery, CommonGetCompanyUsersQueryVariables>;
export const CommonAddUserDocument = new TypedDocumentString(`
    mutation CommonAddUser($companyId: ID!, $user: UserData!) {
  addUser(companyId: $companyId, data: $user)
}
    `) as unknown as TypedDocumentString<CommonAddUserMutation, CommonAddUserMutationVariables>;
export const CommonRequestUserPasswordResetDocument = new TypedDocumentString(`
    mutation CommonRequestUserPasswordReset($companyId: ID!, $userId: ID!) {
  sendRestoreUserPasswordEmail(companyId: $companyId, id: $userId)
}
    `) as unknown as TypedDocumentString<CommonRequestUserPasswordResetMutation, CommonRequestUserPasswordResetMutationVariables>;
export const CommonDeleteUserDocument = new TypedDocumentString(`
    mutation CommonDeleteUser($companyId: ID!, $userId: ID!) {
  removeUser(companyId: $companyId, id: $userId)
}
    `) as unknown as TypedDocumentString<CommonDeleteUserMutation, CommonDeleteUserMutationVariables>;
export const CommonSaveCompanyDataDocument = new TypedDocumentString(`
    mutation CommonSaveCompanyData($companyId: ID, $contractId: ID, $data: CompanyData!) {
  saveCompany(companyId: $companyId, contractId: $contractId, data: $data) {
    result
    message
  }
}
    `) as unknown as TypedDocumentString<CommonSaveCompanyDataMutation, CommonSaveCompanyDataMutationVariables>;
export const CommonFetchCompanyStationsDocument = new TypedDocumentString(`
    query CommonFetchCompanyStations($companyId: ID!, $contractsType: String!, $page: Int, $size: Int, $query: String, $status: StationStatus, $partnerId: ID) {
  cabinet {
    company(id: $companyId) {
      stations(
        page: $page
        size: $size
        query: $query
        contractsType: $contractsType
        status: $status
        partnerId: $partnerId
      ) {
        count
        items {
          id
          name
          address
          lastOnline
          certificate
          certificateKey
          certificateExpiration
        }
        status {
          status
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CommonFetchCompanyStationsQuery, CommonFetchCompanyStationsQueryVariables>;
export const CommonGetCompanyOrdersDocument = new TypedDocumentString(`
    query CommonGetCompanyOrders($companyId: ID, $contractId: ID, $partnerId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId, contractId: $contractId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CommonGetCompanyOrdersQuery, CommonGetCompanyOrdersQueryVariables>;
export const CommonDownloadReportDocument = new TypedDocumentString(`
    query CommonDownloadReport($companyId: ID, $contractId: ID, $partnerId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId, partnerId: $partnerId) {
      ordersNewReportLink(format: excel, filter: $filter)
    }
  }
}
    `) as unknown as TypedDocumentString<CommonDownloadReportQuery, CommonDownloadReportQueryVariables>;
export const SetOrganizationModeDocument = new TypedDocumentString(`
    mutation SetOrganizationMode($companyId: ID!, $mode: OrganizationMode!) {
  setOrganizationMode(companyId: $companyId, mode: $mode)
}
    `) as unknown as TypedDocumentString<SetOrganizationModeMutation, SetOrganizationModeMutationVariables>;
export const GetCompanyContractsDatesDocument = new TypedDocumentString(`
    query getCompanyContractsDates($companyId: ID) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        date
        finishDate
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyContractsDatesQuery, GetCompanyContractsDatesQueryVariables>;
export const SaveBulkFuelsDocument = new TypedDocumentString(`
    mutation SaveBulkFuels($fuelData: [FuelData!]!) {
  saveBulkFuels(fuelData: $fuelData)
}
    `) as unknown as TypedDocumentString<SaveBulkFuelsMutation, SaveBulkFuelsMutationVariables>;
export const CompanyAddUserToCompanyDocument = new TypedDocumentString(`
    mutation companyAddUserToCompany($companyId: ID!, $user: UserData!) {
  addUser(companyId: $companyId, data: $user)
}
    `) as unknown as TypedDocumentString<CompanyAddUserToCompanyMutation, CompanyAddUserToCompanyMutationVariables>;
export const RemoveCompanyUserDocument = new TypedDocumentString(`
    mutation removeCompanyUser($companyId: ID!, $userId: ID!) {
  removeUser(companyId: $companyId, id: $userId)
}
    `) as unknown as TypedDocumentString<RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables>;
export const GetCompanyDepartmentStatsDocument = new TypedDocumentString(`
    query getCompanyDepartmentStats($companyId: ID, $partnerId: ID) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      partners {
        id
      }
      drivers {
        count
      }
      cars {
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyDepartmentStatsQuery, GetCompanyDepartmentStatsQueryVariables>;
export const AddCompanyDepartmentDocument = new TypedDocumentString(`
    mutation addCompanyDepartment($companyId: ID!, $data: PartnerData!, $parentId: ID, $moveDrivers: Boolean) {
  addPartner(
    companyId: $companyId
    data: $data
    parentId: $parentId
    moveDrivers: $moveDrivers
  ) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AddCompanyDepartmentMutation, AddCompanyDepartmentMutationVariables>;
export const CompanyCreateNewContractDocument = new TypedDocumentString(`
    mutation companyCreateNewContract($companyId: ID!, $data: ContractData!) {
  createContract(companyId: $companyId, data: $data) {
    result
    message
  }
}
    `) as unknown as TypedDocumentString<CompanyCreateNewContractMutation, CompanyCreateNewContractMutationVariables>;
export const CompanyUpdateCompanyContractDocument = new TypedDocumentString(`
    mutation companyUpdateCompanyContract($contractId: ID!, $data: CompanyData!) {
  saveCompany(contractId: $contractId, data: $data) {
    result
    message
  }
}
    `) as unknown as TypedDocumentString<CompanyUpdateCompanyContractMutation, CompanyUpdateCompanyContractMutationVariables>;
export const GetCompanyPaymentsByCompanyIdDocument = new TypedDocumentString(`
    query GetCompanyPaymentsByCompanyId($companyId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(id: $companyId) {
      payments {
        count
        items(filter: $filter) {
          status
          statusDescription
          createdAt
          provider {
            name
          }
          balances {
            amount
            description
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyPaymentsByCompanyIdQuery, GetCompanyPaymentsByCompanyIdQueryVariables>;
export const GetCompanyPaymentsByContractIdDocument = new TypedDocumentString(`
    query GetCompanyPaymentsByContractId($contractId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(contractId: $contractId) {
      payments {
        count
        items(filter: $filter) {
          status
          statusDescription
          createdAt
          provider {
            name
          }
          balances {
            amount
            description
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyPaymentsByContractIdQuery, GetCompanyPaymentsByContractIdQueryVariables>;
export const GetAdminAzsStationsDocument = new TypedDocumentString(`
    query getAdminAzsStations($companyId: ID!, $query: String, $state: [StationState!]!, $status: StationStatus, $region: String, $groupId: ID) {
  cabinet {
    company(id: $companyId) {
      ... on AzsCompany {
        stationPartner {
          system {
            protocol
          }
        }
        stations(
          query: $query
          state: $state
          status: $status
          region: $region
          groupId: $groupId
        ) {
          active
          count
          items {
            id
            name
            nameApi
            brand
            address
            color
            state
            status
            groupId
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAdminAzsStationsQuery, GetAdminAzsStationsQueryVariables>;
export const GetColorsDocument = new TypedDocumentString(`
    query getColors {
  colors {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetColorsQuery, GetColorsQueryVariables>;
export const GetRegionsDocument = new TypedDocumentString(`
    query getRegions {
  regions {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetAdminAzsStationsPageDocument = new TypedDocumentString(`
    query getAdminAzsStationsPage($companyId: ID!, $query: String, $state: [StationState!]!, $status: StationStatus, $region: String, $groupId: ID, $page: Int, $pageSize: Int) {
  cabinet {
    company(id: $companyId) {
      stations(
        query: $query
        state: $state
        status: $status
        region: $region
        groupId: $groupId
        page: $page
        size: $pageSize
      ) {
        count
        items {
          id
          name
          nameApi
          brand
          address
          color
          status
          state
          point
          promo
          groupId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAdminAzsStationsPageQuery, GetAdminAzsStationsPageQueryVariables>;
export const GetCompanyStationsDocument = new TypedDocumentString(`
    query getCompanyStations($companyId: ID!, $query: String, $page: Int, $size: Int) {
  cabinet {
    company(id: $companyId) {
      stations(query: $query, page: $page, size: $size) {
        count
        items {
          id
          name
          nameApi
          address
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyStationsQuery, GetCompanyStationsQueryVariables>;
export const GetCompaniesDocument = new TypedDocumentString(`
    query getCompanies($filter: CompaniesFilterParams!) {
  cabinet {
    findCompanies(filter: $filter) {
      items {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const FetchCompanyContractsAndBalanceDocument = new TypedDocumentString(`
    query FetchCompanyContractsAndBalance($companyId: ID!, $filter: PaymentsQueryParams) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        number
        businessType
      }
      contract {
        balanceLimit
        balance
      }
      payments {
        count
        items(filter: $filter) {
          id
          amount
          type
          status
          statusDescription
          transactionId
          provider {
            name
          }
          createdAt
          balances {
            amount
            description
          }
          ... on OnlinePayment {
            pan
          }
        }
      }
    }
  }
  paymentProviders(companyId: $companyId) {
    id
    name
    service
    type
  }
}
    `) as unknown as TypedDocumentString<FetchCompanyContractsAndBalanceQuery, FetchCompanyContractsAndBalanceQueryVariables>;
export const RefetchCompanyContractsAndBalanceDocument = new TypedDocumentString(`
    query RefetchCompanyContractsAndBalance($companyId: ID, $contractId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      contract {
        balanceLimit
        balance
        id
      }
      payments {
        items(filter: $filter) {
          id
          amount
          type
          status
          statusDescription
          transactionId
          provider {
            name
          }
          createdAt
          balances {
            amount
            description
          }
          ... on OnlinePayment {
            pan
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RefetchCompanyContractsAndBalanceQuery, RefetchCompanyContractsAndBalanceQueryVariables>;
export const CompanyFetchAggregatorTransactionsDocument = new TypedDocumentString(`
    query CompanyFetchAggregatorTransactions($companyId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        summary {
          name
          quantity
          total
          discount
        }
        items {
          id
          date
          status
          statusMessage
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyFetchAggregatorTransactionsQuery, CompanyFetchAggregatorTransactionsQueryVariables>;
export const CompanyFetchAggregatorContractsDocument = new TypedDocumentString(`
    query CompanyFetchAggregatorContracts($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        number
        date
        finishDate
        paymentType
        discount
        businessType
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyFetchAggregatorContractsQuery, CompanyFetchAggregatorContractsQueryVariables>;
export const CompanyGetCustomContractsDocument = new TypedDocumentString(`
    query CompanyGetCustomContracts($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      contracts(contractsType: online, contractsSubtype: [custom]) {
        number
        discount
        ... on CustomContract {
          discountOrganizations
        }
      }
      verified
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCustomContractsQuery, CompanyGetCustomContractsQueryVariables>;
export const FetchAdminAzsTransactionsDocument = new TypedDocumentString(`
    query FetchAdminAzsTransactions($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          status
          corp {
            driver {
              name
            }
            car {
              number
            }
          }
          user {
            phone
          }
          station {
            name
            address
          }
          payment {
            type
            source
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          total
          quantity
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FetchAdminAzsTransactionsQuery, FetchAdminAzsTransactionsQueryVariables>;
export const DownloadAdminAzsTransactionsDocument = new TypedDocumentString(`
    query DownloadAdminAzsTransactions($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNewReportLink(filter: $filter, format: excel)
    }
  }
}
    `) as unknown as TypedDocumentString<DownloadAdminAzsTransactionsQuery, DownloadAdminAzsTransactionsQueryVariables>;
export const CompanyGetCompanyNameByIdDocument = new TypedDocumentString(`
    query companyGetCompanyNameById($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      name
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCompanyNameByIdQuery, CompanyGetCompanyNameByIdQueryVariables>;
export const CompanyGetCompanyContractsByIdDocument = new TypedDocumentString(`
    query companyGetCompanyContractsById($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        number
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCompanyContractsByIdQuery, CompanyGetCompanyContractsByIdQueryVariables>;
export const CompanyGetCardsDocument = new TypedDocumentString(`
    query companyGetCards($id: ID) {
  cabinet {
    company(id: $id) {
      cards {
        cards {
          token
          psp
          number
          label
          status
          limitsShort
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCardsQuery, CompanyGetCardsQueryVariables>;
export const CompanyGetCardDocument = new TypedDocumentString(`
    query companyGetCard($companyId: ID!, $token: String!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      cards {
        card(token: $token) {
          psp
          number
          label
          status
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          station {
            name
            address
          }
          ... on OfflineOrder {
            cardNumber
            bankProduct
            items {
              id
              type
              quantityReq
              quantityReport
              groupName
              shortName
              prices {
                corp
                fact
                user
                station
              }
              cost {
                corp
                fact
                user
                station
              }
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCardQuery, CompanyGetCardQueryVariables>;
export const ChangeBusinessCardSettingsDocument = new TypedDocumentString(`
    mutation changeBusinessCardSettings($companyId: ID!, $token: String!, $status: Boolean, $label: String) {
  changeBusinessCardSettings(
    companyId: $companyId
    token: $token
    status: $status
    label: $label
  )
}
    `) as unknown as TypedDocumentString<ChangeBusinessCardSettingsMutation, ChangeBusinessCardSettingsMutationVariables>;
export const GetCardTemplatesDocument = new TypedDocumentString(`
    query getCardTemplates($id: ID!) {
  cabinet {
    company(id: $id) {
      cards {
        templates {
          id
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardTemplatesQuery, GetCardTemplatesQueryVariables>;
export const GetCardTemplateDocument = new TypedDocumentString(`
    query getCardTemplate($companyId: ID!, $templateId: ID!) {
  cabinet {
    company(id: $companyId) {
      cards {
        template(id: $templateId) {
          name
          groupPetroleum {
            groupRestriction {
              allowed
              unlimited
            }
            restrictions {
              allowed
              name
              period
              quantity
              unit
              unlimited
            }
          }
          groupServices {
            groupRestriction {
              allowed
              period
              quantity
              unit
              unlimited
            }
          }
          groupGoods {
            groupRestriction {
              allowed
              period
              quantity
              unit
              unlimited
            }
          }
          groupCafe {
            groupRestriction {
              allowed
              period
              quantity
              unit
              unlimited
            }
          }
          regions
          nets
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardTemplateQuery, GetCardTemplateQueryVariables>;
export const CreateCardTemplateDocument = new TypedDocumentString(`
    mutation createCardTemplate($companyId: ID!, $template: CardTemplateData!) {
  createCardTemplate(companyId: $companyId, template: $template) {
    name
  }
}
    `) as unknown as TypedDocumentString<CreateCardTemplateMutation, CreateCardTemplateMutationVariables>;
export const UpdateCardTemplateDocument = new TypedDocumentString(`
    mutation updateCardTemplate($companyId: ID!, $templateId: ID!, $template: CardTemplateData!) {
  updateCardTemplate(
    companyId: $companyId
    templateId: $templateId
    template: $template
  ) {
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateCardTemplateMutation, UpdateCardTemplateMutationVariables>;
export const DeleteCardTemplateDocument = new TypedDocumentString(`
    mutation deleteCardTemplate($companyId: ID!, $templateId: ID!) {
  deleteCardTemplate(companyId: $companyId, templateId: $templateId)
}
    `) as unknown as TypedDocumentString<DeleteCardTemplateMutation, DeleteCardTemplateMutationVariables>;
export const GetCardLimitsDocument = new TypedDocumentString(`
    query getCardLimits($id: ID!, $token: String!) {
  cabinet {
    company(id: $id) {
      cards {
        card(token: $token) {
          balance {
            id
            name
            groupPetroleum {
              groupRestriction {
                allowed
                unlimited
              }
              restrictions {
                allowed
                name
                period
                quantity
                unit
                unlimited
                balanceQuantity
                usedQuantity
              }
            }
            groupServices {
              groupRestriction {
                allowed
                period
                quantity
                unit
                unlimited
              }
            }
            groupGoods {
              groupRestriction {
                allowed
                period
                quantity
                unit
                unlimited
              }
            }
            groupCafe {
              groupRestriction {
                allowed
                period
                quantity
                unit
                unlimited
              }
            }
          }
          limits {
            regions
            nets
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardLimitsQuery, GetCardLimitsQueryVariables>;
export const UpdateCardLimitsDocument = new TypedDocumentString(`
    mutation updateCardLimits($companyId: ID!, $token: String!, $limits: CardLimitsData!) {
  updateCardLimits(companyId: $companyId, token: $token, limits: $limits)
}
    `) as unknown as TypedDocumentString<UpdateCardLimitsMutation, UpdateCardLimitsMutationVariables>;
export const GetCardsDataDocument = new TypedDocumentString(`
    query getCardsData($id: ID!) {
  cabinet {
    company(id: $id) {
      cards {
        fuels {
          name
        }
        regions {
          name
        }
        nets {
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardsDataQuery, GetCardsDataQueryVariables>;
export const GetCompanyVerifiedDocument = new TypedDocumentString(`
    query getCompanyVerified($id: ID, $contractId: ID) {
  cabinet {
    company(id: $id, contractId: $contractId) {
      verified
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyVerifiedQuery, GetCompanyVerifiedQueryVariables>;
export const GetCompanyTypeDocument = new TypedDocumentString(`
    query getCompanyType($id: ID!) {
  cabinet {
    company(id: $id) {
      type
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyTypeQuery, GetCompanyTypeQueryVariables>;
export const CorpClientGetCompanyPageDocument = new TypedDocumentString(`
    query corpClientGetCompanyPage($companyId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      id
      name
      type
      status
      source
      mode
      registered
      payments {
        balance
      }
      contract {
        id
        balanceLimit
      }
      contracts {
        id
        number
        businessType
      }
      cars {
        count
      }
      ... on TKCompany {
        stat {
          driversCount
          departmentsCount
          allDepartmentsCount
          driversCount
          activeDriversCount
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          payment {
            type
            source
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                corp
              }
              costReq {
                fact
                corp
              }
              prices {
                fact
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CorpClientGetCompanyPageQuery, CorpClientGetCompanyPageQueryVariables>;
export const CorpClientGetContractBalanceDocument = new TypedDocumentString(`
    query corpClientGetContractBalance($contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      contract {
        balance
        balanceLimit
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CorpClientGetContractBalanceQuery, CorpClientGetContractBalanceQueryVariables>;
export const CorpClientFetchDriversTabDocument = new TypedDocumentString(`
    query CorpClientFetchDriversTab($companyId: ID!, $status: DriverStatus, $query: String, $partners: [String!], $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      departments {
        id
        name
        children {
          id
          name
        }
      }
      reportType
      drivers(
        status: $status
        query: $query
        partners: $partners
        page: $page
        size: $size
      ) {
        count
        items {
          id
          name
          phone
          partnerId
          partnerName
          partnerParentName
          isActive
          limits {
            minLeft
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          car {
            id
            number
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CorpClientFetchDriversTabQuery, CorpClientFetchDriversTabQueryVariables>;
export const CorpClientRefetchDriversTabDocument = new TypedDocumentString(`
    query CorpClientRefetchDriversTab($companyId: ID!, $status: DriverStatus, $query: String, $partners: [String!], $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      drivers(
        status: $status
        query: $query
        partners: $partners
        page: $page
        size: $size
      ) {
        count
        items {
          id
          name
          phone
          partnerId
          partnerName
          partnerParentName
          isActive
          limits {
            minLeft
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          car {
            id
            number
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CorpClientRefetchDriversTabQuery, CorpClientRefetchDriversTabQueryVariables>;
export const GetOfflineClientsDocument = new TypedDocumentString(`
    query GetOfflineClients($filter: CompaniesFilterParams!, $page: Int, $size: Int) {
  cabinet {
    findCompanies(filter: $filter, page: $page, size: $size) {
      count
      items {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineClientsQuery, GetOfflineClientsQueryVariables>;
export const GetCompanyOfflineTransactionsDocument = new TypedDocumentString(`
    query GetCompanyOfflineTransactions($cardOwnerId: ID, $dateFrom: String!, $dateTo: String!) {
  cabinet {
    company(cardOwnerId: $cardOwnerId) {
      name
      summaryByFuelType(from: $dateFrom, to: $dateTo) {
        shortName
        volumeFact
        costFact
        costFirm
        costRefund
        firmCostRefund
        volumeRefund
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyOfflineTransactionsQuery, GetCompanyOfflineTransactionsQueryVariables>;
export const GetDriversDocument = new TypedDocumentString(`
    query getDrivers($companyId: ID, $partnerId: ID, $query: String, $status: DriverStatus, $page: Int, $size: Int) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      drivers(query: $query, status: $status, page: $page, size: $size) {
        hasAny
        count
        items {
          id
          name
          phone
          created
          partnerId
          partnerDriverId
          partnerName
          isActive
          limits {
            minLeft
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          car {
            id
            number
          }
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriversQuery, GetDriversQueryVariables>;
export const GetDriversListPageDocument = new TypedDocumentString(`
    query getDriversListPage($companyId: ID, $partnerId: ID, $status: DriverStatus, $query: String, $page: Int, $size: Int) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      drivers(query: $query, status: $status, page: $page, size: $size) {
        hasAny
        count
        items {
          id
          name
          phone
          created
          partnerId
          partnerDriverId
          partnerName
          isActive
          limits {
            minLeft
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          car {
            id
            number
          }
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriversListPageQuery, GetDriversListPageQueryVariables>;
export const DriversGetDriverPageDocument = new TypedDocumentString(`
    query driversGetDriverPage($companyId: ID!, $partnerId: ID!, $driverId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      type
      driver(id: $driverId, partnerId: $partnerId) {
        id
        name
        phone
        created
        partnerCars {
          partner {
            id
            name
          }
          car {
            id
            number
          }
          limits {
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          isActive
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                corp
              }
              costReq {
                fact
                corp
              }
              prices {
                fact
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
      departments {
        id
        name
        children {
          id
          name
          children {
            id
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DriversGetDriverPageQuery, DriversGetDriverPageQueryVariables>;
export const DriversRefreshDriverPageDocument = new TypedDocumentString(`
    query driversRefreshDriverPage($companyId: ID!, $partnerId: ID!, $driverId: ID!) {
  cabinet {
    company(id: $companyId) {
      type
      driver(id: $driverId, partnerId: $partnerId) {
        id
        name
        phone
        created
        partnerCars {
          partner {
            id
            name
          }
          car {
            id
            number
          }
          limits {
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          isActive
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
      departments {
        id
        name
        children {
          id
          name
          children {
            id
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DriversRefreshDriverPageQuery, DriversRefreshDriverPageQueryVariables>;
export const DriversAddDriverDocument = new TypedDocumentString(`
    mutation driversAddDriver($companyId: ID!, $driver: DriverData!) {
  addDriver(companyId: $companyId, data: $driver) {
    id
  }
}
    `) as unknown as TypedDocumentString<DriversAddDriverMutation, DriversAddDriverMutationVariables>;
export const GetDriverBalanceHistoryDocument = new TypedDocumentString(`
    query getDriverBalanceHistory($companyId: ID, $partnerId: ID!, $contractId: ID, $driverId: ID!, $filter: QueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId, contractId: $contractId) {
      driver(id: $driverId, partnerId: $partnerId) {
        balanceHistory(filter: $filter) {
          items {
            total
            date
          }
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriverBalanceHistoryQuery, GetDriverBalanceHistoryQueryVariables>;
export const GetDriverExpensesDocument = new TypedDocumentString(`
    query getDriverExpenses($companyId: ID!, $partnerId: ID!, $driverId: ID!) {
  cabinet {
    company(id: $companyId) {
      driver(partnerId: $partnerId, id: $driverId) {
        limitsAndExpenses {
          limitsType
          isQuantity
          dayExpenses
          weekExpenses
          monthExpenses
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriverExpensesQuery, GetDriverExpensesQueryVariables>;
export const GetFaqDocument = new TypedDocumentString(`
    query getFAQ {
  faq {
    id
    question
    answer
    sorting
  }
}
    `) as unknown as TypedDocumentString<GetFaqQuery, GetFaqQueryVariables>;
export const AddFaqDocument = new TypedDocumentString(`
    mutation addFaq($question: String!, $answer: String, $sorting: Float) {
  addFaq(question: $question, answer: $answer, sorting: $sorting) {
    id
  }
}
    `) as unknown as TypedDocumentString<AddFaqMutation, AddFaqMutationVariables>;
export const RemoveQuestionDocument = new TypedDocumentString(`
    mutation removeQuestion($id: String!) {
  removeFaq(id: $id)
}
    `) as unknown as TypedDocumentString<RemoveQuestionMutation, RemoveQuestionMutationVariables>;
export const UpdateQuestionDocument = new TypedDocumentString(`
    mutation updateQuestion($id: String!, $question: String, $answer: String, $sorting: Float) {
  editFaq(id: $id, question: $question, answer: $answer, sorting: $sorting) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const GetStationsGroupsDocument = new TypedDocumentString(`
    query getStationsGroups($filter: StationsGroupQueryParams!) {
  cabinet {
    stationsGroups(filter: $filter) {
      items {
        id
        name
        description
      }
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupsQuery, GetStationsGroupsQueryVariables>;
export const GetIndividualDiscountsGroupPageDocument = new TypedDocumentString(`
    query getIndividualDiscountsGroupPage($groupId: ID!) {
  cabinet {
    stationsGroup(id: $groupId) {
      name
      description
      stations(filter: {}) {
        items {
          id
          name
          address
          organizationName
        }
        count
      }
      discountsGroups(filter: {}) {
        items {
          contractId
          contractNumber
          organizationName
          fuels
          discounts
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetIndividualDiscountsGroupPageQuery, GetIndividualDiscountsGroupPageQueryVariables>;
export const GetStationsGroupStationsDocument = new TypedDocumentString(`
    query getStationsGroupStations($groupId: ID!, $filter: QueryParams!) {
  cabinet {
    stationsGroup(id: $groupId) {
      stations(filter: $filter) {
        items {
          id
          name
          address
          organizationName
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupStationsQuery, GetStationsGroupStationsQueryVariables>;
export const GetStationsGroupDiscountsDocument = new TypedDocumentString(`
    query getStationsGroupDiscounts($groupId: ID!, $filter: QueryParams!) {
  cabinet {
    stationsGroup(id: $groupId) {
      discountsGroups(filter: $filter) {
        items {
          contractId
          contractNumber
          organizationName
          fuels
          discounts
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupDiscountsQuery, GetStationsGroupDiscountsQueryVariables>;
export const GetStationsGroupFuelDiscountDocument = new TypedDocumentString(`
    query getStationsGroupFuelDiscount($groupId: ID!, $discountId: ID!) {
  cabinet {
    stationsGroup(id: $groupId) {
      contractDiscount(id: $discountId) {
        fuelId
        discount
        startDate
        endDate
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupFuelDiscountQuery, GetStationsGroupFuelDiscountQueryVariables>;
export const GetStationsGroupContractDiscountsDocument = new TypedDocumentString(`
    query getStationsGroupContractDiscounts($groupId: ID!, $contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      name
      contract {
        number
      }
    }
    stationsGroup(id: $groupId) {
      name
      contractDiscounts(contractId: $contractId) {
        items {
          discountId
          fuelId
          discount
          startDate
          endDate
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupContractDiscountsQuery, GetStationsGroupContractDiscountsQueryVariables>;
export const GetStationsGroupNameAndDescriptionDocument = new TypedDocumentString(`
    query getStationsGroupNameAndDescription($groupId: ID!) {
  cabinet {
    stationsGroup(id: $groupId) {
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupNameAndDescriptionQuery, GetStationsGroupNameAndDescriptionQueryVariables>;
export const AddStationsGroupDocument = new TypedDocumentString(`
    mutation addStationsGroup($name: String!, $description: String!, $companyId: ID, $stationsIDs: [String!], $query: String) {
  addStationsGroup(
    name: $name
    description: $description
    companyId: $companyId
    stationsIDs: $stationsIDs
    query: $query
  )
}
    `) as unknown as TypedDocumentString<AddStationsGroupMutation, AddStationsGroupMutationVariables>;
export const EditStationsGroupDocument = new TypedDocumentString(`
    mutation editStationsGroup($id: ID!, $name: String!, $description: String!, $stationsIDs: [String!], $companyId: ID, $query: String) {
  editStationsGroup(
    id: $id
    name: $name
    description: $description
    stationsIDs: $stationsIDs
    companyId: $companyId
    query: $query
  )
}
    `) as unknown as TypedDocumentString<EditStationsGroupMutation, EditStationsGroupMutationVariables>;
export const AddCorpClientStationsGroupFuelDiscountsDocument = new TypedDocumentString(`
    mutation addCorpClientStationsGroupFuelDiscounts($groupId: ID!, $contractId: ID!, $discount: Float!, $fuelsIds: [Int!]!, $startDate: DateTime, $endDate: DateTime) {
  addCorpClientStationsGroupFuelDiscounts(
    groupId: $groupId
    contractId: $contractId
    fuelsIds: $fuelsIds
    discount: $discount
    startDate: $startDate
    endDate: $endDate
  )
}
    `) as unknown as TypedDocumentString<AddCorpClientStationsGroupFuelDiscountsMutation, AddCorpClientStationsGroupFuelDiscountsMutationVariables>;
export const EditCorpClientStationsGroupFuelDiscountDocument = new TypedDocumentString(`
    mutation editCorpClientStationsGroupFuelDiscount($discountId: ID!, $discount: Float!, $startDate: DateTime, $endDate: DateTime) {
  editCorpClientStationsGroupFuelDiscount(
    discountId: $discountId
    discount: $discount
    startDate: $startDate
    endDate: $endDate
  )
}
    `) as unknown as TypedDocumentString<EditCorpClientStationsGroupFuelDiscountMutation, EditCorpClientStationsGroupFuelDiscountMutationVariables>;
export const DeleteStationsGroupStationsDocument = new TypedDocumentString(`
    mutation deleteStationsGroupStations($id: ID!) {
  deleteStationsGroupStations(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupStationsMutation, DeleteStationsGroupStationsMutationVariables>;
export const DeleteStationsGroupStationDocument = new TypedDocumentString(`
    mutation deleteStationsGroupStation($groupId: ID!, $stationId: ID!) {
  deleteStationsGroupStation(groupId: $groupId, stationId: $stationId)
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupStationMutation, DeleteStationsGroupStationMutationVariables>;
export const DeleteStationsGroupFuelDiscountsDocument = new TypedDocumentString(`
    mutation deleteStationsGroupFuelDiscounts($id: ID!) {
  deleteStationsGroupFuelDiscounts(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupFuelDiscountsMutation, DeleteStationsGroupFuelDiscountsMutationVariables>;
export const DeleteStationsGroupContractFuelDiscountsDocument = new TypedDocumentString(`
    mutation deleteStationsGroupContractFuelDiscounts($groupId: ID!, $contractId: ID!) {
  deleteStationsGroupContractFuelDiscounts(
    groupId: $groupId
    contractId: $contractId
  )
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupContractFuelDiscountsMutation, DeleteStationsGroupContractFuelDiscountsMutationVariables>;
export const DeleteStationsGroupFuelDiscountDocument = new TypedDocumentString(`
    mutation deleteStationsGroupFuelDiscount($id: ID!) {
  deleteStationsGroupFuelDiscount(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupFuelDiscountMutation, DeleteStationsGroupFuelDiscountMutationVariables>;
export const MapsFetchStationsDocument = new TypedDocumentString(`
    query mapsFetchStations {
  stations {
    id
    name
    address
    point
    prices {
      fuel {
        code
      }
      price
    }
  }
}
    `) as unknown as TypedDocumentString<MapsFetchStationsQuery, MapsFetchStationsQueryVariables>;
export const MapsFetchFindStationsDocument = new TypedDocumentString(`
    query MapsFetchFindStations($query: String) {
  stationsByES(query: $query, size: 5) {
    items {
      id
      name
      address
    }
  }
}
    `) as unknown as TypedDocumentString<MapsFetchFindStationsQuery, MapsFetchFindStationsQueryVariables>;
export const MapsFetchStationPointDocument = new TypedDocumentString(`
    query MapsFetchStationPoint($id: ID!) {
  station(id: $id) {
    point
  }
}
    `) as unknown as TypedDocumentString<MapsFetchStationPointQuery, MapsFetchStationPointQueryVariables>;
export const FetchOfflineCompanySettingsAndCatalogDocument = new TypedDocumentString(`
    query FetchOfflineCompanySettingsAndCatalog($companyId: ID!, $partnerId: ID!) {
  productCatalog {
    groupId
    groupName
    products {
      productId
      productName
    }
  }
  cabinet {
    company(id: $companyId) {
      ... on AzsCompany {
        settings(partnerId: $partnerId) {
          osnovans
        }
        productCatalog(partnerId: $partnerId) {
          groupId
          groupName
          parentGroupId
          discount
          internalId
          products {
            productId
            productName
            discount
            internalId
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FetchOfflineCompanySettingsAndCatalogQuery, FetchOfflineCompanySettingsAndCatalogQueryVariables>;
export const OfflineSaveCompanySettingsAndCatalogDocument = new TypedDocumentString(`
    mutation OfflineSaveCompanySettingsAndCatalog($companyId: ID!, $data: CompanyData!, $partnerId: ID!) {
  saveCompany(companyId: $companyId, data: $data, partnerId: $partnerId) {
    result
    message
  }
}
    `) as unknown as TypedDocumentString<OfflineSaveCompanySettingsAndCatalogMutation, OfflineSaveCompanySettingsAndCatalogMutationVariables>;
export const CreateOfflinePartnerDocument = new TypedDocumentString(`
    mutation CreateOfflinePartner($contract: String!, $firmId: String!, $name: String!, $organization: ID!, $osnovans: [Float!]) {
  createOfflinePartner(
    organization: $organization
    contract: $contract
    firmId: $firmId
    name: $name
    osnovans: $osnovans
  )
}
    `) as unknown as TypedDocumentString<CreateOfflinePartnerMutation, CreateOfflinePartnerMutationVariables>;
export const AddOfflineStationDocument = new TypedDocumentString(`
    mutation AddOfflineStation($partnerId: ID!, $stationData: NewOfflineStationData!) {
  addOfflineStation(partnerId: $partnerId, stationData: $stationData) {
    id
  }
}
    `) as unknown as TypedDocumentString<AddOfflineStationMutation, AddOfflineStationMutationVariables>;
export const GetOfflineTransactionsPageDocument = new TypedDocumentString(`
    query GetOfflineTransactionsPage($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          station {
            address
          }
          status
          statusMessage
          ... on OfflineOrder {
            owner {
              name
              shortName
            }
            cardNumber
            items {
              id
              type
              quantity
              groupName
              shortName
              prices {
                corp
                fact
                user
                station
              }
              cost {
                corp
                fact
                user
                station
              }
            }
          }
        }
        summary {
          name
          count
          quantity
          total
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineTransactionsPageQuery, GetOfflineTransactionsPageQueryVariables>;
export const GetOfflineTransactionsDownloadLinkDocument = new TypedDocumentString(`
    query GetOfflineTransactionsDownloadLink($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNewReportLink(filter: $filter, format: excel)
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineTransactionsDownloadLinkQuery, GetOfflineTransactionsDownloadLinkQueryVariables>;
export const GetOfflineOrderDocument = new TypedDocumentString(`
    query GetOfflineOrder($companyId: ID, $contractId: ID, $orderId: ID!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      orderNew(id: $orderId) {
        id
        date
        station {
          id
          name
          address
          organizationName
        }
        status
        statusMessage
        ... on OfflineOrder {
          mps
          owner {
            name
            shortName
          }
          items {
            id
            type
            quantityReq
            quantityReport
            groupName
            shortName
            prices {
              corp
              fact
              user
              station
            }
            cost {
              corp
              fact
              user
              station
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineOrderQuery, GetOfflineOrderQueryVariables>;
export const OrdersGetOrderDataDocument = new TypedDocumentString(`
    query ordersGetOrderData($fuelUpCompanyId: ID!, $orderId: ID!) {
  cabinet {
    company(id: $fuelUpCompanyId) {
      orderNew(id: $orderId) {
        ... on OnlineOrder {
          station {
            id
            name
            address
          }
          sberSpasiboDetails {
            credit
          }
          item {
            fuel {
              id
              name
            }
            quantityReport
            quantityReq
            costReport {
              fact
              station
              corp
              user
            }
            prices {
              fact
              station
              corp
            }
            discount {
              station
              corp
            }
          }
          corp {
            car {
              id
              number
            }
            driver {
              id
            }
            company {
              id
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrdersGetOrderDataQuery, OrdersGetOrderDataQueryVariables>;
export const OrdersModifyOrderDocument = new TypedDocumentString(`
    mutation ordersModifyOrder($orderId: ID!, $volume: Float, $discountCorp: Float, $discountStation: Float, $carId: ID, $fuelId: Int, $stationId: ID, $costPromotion: Float, $commentary: String!) {
  modifyOrder(
    id: $orderId
    volume: $volume
    discountCorp: $discountCorp
    discountStation: $discountStation
    carId: $carId
    fuelId: $fuelId
    stationId: $stationId
    costPromotion: $costPromotion
    commentary: $commentary
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<OrdersModifyOrderMutation, OrdersModifyOrderMutationVariables>;
export const GetPaymentsDocument = new TypedDocumentString(`
    query GetPayments($companyId: ID, $contractId: ID, $partnerId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(id: $companyId, contractId: $contractId, partnerId: $partnerId) {
      payments {
        balance
        needMoney
        count
        cards {
          id
          name
          provider {
            id
            name
          }
        }
        items(filter: $filter) {
          id
          amount
          type
          status
          statusDescription
          transactionId
          provider {
            name
          }
          createdAt
          balances {
            amount
            description
          }
          ... on OnlinePayment {
            pan
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetPaymentsQuery, GetPaymentsQueryVariables>;
export const GetPaymentProvidersDocument = new TypedDocumentString(`
    query GetPaymentProviders($companyId: ID) {
  paymentProviders(companyId: $companyId) {
    id
    name
    service
    type
  }
}
    `) as unknown as TypedDocumentString<GetPaymentProvidersQuery, GetPaymentProvidersQueryVariables>;
export const CreatePaymentDocument = new TypedDocumentString(`
    mutation CreatePayment($contractId: ID!, $providerId: ID!, $cardId: ID, $amount: Float!) {
  createPayment(
    contractId: $contractId
    providerId: $providerId
    cardId: $cardId
    amount: $amount
  ) {
    id
    error
    ... on InvoicePaymentResponse {
      url
      number
    }
    ... on OnlinePaymentResponse {
      url
      auto
    }
    ... on SberInvoicePaymentResponse {
      url
    }
  }
}
    `) as unknown as TypedDocumentString<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const GetMonthlyReportLinkDocument = new TypedDocumentString(`
    query getMonthlyReportLink($id: ID!, $month: String!) {
  cabinet {
    company(id: $id) {
      monthlyReportLink(month: $month)
    }
  }
}
    `) as unknown as TypedDocumentString<GetMonthlyReportLinkQuery, GetMonthlyReportLinkQueryVariables>;
export const StationsGetStationPageDocument = new TypedDocumentString(`
    query stationsGetStationPage($companyId: ID, $contractId: ID, $stationId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      id
      name
      station(id: $stationId) {
        name
        status
        address
        isActive
        integration {
          login
          password
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationPageQuery, StationsGetStationPageQueryVariables>;
export const AdminGetStationPageDocument = new TypedDocumentString(`
    query adminGetStationPage($companyId: ID, $contractId: ID, $stationId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      id
      name
      station(id: $stationId) {
        name
        status
        address
        isActive
        lastOnline
        integration {
          login
          password
        }
      }
      ... on AzsCompany {
        stationPartner {
          system {
            isPing
          }
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          payment {
            type
            source
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetStationPageQuery, AdminGetStationPageQueryVariables>;
export const GetStationDataDocument = new TypedDocumentString(`
    query getStationData($companyId: ID!, $stationId: ID!) {
  cabinet {
    company(id: $companyId) {
      station(id: $stationId) {
        id
        name
        promo
        address
        color
        point
        groupId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationDataQuery, GetStationDataQueryVariables>;
export const StationsRefreshStationPageDocument = new TypedDocumentString(`
    query stationsRefreshStationPage($companyId: ID, $stationId: ID!) {
  cabinet {
    company(id: $companyId) {
      id
      name
      station(id: $stationId) {
        name
        status
        address
        isActive
        integration {
          login
          password
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsRefreshStationPageQuery, StationsRefreshStationPageQueryVariables>;
export const StationsGetStationOrdersDocument = new TypedDocumentString(`
    query stationsGetStationOrders($companyId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
          }
          station {
            name
            address
          }
          payment {
            type
            source
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationOrdersQuery, StationsGetStationOrdersQueryVariables>;
export const StationsGetStationCoordsDocument = new TypedDocumentString(`
    query stationsGetStationCoords($stationId: ID!) {
  station(id: $stationId) {
    name
    point
    address
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationCoordsQuery, StationsGetStationCoordsQueryVariables>;
export const StationsGetStationPricesDocument = new TypedDocumentString(`
    query stationsGetStationPrices($stationId: ID!) {
  station(id: $stationId) {
    prices {
      fuel {
        shortName
      }
      pumps
      price
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationPricesQuery, StationsGetStationPricesQueryVariables>;
export const StationsGetStationPricesDiscountsDocument = new TypedDocumentString(`
    query stationsGetStationPricesDiscounts($companyId: ID!, $stationId: ID!) {
  cabinet {
    company(id: $companyId) {
      station(id: $stationId) {
        prices {
          fuel {
            id
            shortName
          }
          pumps
          price
        }
        stationFuelDiscounts {
          id
          fuel
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationPricesDiscountsQuery, StationsGetStationPricesDiscountsQueryVariables>;
export const SetStationDiscountPriceDocument = new TypedDocumentString(`
    mutation setStationDiscountPrice($discountId: ID, $stationId: ID!, $fuelId: ID, $discount: Float!) {
  setStationFuelDiscount(
    discountId: $discountId
    stationId: $stationId
    fuelId: $fuelId
    discount: $discount
  )
}
    `) as unknown as TypedDocumentString<SetStationDiscountPriceMutation, SetStationDiscountPriceMutationVariables>;
export const AddCompanyStationDocument = new TypedDocumentString(`
    mutation AddCompanyStation($companyId: ID!, $data: NewStationData!) {
  addStation(companyId: $companyId, stationData: $data) {
    result
    message
  }
}
    `) as unknown as TypedDocumentString<AddCompanyStationMutation, AddCompanyStationMutationVariables>;
export const EditCompanyStationDocument = new TypedDocumentString(`
    mutation EditCompanyStation($stationId: ID!, $data: EditStationData!) {
  editStation(stationId: $stationId, stationData: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<EditCompanyStationMutation, EditCompanyStationMutationVariables>;
export const BulkEditCompanyStationsDocument = new TypedDocumentString(`
    mutation BulkEditCompanyStations($companyId: ID!, $data: BulkEditStationsData!) {
  bulkEditStations(companyId: $companyId, stationsData: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<BulkEditCompanyStationsMutation, BulkEditCompanyStationsMutationVariables>;
export const GetStationCompanyIdDocument = new TypedDocumentString(`
    query getStationCompanyId($stationId: ID!) {
  station(id: $stationId) {
    organizationId
  }
}
    `) as unknown as TypedDocumentString<GetStationCompanyIdQuery, GetStationCompanyIdQueryVariables>;
export const AddColorDocument = new TypedDocumentString(`
    mutation AddColor($name: String!, $color: String!) {
  addColor(name: $name, color: $color) {
    id
  }
}
    `) as unknown as TypedDocumentString<AddColorMutation, AddColorMutationVariables>;
export const DownloadStationsIntegrationsDocument = new TypedDocumentString(`
    query DownloadStationsIntegrations($companyId: ID) {
  cabinet {
    company(id: $companyId) {
      integrationsReportLink
    }
  }
}
    `) as unknown as TypedDocumentString<DownloadStationsIntegrationsQuery, DownloadStationsIntegrationsQueryVariables>;
export const GetOfflineStationPageDocument = new TypedDocumentString(`
    query GetOfflineStationPage($contractId: ID!, $stationId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(contractId: $contractId) {
      station(id: $stationId) {
        name
        address
        integration {
          login
          password
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          station {
            address
          }
          status
          statusMessage
          ... on OfflineOrder {
            owner {
              name
              shortName
            }
            cardNumber
            items {
              id
              type
              quantity
              groupName
              shortName
              prices {
                corp
                fact
                user
                station
              }
              cost {
                corp
                fact
                user
                station
              }
            }
          }
        }
        summary {
          name
          count
          quantity
          total
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineStationPageQuery, GetOfflineStationPageQueryVariables>;
export const StationsFetchStationsListDocument = new TypedDocumentString(`
    query StationsFetchStationsList($size: Int!, $offset: Int!, $query: String) {
  stationsByES(size: $size, offset: $offset, query: $query) {
    count
    items {
      id
      name
      address
    }
  }
}
    `) as unknown as TypedDocumentString<StationsFetchStationsListQuery, StationsFetchStationsListQueryVariables>;
export const StationsGetStationsPageDocument = new TypedDocumentString(`
    query StationsGetStationsPage($companyId: ID!, $stationId: ID!, $filter: OrdersQueryParams!) {
  station(id: $stationId) {
    name
    address
  }
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        summary {
          name
          count
          total
          discount
          quantity
        }
        items {
          id
          date
          status
          statusMessage
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationsPageQuery, StationsGetStationsPageQueryVariables>;
export const StationsUpdateStationInfoAndTransactionsDocument = new TypedDocumentString(`
    query StationsUpdateStationInfoAndTransactions($companyId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        summary {
          name
          count
          total
          discount
          quantity
        }
        items {
          id
          date
          status
          statusMessage
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsUpdateStationInfoAndTransactionsQuery, StationsUpdateStationInfoAndTransactionsQueryVariables>;
export const StationsAddAsuDocument = new TypedDocumentString(`
    mutation stationsAddAsu($data: NewStationSystemData!) {
  addStationSystem(data: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<StationsAddAsuMutation, StationsAddAsuMutationVariables>;
export const StationsFetchStationIntegrationTabDocument = new TypedDocumentString(`
    query StationsFetchStationIntegrationTab($id: ID) {
  cabinet {
    company(id: $id) {
      ... on AzsCompany {
        stationPartner {
          id
          name
          outgoing
          apiType
          apiKey
          system {
            id
            name
            protocol
            isPing
          }
        }
        stationPartnerFuels {
          partnerFuelId
          fuelId
          name
          ename
        }
      }
    }
    serverAsu
  }
  systems {
    id
    name
    protocol
    isPing
  }
  fuel {
    id
    name
    description
  }
}
    `) as unknown as TypedDocumentString<StationsFetchStationIntegrationTabQuery, StationsFetchStationIntegrationTabQueryVariables>;
export const StationsSaveStationIntegrationDocument = new TypedDocumentString(`
    mutation StationsSaveStationIntegration($companyId: ID!, $companyData: CompanyData!, $stationData: StationSystemData!) {
  editStationSystem(data: $stationData) {
    id
  }
  saveCompany(companyId: $companyId, data: $companyData) {
    result
    message
  }
}
    `) as unknown as TypedDocumentString<StationsSaveStationIntegrationMutation, StationsSaveStationIntegrationMutationVariables>;
export const StationsUpdatePartnerStationsDocument = new TypedDocumentString(`
    mutation StationsUpdatePartnerStations($companyId: ID!) {
  updatePartnerStations(companyId: $companyId)
}
    `) as unknown as TypedDocumentString<StationsUpdatePartnerStationsMutation, StationsUpdatePartnerStationsMutationVariables>;
export const StationsIndexStationsDocument = new TypedDocumentString(`
    mutation StationsIndexStations($stationId: ID) {
  indexStations(id: $stationId)
}
    `) as unknown as TypedDocumentString<StationsIndexStationsMutation, StationsIndexStationsMutationVariables>;
export const GetAzsCompanyStationsDocument = new TypedDocumentString(`
    query GetAzsCompanyStations($companyId: ID!, $contractsType: String!, $page: Int, $size: Int, $query: String, $status: StationStatus) {
  cabinet {
    company(id: $companyId) {
      stations(
        contractsType: $contractsType
        page: $page
        size: $size
        query: $query
        status: $status
      ) {
        count
        items {
          id
          name
          address
          lastOnline
          status
        }
        status {
          status
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAzsCompanyStationsQuery, GetAzsCompanyStationsQueryVariables>;
export const GetCompanyStationsForStationsGroupDocument = new TypedDocumentString(`
    query getCompanyStationsForStationsGroup($companyId: ID!, $page: Int, $size: Int, $query: String) {
  cabinet {
    company(id: $companyId) {
      stations(page: $page, size: $size, query: $query) {
        items {
          id
          name
          nameApi
          address
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyStationsForStationsGroupQuery, GetCompanyStationsForStationsGroupQueryVariables>;
export const AddStationsToStationsGroupDocument = new TypedDocumentString(`
    mutation addStationsToStationsGroup($groupId: ID!, $stationsIds: [String!], $companyId: ID, $query: String) {
  addStationsToStationsGroup(
    groupId: $groupId
    stationsIds: $stationsIds
    companyId: $companyId
    query: $query
  )
}
    `) as unknown as TypedDocumentString<AddStationsToStationsGroupMutation, AddStationsToStationsGroupMutationVariables>;
export const StationsGetCompanyStationsDocument = new TypedDocumentString(`
    query stationsGetCompanyStations($companyId: ID!, $query: String) {
  cabinet {
    company(id: $companyId) {
      stations(query: $query) {
        items {
          id
          name
          address
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetCompanyStationsQuery, StationsGetCompanyStationsQueryVariables>;
export const StationsGetStationsDocument = new TypedDocumentString(`
    query stationsGetStations {
  stationsByES(size: 10000) {
    items {
      id
      name
      address
      point
      prices {
        fuel {
          code
        }
        price
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationsQuery, StationsGetStationsQueryVariables>;
export const StationsGetMapStationsDocument = new TypedDocumentString(`
    query stationsGetMapStations {
  stationsByES(size: 10000) {
    items {
      id
      point
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetMapStationsQuery, StationsGetMapStationsQueryVariables>;
export const StationsGetMapStationDocument = new TypedDocumentString(`
    query stationsGetMapStation($id: ID!) {
  station(id: $id) {
    name
    address
    prices {
      fuel {
        code
      }
      price
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetMapStationQuery, StationsGetMapStationQueryVariables>;
export const StationsSetStationStateDocument = new TypedDocumentString(`
    mutation stationsSetStationState($id: ID!, $state: StationState!, $commentary: String!) {
  setStationState(id: $id, state: $state, commentary: $commentary)
}
    `) as unknown as TypedDocumentString<StationsSetStationStateMutation, StationsSetStationStateMutationVariables>;
export const StationsBulkSetStationStateDocument = new TypedDocumentString(`
    mutation stationsBulkSetStationState($companyId: ID!, $query: String, $status: StationStatus, $region: String, $commentary: String!, $oldState: [StationState!]!, $newState: StationState!, $groupId: ID) {
  bulkSetStationsState(
    companyId: $companyId
    query: $query
    status: $status
    region: $region
    oldState: $oldState
    newState: $newState
    commentary: $commentary
    groupId: $groupId
  )
}
    `) as unknown as TypedDocumentString<StationsBulkSetStationStateMutation, StationsBulkSetStationStateMutationVariables>;
export const BulkSetStationsStateByGroupIdDocument = new TypedDocumentString(`
    mutation bulkSetStationsStateByGroupId($groupId: ID!, $state: StationState!, $commentary: String!) {
  bulkSetStationsStateByGroupId(
    groupId: $groupId
    state: $state
    commentary: $commentary
  )
}
    `) as unknown as TypedDocumentString<BulkSetStationsStateByGroupIdMutation, BulkSetStationsStateByGroupIdMutationVariables>;
export const StationsStateLogsGroupsDocument = new TypedDocumentString(`
    query stationsStateLogsGroups($companyId: ID!, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      stationsStateLogsGroups(filter: {page: $page, size: $size}) {
        items {
          id
          date
          state
          email
          commentary
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsStateLogsGroupsQuery, StationsStateLogsGroupsQueryVariables>;
export const StationsGetStationStateLogsDocument = new TypedDocumentString(`
    query stationsGetStationStateLogs($companyId: ID!, $stationId: ID!, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      station(id: $stationId) {
        stateLogs(filter: {page: $page, size: $size}) {
          items {
            date
            user
            state
            commentary
          }
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationStateLogsQuery, StationsGetStationStateLogsQueryVariables>;
export const CopyStationsDocument = new TypedDocumentString(`
    mutation copyStations($companyId: ID!, $ids: [ID!]!) {
  copyStations(ids: $ids, companyId: $companyId)
}
    `) as unknown as TypedDocumentString<CopyStationsMutation, CopyStationsMutationVariables>;
export const GetUpdatedStationsDocument = new TypedDocumentString(`
    query getUpdatedStations($id: ID!, $filter: QueryParams!) {
  cabinet {
    company(id: $id) {
      updatedStations(filter: $filter) {
        count
        items {
          id
          name
          nameApi
          address
          addressApi
          organizationName
          lng
          lngApi
          lat
          latApi
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetUpdatedStationsQuery, GetUpdatedStationsQueryVariables>;
export const GetStationDataToEditDocument = new TypedDocumentString(`
    query getStationDataToEdit($stationId: ID!) {
  station(id: $stationId) {
    name
    brand
    address
    promo
    color
    point
    groupId
    mode {
      type
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationDataToEditQuery, GetStationDataToEditQueryVariables>;
export const GetInternalOrdersDocument = new TypedDocumentString(`
    query getInternalOrders($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          hasOnlineOrder
          hasOfflineOrder
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
            email
            maskedPan
          }
          corp {
            company {
              name
            }
            driver {
              name
              phone
            }
            car {
              number
            }
            waybill {
              number
            }
          }
          station {
            name
            address
          }
          sberSpasiboDetails {
            subId
            costPromotion
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
          ... on OfflineOrder {
            cardNumber
            bankProduct
            items {
              id
              type
              pump
              name
              quantityReq
              quantityReport
              groupName
              shortName
              prices {
                corp
                fact
                user
                station
              }
              cost {
                corp
                fact
                user
                station
              }
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetInternalOrdersQuery, GetInternalOrdersQueryVariables>;
export const GetInternalOrderDocument = new TypedDocumentString(`
    query getInternalOrder($companyId: ID!, $orderId: ID!) {
  cabinet {
    company(id: $companyId) {
      orderNew(id: $orderId) {
        id
        date
        finished
        type
        hasOnlineOrder
        hasOfflineOrder
        payment {
          id
          type
          source
          rrn
          merchantName
          email
          maskedPan
        }
        station {
          id
          name
          mode {
            type
          }
          address
          contractId
          organizationId
        }
        corp {
          company {
            id
            name
          }
          driver {
            id
            name
            phone
            partnerId
          }
          car {
            id
            number
          }
          waybill {
            number
            validSince
            validTo
            limit
          }
        }
        user {
          id
          phone
        }
        sberId
        sberSpasiboDetails {
          oid
          subId
          status
          debit
          credit
          refund
          costPromotion
        }
        ... on OnlineOrder {
          stationOrderId
          bankReserveId
          item {
            pump
            fuel {
              name
            }
            quantityReq
            quantityReport
            costReport {
              corp
              fact
              user
              station
            }
            prices {
              corp
              fact
              user
              station
            }
            costReq {
              corp
              fact
              user
              station
            }
            refund {
              corp
              fact
              user
              station
              quantity
            }
          }
        }
        ... on OfflineOrder {
          items {
            id
            type
            pump
            name
            groupName
            shortName
          }
        }
      }
      orderDetails(id: $orderId) {
        time
        params
        details
        status
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetInternalOrderQuery, GetInternalOrderQueryVariables>;
export const SupportFetchDriversTabDocument = new TypedDocumentString(`
    query SupportFetchDriversTab($companyId: ID!, $status: DriverStatus, $query: String, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      drivers(status: $status, query: $query, page: $page, size: $size) {
        activeCount
        totalCount
        items {
          id
          created
          name
          phone
          partnerId
          partnerName
          partnerParentName
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportFetchDriversTabQuery, SupportFetchDriversTabQueryVariables>;
export const SupportRefetchDriversTabDocument = new TypedDocumentString(`
    query SupportRefetchDriversTab($companyId: ID!, $status: DriverStatus, $query: String, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      drivers(status: $status, query: $query, page: $page, size: $size) {
        items {
          id
          created
          name
          phone
          partnerId
          partnerName
          partnerParentName
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportRefetchDriversTabQuery, SupportRefetchDriversTabQueryVariables>;
export const SupportFetchUsersTabDocument = new TypedDocumentString(`
    query SupportFetchUsersTab($companyId: ID!, $query: String, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      apiUsers(query: $query, page: $page, size: $size) {
        count
        items {
          phone
          ... on ApiUser {
            hasSberLoyalty
            registered
            email
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportFetchUsersTabQuery, SupportFetchUsersTabQueryVariables>;
export const SupportRefetchUsersTabDocument = new TypedDocumentString(`
    query SupportRefetchUsersTab($companyId: ID!, $query: String, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      apiUsers(query: $query, page: $page, size: $size) {
        items {
          phone
          ... on ApiUser {
            hasSberLoyalty
            registered
            email
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportRefetchUsersTabQuery, SupportRefetchUsersTabQueryVariables>;
export const SupportFetchUserPageDocument = new TypedDocumentString(`
    query SupportFetchUserPage($companyId: ID!, $phone: String!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      type
      apiUser(phone: $phone) {
        id
        email
        registered
        version {
          os
          osVersion
          appType
          appVersion
        }
        sberLoyaltyBalance
        lastActivity
        drivers {
          id
          companyId
          companyName
          companyReportType
          partnerId
          partnerName
          limitsAndExpenses {
            limitsType
            balance
            blocked
            day
            week
            month
            dayExpenses
            weekExpenses
            monthExpenses
            isQuantity
            fuels
            regions
          }
          car {
            id
            number
          }
          isActive
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          corp {
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportFetchUserPageQuery, SupportFetchUserPageQueryVariables>;
export const SupportGetUserOrdersDocument = new TypedDocumentString(`
    query supportGetUserOrders($companyId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          corp {
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGetUserOrdersQuery, SupportGetUserOrdersQueryVariables>;
export const GetMonitoringTabDocument = new TypedDocumentString(`
    query getMonitoringTab($status: StationStatus, $query: String, $offset: Int, $size: Int, $state: [StationState!], $sort: StationsSort, $sortDir: SortDirection) {
  stationsByES(
    point: [0, 0]
    status: $status
    query: $query
    state: $state
    offset: $offset
    size: $size
    sort: $sort
    sortDir: $sortDir
  ) {
    count
    status {
      status
      count
    }
    items {
      id
      name
      address
      lastOnline
      organizationName
      organizationId
      stationName
      state
      status
      stateDetails {
        date
        email
        commentary
      }
      acs
    }
  }
}
    `) as unknown as TypedDocumentString<GetMonitoringTabQuery, GetMonitoringTabQueryVariables>;
export const SupportRequestUserRestorePasswordEmailDocument = new TypedDocumentString(`
    mutation SupportRequestUserRestorePasswordEmail($companyId: ID!, $userId: ID!) {
  result: sendRestoreUserPasswordEmail(companyId: $companyId, id: $userId)
}
    `) as unknown as TypedDocumentString<SupportRequestUserRestorePasswordEmailMutation, SupportRequestUserRestorePasswordEmailMutationVariables>;
export const SupportDismissOrderDocument = new TypedDocumentString(`
    mutation supportDismissOrder($orderId: ID!, $volume: Float!, $commentary: String!, $partial: Boolean) {
  dismissOrder(
    id: $orderId
    volume: $volume
    commentary: $commentary
    partial: $partial
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportDismissOrderMutation, SupportDismissOrderMutationVariables>;
export const SupportDismissOrderToIncomeDocument = new TypedDocumentString(`
    mutation supportDismissOrderToIncome($orderId: ID!, $volume: Float!, $commentary: String!) {
  dismissOrderToIncome(id: $orderId, volume: $volume, commentary: $commentary) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportDismissOrderToIncomeMutation, SupportDismissOrderToIncomeMutationVariables>;
export const SupportRefundOrderDocument = new TypedDocumentString(`
    mutation supportRefundOrder($orderId: ID!, $volume: Float!, $commentary: String!) {
  refundOrder(id: $orderId, volume: $volume, commentary: $commentary) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportRefundOrderMutation, SupportRefundOrderMutationVariables>;
export const SupportUndoLossDocument = new TypedDocumentString(`
    mutation supportUndoLoss($orderId: ID!, $companyId: ID!, $commentary: String!) {
  undoLoss(id: $orderId, companyId: $companyId, commentary: $commentary) {
    id
    status
    message
  }
}
    `) as unknown as TypedDocumentString<SupportUndoLossMutation, SupportUndoLossMutationVariables>;
export const SupportCancelOrderDocument = new TypedDocumentString(`
    mutation SupportCancelOrder($orderId: ID!, $commentary: String!) {
  cancelOrder(id: $orderId, commentary: $commentary) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportCancelOrderMutation, SupportCancelOrderMutationVariables>;
export const SupportCloseOrderDocument = new TypedDocumentString(`
    mutation SupportCloseOrder($orderId: ID!, $volume: Float!, $commentary: String!) {
  closeOrder(id: $orderId, volume: $volume, commentary: $commentary) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportCloseOrderMutation, SupportCloseOrderMutationVariables>;
export const SupportGetScriptsDocument = new TypedDocumentString(`
    query supportGetScripts {
  scripts {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<SupportGetScriptsQuery, SupportGetScriptsQueryVariables>;
export const SupportGetScriptByIdDocument = new TypedDocumentString(`
    query supportGetScriptById($id: Int!) {
  script(id: $id) {
    name
    args
    entry
    preview
  }
}
    `) as unknown as TypedDocumentString<SupportGetScriptByIdQuery, SupportGetScriptByIdQueryVariables>;
export const SupportCreateScriptRunDocument = new TypedDocumentString(`
    mutation supportCreateScriptRun($id: Int!, $params: String!) {
  createScriptRun(id: $id, params: $params) {
    status
    data
  }
}
    `) as unknown as TypedDocumentString<SupportCreateScriptRunMutation, SupportCreateScriptRunMutationVariables>;
export const SupportPreviewScriptRunDocument = new TypedDocumentString(`
    mutation supportPreviewScriptRun($id: Int!, $params: String!) {
  previewScriptRun(id: $id, params: $params)
}
    `) as unknown as TypedDocumentString<SupportPreviewScriptRunMutation, SupportPreviewScriptRunMutationVariables>;
export const SupportExecuteScriptRunDocument = new TypedDocumentString(`
    mutation supportExecuteScriptRun($id: Int!) {
  executeScriptRun(id: $id) {
    status
    data
  }
}
    `) as unknown as TypedDocumentString<SupportExecuteScriptRunMutation, SupportExecuteScriptRunMutationVariables>;
export const SupportGetRunsDocument = new TypedDocumentString(`
    query supportGetRuns($page: Int, $size: Int) {
  runs(page: $page, size: $size) {
    count
    items {
      id
      date
      script {
        name
      }
      state
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGetRunsQuery, SupportGetRunsQueryVariables>;
export const SupportGetRunDocument = new TypedDocumentString(`
    query supportGetRun($id: Int!) {
  run(id: $id) {
    id
    date
    script {
      id
      name
      args
      preview
    }
    state
    params
    user {
      ... on LKUser {
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGetRunQuery, SupportGetRunQueryVariables>;
export const SupportGetCompanyNameByContractIdDocument = new TypedDocumentString(`
    query supportGetCompanyNameByContractId($id: ID!) {
  cabinet {
    company(contractId: $id) {
      contract {
        number
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGetCompanyNameByContractIdQuery, SupportGetCompanyNameByContractIdQueryVariables>;
export const RefundSpasiboBonusesDocument = new TypedDocumentString(`
    mutation RefundSpasiboBonuses($id: String!, $orderId: ID!) {
  result: cancelSberLoyaltyReceipt(id: $id, orderId: $orderId)
}
    `) as unknown as TypedDocumentString<RefundSpasiboBonusesMutation, RefundSpasiboBonusesMutationVariables>;
export const CheckContractPaymentsDocument = new TypedDocumentString(`
    mutation checkContractPayments($contractId: ID!) {
  checkContractPayments(contractId: $contractId) {
    completed
    amount
  }
}
    `) as unknown as TypedDocumentString<CheckContractPaymentsMutation, CheckContractPaymentsMutationVariables>;
export const PutCardsFirmReferenceDocument = new TypedDocumentString(`
    mutation putCardsFirmReference($companyId: ID!) {
  putCardsFirmReference(companyId: $companyId)
}
    `) as unknown as TypedDocumentString<PutCardsFirmReferenceMutation, PutCardsFirmReferenceMutationVariables>;
export const UnlinkUserSberIdDocument = new TypedDocumentString(`
    mutation unlinkUserSberId($userId: ID!) {
  unlinkUserSberId(userId: $userId)
}
    `) as unknown as TypedDocumentString<UnlinkUserSberIdMutation, UnlinkUserSberIdMutationVariables>;
export const GetWaybillsDocument = new TypedDocumentString(`
    query getWaybills($companyId: ID, $partnerId: ID, $page: Int, $size: Int, $query: String, $state: String, $dateFrom: DateTime, $dateTo: DateTime) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      waybills(
        page: $page
        size: $size
        dateFrom: $dateFrom
        dateTo: $dateTo
        state: $state
        query: $query
      ) {
        items {
          id
          number
          validSince
          validTo
          allowedFuels
          limit
          limitQuantity
          state
          createdAt
          car {
            number
          }
          partner {
            name
          }
          riders(size: 3) {
            items {
              name
              phone
            }
            count
          }
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetWaybillsQuery, GetWaybillsQueryVariables>;
export const GetWaybillDocument = new TypedDocumentString(`
    query getWaybill($companyId: ID, $partnerId: ID, $waybillId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      waybill(id: $waybillId) {
        id
        number
        validSince
        validTo
        limit
        limitQuantity
        state
        createdAt
        car {
          number
        }
        partner {
          name
        }
        riders(size: 10) {
          items {
            name
            phone
            isBlocked
          }
          count
        }
      }
      ordersNew(filter: $filter) {
        count
        summary {
          name
          quantity
          total
          discount
        }
        items {
          id
          date
          status
          statusMessage
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetWaybillQuery, GetWaybillQueryVariables>;
export const GetWaybillRidersDocument = new TypedDocumentString(`
    query GetWaybillRiders($companyId: ID, $partnerId: ID, $waybillId: ID!, $page: Int, $size: Int) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      waybill(id: $waybillId) {
        riders(page: $page, size: $size) {
          items {
            name
            phone
            isBlocked
          }
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetWaybillRidersQuery, GetWaybillRidersQueryVariables>;